require("core-js/modules/esnext.global-this.js");
require("core-js/modules/esnext.aggregate-error.js");
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("@babel/runtime/helpers/slicedToArray"), require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/typeof"), require("@babel/runtime/helpers/toConsumableArray")) : "function" == typeof define && define.amd ? define(["@babel/runtime/helpers/slicedToArray", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/regenerator", "@babel/runtime/helpers/typeof", "@babel/runtime/helpers/toConsumableArray"], e) : (t = "undefined" != typeof globalThis ? globalThis : t || self)["swell-js"] = e(t._slicedToArray, t._defineProperty$1, t._asyncToGenerator, t._regeneratorRuntime, t._typeof, t._toConsumableArray);
}(this, function (t, e, r, n, o, a) {
  "use strict";

  function i(t) {
    return t && "object" == typeof t && "default" in t ? t : {
      default: t
    };
  }
  var u = i(t),
    c = i(e),
    s = i(r),
    f = i(n),
    l = i(o),
    p = i(a);
  function d(t) {
    var e = t.default;
    if ("function" == typeof e) {
      var r = function r() {
        return e.apply(this, arguments);
      };
      r.prototype = e.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.keys(t).forEach(function (e) {
      var n = Object.getOwnPropertyDescriptor(t, e);
      Object.defineProperty(r, e, n.get ? n : {
        enumerable: !0,
        get: function get() {
          return t[e];
        }
      });
    }), r;
  }
  var h,
    y = "undefined" != typeof Symbol && Symbol,
    g = function g() {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" === l.default(Symbol.iterator)) return !0;
      var t = {},
        e = Symbol("test"),
        r = Object(e);
      if ("string" == typeof e) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
      for (e in t[e] = 42, t) {
        return !1;
      }
      if ("function" == typeof Object.keys && 0 !== Object.keys(t).length) return !1;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
      var n = Object.getOwnPropertySymbols(t);
      if (1 !== n.length || n[0] !== e) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var o = Object.getOwnPropertyDescriptor(t, e);
        if (42 !== o.value || !0 !== o.enumerable) return !1;
      }
      return !0;
    },
    b = "Function.prototype.bind called on incompatible ",
    m = Array.prototype.slice,
    w = Object.prototype.toString,
    j = "[object Function]",
    x = function x(t) {
      var e = this;
      if ("function" != typeof e || w.call(e) !== j) throw new TypeError(b + e);
      for (var r, n = m.call(arguments, 1), o = function o() {
          if (this instanceof r) {
            var o = e.apply(this, n.concat(m.call(arguments)));
            return Object(o) === o ? o : this;
          }
          return e.apply(t, n.concat(m.call(arguments)));
        }, a = Math.max(0, e.length - n.length), i = [], u = 0; u < a; u++) {
        i.push("$" + u);
      }
      if (r = Function("binder", "return function (" + i.join(",") + "){ return binder.apply(this,arguments); }")(o), e.prototype) {
        var c = function c() {};
        c.prototype = e.prototype, r.prototype = new c(), c.prototype = null;
      }
      return r;
    },
    O = Function.prototype.bind || x,
    _ = O.call(Function.call, Object.prototype.hasOwnProperty),
    S = SyntaxError,
    A = Function,
    k = TypeError,
    E = function E(t) {
      try {
        return A('"use strict"; return (' + t + ").constructor;")();
      } catch (t) {}
    },
    P = Object.getOwnPropertyDescriptor;
  if (P) try {
    P({}, "");
  } catch (t) {
    P = null;
  }
  var C = function C() {
      throw new k();
    },
    R = P ? function () {
      try {
        return C;
      } catch (t) {
        try {
          return P(arguments, "callee").get;
        } catch (t) {
          return C;
        }
      }
    }() : C,
    I = "function" == typeof y && "function" == typeof Symbol && "symbol" === l.default(y("foo")) && "symbol" === l.default(Symbol("bar")) && g(),
    U = Object.getPrototypeOf || function (t) {
      return t.__proto__;
    },
    D = {},
    T = "undefined" == typeof Uint8Array ? h : U(Uint8Array),
    M = {
      "%AggregateError%": "undefined" == typeof AggregateError ? h : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? h : ArrayBuffer,
      "%ArrayIteratorPrototype%": I ? U([][Symbol.iterator]()) : h,
      "%AsyncFromSyncIteratorPrototype%": h,
      "%AsyncFunction%": D,
      "%AsyncGenerator%": D,
      "%AsyncGeneratorFunction%": D,
      "%AsyncIteratorPrototype%": D,
      "%Atomics%": "undefined" == typeof Atomics ? h : Atomics,
      "%BigInt%": "undefined" == typeof BigInt ? h : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": "undefined" == typeof DataView ? h : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": "undefined" == typeof Float32Array ? h : Float32Array,
      "%Float64Array%": "undefined" == typeof Float64Array ? h : Float64Array,
      "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? h : FinalizationRegistry,
      "%Function%": A,
      "%GeneratorFunction%": D,
      "%Int8Array%": "undefined" == typeof Int8Array ? h : Int8Array,
      "%Int16Array%": "undefined" == typeof Int16Array ? h : Int16Array,
      "%Int32Array%": "undefined" == typeof Int32Array ? h : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": I ? U(U([][Symbol.iterator]())) : h,
      "%JSON%": "object" === ("undefined" == typeof JSON ? "undefined" : l.default(JSON)) ? JSON : h,
      "%Map%": "undefined" == typeof Map ? h : Map,
      "%MapIteratorPrototype%": "undefined" != typeof Map && I ? U(new Map()[Symbol.iterator]()) : h,
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": "undefined" == typeof Promise ? h : Promise,
      "%Proxy%": "undefined" == typeof Proxy ? h : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": "undefined" == typeof Reflect ? h : Reflect,
      "%RegExp%": RegExp,
      "%Set%": "undefined" == typeof Set ? h : Set,
      "%SetIteratorPrototype%": "undefined" != typeof Set && I ? U(new Set()[Symbol.iterator]()) : h,
      "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? h : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": I ? U(""[Symbol.iterator]()) : h,
      "%Symbol%": I ? Symbol : h,
      "%SyntaxError%": S,
      "%ThrowTypeError%": R,
      "%TypedArray%": T,
      "%TypeError%": k,
      "%Uint8Array%": "undefined" == typeof Uint8Array ? h : Uint8Array,
      "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? h : Uint8ClampedArray,
      "%Uint16Array%": "undefined" == typeof Uint16Array ? h : Uint16Array,
      "%Uint32Array%": "undefined" == typeof Uint32Array ? h : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": "undefined" == typeof WeakMap ? h : WeakMap,
      "%WeakRef%": "undefined" == typeof WeakRef ? h : WeakRef,
      "%WeakSet%": "undefined" == typeof WeakSet ? h : WeakSet
    },
    N = function t(e) {
      var r;
      if ("%AsyncFunction%" === e) r = E("async function () {}");else if ("%GeneratorFunction%" === e) r = E("function* () {}");else if ("%AsyncGeneratorFunction%" === e) r = E("async function* () {}");else if ("%AsyncGenerator%" === e) {
        var n = t("%AsyncGeneratorFunction%");
        n && (r = n.prototype);
      } else if ("%AsyncIteratorPrototype%" === e) {
        var o = t("%AsyncGenerator%");
        o && (r = U(o.prototype));
      }
      return M[e] = r, r;
    },
    z = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    },
    L = O,
    F = _,
    B = L.call(Function.call, Array.prototype.concat),
    q = L.call(Function.apply, Array.prototype.splice),
    $ = L.call(Function.call, String.prototype.replace),
    Y = L.call(Function.call, String.prototype.slice),
    G = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
    W = /\\(\\)?/g,
    J = function J(t) {
      var e = Y(t, 0, 1),
        r = Y(t, -1);
      if ("%" === e && "%" !== r) throw new S("invalid intrinsic syntax, expected closing `%`");
      if ("%" === r && "%" !== e) throw new S("invalid intrinsic syntax, expected opening `%`");
      var n = [];
      return $(t, G, function (t, e, r, o) {
        n[n.length] = r ? $(o, W, "$1") : e || t;
      }), n;
    },
    Z = function Z(t, e) {
      var r,
        n = t;
      if (F(z, n) && (n = "%" + (r = z[n])[0] + "%"), F(M, n)) {
        var o = M[n];
        if (o === D && (o = N(n)), void 0 === o && !e) throw new k("intrinsic " + t + " exists, but is not available. Please file an issue!");
        return {
          alias: r,
          name: n,
          value: o
        };
      }
      throw new S("intrinsic " + t + " does not exist!");
    },
    V = function V(t, e) {
      if ("string" != typeof t || 0 === t.length) throw new k("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof e) throw new k('"allowMissing" argument must be a boolean');
      var r = J(t),
        n = r.length > 0 ? r[0] : "",
        o = Z("%" + n + "%", e),
        a = o.name,
        i = o.value,
        u = !1,
        c = o.alias;
      c && (n = c[0], q(r, B([0, 1], c)));
      for (var s = 1, f = !0; s < r.length; s += 1) {
        var l = r[s],
          p = Y(l, 0, 1),
          d = Y(l, -1);
        if (('"' === p || "'" === p || "`" === p || '"' === d || "'" === d || "`" === d) && p !== d) throw new S("property names with quotes must have matching quotes");
        if ("constructor" !== l && f || (u = !0), F(M, a = "%" + (n += "." + l) + "%")) i = M[a];else if (null != i) {
          if (!(l in i)) {
            if (!e) throw new k("base intrinsic for " + t + " exists, but the property is not available.");
            return;
          }
          if (P && s + 1 >= r.length) {
            var h = P(i, l);
            i = (f = !!h) && "get" in h && !("originalValue" in h.get) ? h.get : i[l];
          } else f = F(i, l), i = i[l];
          f && !u && (M[a] = i);
        }
      }
      return i;
    },
    H = {
      exports: {}
    };
  !function (t) {
    var e = O,
      r = V,
      n = r("%Function.prototype.apply%"),
      o = r("%Function.prototype.call%"),
      a = r("%Reflect.apply%", !0) || e.call(o, n),
      i = r("%Object.getOwnPropertyDescriptor%", !0),
      u = r("%Object.defineProperty%", !0),
      c = r("%Math.max%");
    if (u) try {
      u({}, "a", {
        value: 1
      });
    } catch (t) {
      u = null;
    }
    t.exports = function (t) {
      var r = a(e, o, arguments);
      if (i && u) {
        var n = i(r, "length");
        n.configurable && u(r, "length", {
          value: 1 + c(0, t.length - (arguments.length - 1))
        });
      }
      return r;
    };
    var s = function s() {
      return a(e, n, arguments);
    };
    u ? u(t.exports, "apply", {
      value: s
    }) : t.exports.apply = s;
  }(H);
  var Q = V,
    X = H.exports,
    K = X(Q("String.prototype.indexOf")),
    tt = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {},
    et = [],
    rt = [],
    nt = "undefined" != typeof Uint8Array ? Uint8Array : Array,
    ot = !1;
  function at() {
    ot = !0;
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, r = t.length; e < r; ++e) {
      et[e] = t[e], rt[t.charCodeAt(e)] = e;
    }
    rt["-".charCodeAt(0)] = 62, rt["_".charCodeAt(0)] = 63;
  }
  function it(t, e, r) {
    for (var n, o, a = [], i = e; i < r; i += 3) {
      n = (t[i] << 16) + (t[i + 1] << 8) + t[i + 2], a.push(et[(o = n) >> 18 & 63] + et[o >> 12 & 63] + et[o >> 6 & 63] + et[63 & o]);
    }
    return a.join("");
  }
  function ut(t) {
    var e;
    ot || at();
    for (var r = t.length, n = r % 3, o = "", a = [], i = 16383, u = 0, c = r - n; u < c; u += i) {
      a.push(it(t, u, u + i > c ? c : u + i));
    }
    return 1 === n ? (e = t[r - 1], o += et[e >> 2], o += et[e << 4 & 63], o += "==") : 2 === n && (e = (t[r - 2] << 8) + t[r - 1], o += et[e >> 10], o += et[e >> 4 & 63], o += et[e << 2 & 63], o += "="), a.push(o), a.join("");
  }
  function ct(t, e, r, n, o) {
    var a,
      i,
      u = 8 * o - n - 1,
      c = (1 << u) - 1,
      s = c >> 1,
      f = -7,
      l = r ? o - 1 : 0,
      p = r ? -1 : 1,
      d = t[e + l];
    for (l += p, a = d & (1 << -f) - 1, d >>= -f, f += u; f > 0; a = 256 * a + t[e + l], l += p, f -= 8) {
      ;
    }
    for (i = a & (1 << -f) - 1, a >>= -f, f += n; f > 0; i = 256 * i + t[e + l], l += p, f -= 8) {
      ;
    }
    if (0 === a) a = 1 - s;else {
      if (a === c) return i ? NaN : 1 / 0 * (d ? -1 : 1);
      i += Math.pow(2, n), a -= s;
    }
    return (d ? -1 : 1) * i * Math.pow(2, a - n);
  }
  function st(t, e, r, n, o, a) {
    var i,
      u,
      c,
      s = 8 * a - o - 1,
      f = (1 << s) - 1,
      l = f >> 1,
      p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      d = n ? 0 : a - 1,
      h = n ? 1 : -1,
      y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (u = isNaN(e) ? 1 : 0, i = f) : (i = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -i)) < 1 && (i--, c *= 2), (e += i + l >= 1 ? p / c : p * Math.pow(2, 1 - l)) * c >= 2 && (i++, c /= 2), i + l >= f ? (u = 0, i = f) : i + l >= 1 ? (u = (e * c - 1) * Math.pow(2, o), i += l) : (u = e * Math.pow(2, l - 1) * Math.pow(2, o), i = 0)); o >= 8; t[r + d] = 255 & u, d += h, u /= 256, o -= 8) {
      ;
    }
    for (i = i << o | u, s += o; s > 0; t[r + d] = 255 & i, d += h, i /= 256, s -= 8) {
      ;
    }
    t[r + d - h] |= 128 * y;
  }
  var ft = {}.toString,
    lt = Array.isArray || function (t) {
      return "[object Array]" == ft.call(t);
    };
  function pt() {
    return ht.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function dt(t, e) {
    if (pt() < e) throw new RangeError("Invalid typed array length");
    return ht.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = ht.prototype : (null === t && (t = new ht(e)), t.length = e), t;
  }
  function ht(t, e, r) {
    if (!(ht.TYPED_ARRAY_SUPPORT || this instanceof ht)) return new ht(t, e, r);
    if ("number" == typeof t) {
      if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
      return gt(this, t);
    }
    return yt(this, t, e, r);
  }
  function yt(t, e, r, n) {
    if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
      if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
      if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
      e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
      ht.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = ht.prototype : t = bt(t, e);
      return t;
    }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
      "string" == typeof r && "" !== r || (r = "utf8");
      if (!ht.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
      var n = 0 | jt(e, r),
        o = (t = dt(t, n)).write(e, r);
      o !== n && (t = t.slice(0, o));
      return t;
    }(t, e, r) : function (t, e) {
      if (wt(e)) {
        var r = 0 | mt(e.length);
        return 0 === (t = dt(t, r)).length || e.copy(t, 0, 0, r), t;
      }
      if (e) {
        if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? dt(t, 0) : bt(t, e);
        if ("Buffer" === e.type && lt(e.data)) return bt(t, e.data);
      }
      var n;
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(t, e);
  }
  function vt(t) {
    if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
    if (t < 0) throw new RangeError('"size" argument must not be negative');
  }
  function gt(t, e) {
    if (vt(e), t = dt(t, e < 0 ? 0 : 0 | mt(e)), !ht.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
      t[r] = 0;
    }
    return t;
  }
  function bt(t, e) {
    var r = e.length < 0 ? 0 : 0 | mt(e.length);
    t = dt(t, r);
    for (var n = 0; n < r; n += 1) {
      t[n] = 255 & e[n];
    }
    return t;
  }
  function mt(t) {
    if (t >= pt()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + pt().toString(16) + " bytes");
    return 0 | t;
  }
  function wt(t) {
    return !(null == t || !t._isBuffer);
  }
  function jt(t, e) {
    if (wt(t)) return t.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
    "string" != typeof t && (t = "" + t);
    var r = t.length;
    if (0 === r) return 0;
    for (var n = !1;;) {
      switch (e) {
        case "ascii":
        case "latin1":
        case "binary":
          return r;
        case "utf8":
        case "utf-8":
        case void 0:
          return Zt(t).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return 2 * r;
        case "hex":
          return r >>> 1;
        case "base64":
          return Vt(t).length;
        default:
          if (n) return Zt(t).length;
          e = ("" + e).toLowerCase(), n = !0;
      }
    }
  }
  function xt(t, e, r) {
    var n = !1;
    if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
    if ((r >>>= 0) <= (e >>>= 0)) return "";
    for (t || (t = "utf8");;) {
      switch (t) {
        case "hex":
          return Nt(this, e, r);
        case "utf8":
        case "utf-8":
          return Ut(this, e, r);
        case "ascii":
          return Tt(this, e, r);
        case "latin1":
        case "binary":
          return Mt(this, e, r);
        case "base64":
          return It(this, e, r);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return zt(this, e, r);
        default:
          if (n) throw new TypeError("Unknown encoding: " + t);
          t = (t + "").toLowerCase(), n = !0;
      }
    }
  }
  function Ot(t, e, r) {
    var n = t[e];
    t[e] = t[r], t[r] = n;
  }
  function _t(t, e, r, n, o) {
    if (0 === t.length) return -1;
    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
      if (o) return -1;
      r = t.length - 1;
    } else if (r < 0) {
      if (!o) return -1;
      r = 0;
    }
    if ("string" == typeof e && (e = ht.from(e, n)), wt(e)) return 0 === e.length ? -1 : St(t, e, r, n, o);
    if ("number" == typeof e) return e &= 255, ht.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : St(t, [e], r, n, o);
    throw new TypeError("val must be string, number or Buffer");
  }
  function St(t, e, r, n, o) {
    var a,
      i = 1,
      u = t.length,
      c = e.length;
    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
      if (t.length < 2 || e.length < 2) return -1;
      i = 2, u /= 2, c /= 2, r /= 2;
    }
    function s(t, e) {
      return 1 === i ? t[e] : t.readUInt16BE(e * i);
    }
    if (o) {
      var f = -1;
      for (a = r; a < u; a++) {
        if (s(t, a) === s(e, -1 === f ? 0 : a - f)) {
          if (-1 === f && (f = a), a - f + 1 === c) return f * i;
        } else -1 !== f && (a -= a - f), f = -1;
      }
    } else for (r + c > u && (r = u - c), a = r; a >= 0; a--) {
      for (var l = !0, p = 0; p < c; p++) {
        if (s(t, a + p) !== s(e, p)) {
          l = !1;
          break;
        }
      }
      if (l) return a;
    }
    return -1;
  }
  function At(t, e, r, n) {
    r = Number(r) || 0;
    var o = t.length - r;
    n ? (n = Number(n)) > o && (n = o) : n = o;
    var a = e.length;
    if (a % 2 != 0) throw new TypeError("Invalid hex string");
    n > a / 2 && (n = a / 2);
    for (var i = 0; i < n; ++i) {
      var u = parseInt(e.substr(2 * i, 2), 16);
      if (isNaN(u)) return i;
      t[r + i] = u;
    }
    return i;
  }
  function kt(t, e, r, n) {
    return Ht(Zt(e, t.length - r), t, r, n);
  }
  function Et(t, e, r, n) {
    return Ht(function (t) {
      for (var e = [], r = 0; r < t.length; ++r) {
        e.push(255 & t.charCodeAt(r));
      }
      return e;
    }(e), t, r, n);
  }
  function Pt(t, e, r, n) {
    return Et(t, e, r, n);
  }
  function Ct(t, e, r, n) {
    return Ht(Vt(e), t, r, n);
  }
  function Rt(t, e, r, n) {
    return Ht(function (t, e) {
      for (var r, n, o, a = [], i = 0; i < t.length && !((e -= 2) < 0); ++i) {
        n = (r = t.charCodeAt(i)) >> 8, o = r % 256, a.push(o), a.push(n);
      }
      return a;
    }(e, t.length - r), t, r, n);
  }
  function It(t, e, r) {
    return 0 === e && r === t.length ? ut(t) : ut(t.slice(e, r));
  }
  function Ut(t, e, r) {
    r = Math.min(t.length, r);
    for (var n = [], o = e; o < r;) {
      var a,
        i,
        u,
        c,
        s = t[o],
        f = null,
        l = s > 239 ? 4 : s > 223 ? 3 : s > 191 ? 2 : 1;
      if (o + l <= r) switch (l) {
        case 1:
          s < 128 && (f = s);
          break;
        case 2:
          128 == (192 & (a = t[o + 1])) && (c = (31 & s) << 6 | 63 & a) > 127 && (f = c);
          break;
        case 3:
          a = t[o + 1], i = t[o + 2], 128 == (192 & a) && 128 == (192 & i) && (c = (15 & s) << 12 | (63 & a) << 6 | 63 & i) > 2047 && (c < 55296 || c > 57343) && (f = c);
          break;
        case 4:
          a = t[o + 1], i = t[o + 2], u = t[o + 3], 128 == (192 & a) && 128 == (192 & i) && 128 == (192 & u) && (c = (15 & s) << 18 | (63 & a) << 12 | (63 & i) << 6 | 63 & u) > 65535 && c < 1114112 && (f = c);
      }
      null === f ? (f = 65533, l = 1) : f > 65535 && (f -= 65536, n.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), n.push(f), o += l;
    }
    return function (t) {
      var e = t.length;
      if (e <= Dt) return String.fromCharCode.apply(String, t);
      var r = "",
        n = 0;
      for (; n < e;) {
        r += String.fromCharCode.apply(String, t.slice(n, n += Dt));
      }
      return r;
    }(n);
  }
  ht.TYPED_ARRAY_SUPPORT = void 0 === tt.TYPED_ARRAY_SUPPORT || tt.TYPED_ARRAY_SUPPORT, ht.poolSize = 8192, ht._augment = function (t) {
    return t.__proto__ = ht.prototype, t;
  }, ht.from = function (t, e, r) {
    return yt(null, t, e, r);
  }, ht.TYPED_ARRAY_SUPPORT && (ht.prototype.__proto__ = Uint8Array.prototype, ht.__proto__ = Uint8Array), ht.alloc = function (t, e, r) {
    return function (t, e, r, n) {
      return vt(e), e <= 0 ? dt(t, e) : void 0 !== r ? "string" == typeof n ? dt(t, e).fill(r, n) : dt(t, e).fill(r) : dt(t, e);
    }(null, t, e, r);
  }, ht.allocUnsafe = function (t) {
    return gt(null, t);
  }, ht.allocUnsafeSlow = function (t) {
    return gt(null, t);
  }, ht.isBuffer = function (t) {
    return null != t && (!!t._isBuffer || Qt(t) || function (t) {
      return "function" == typeof t.readFloatLE && "function" == typeof t.slice && Qt(t.slice(0, 0));
    }(t));
  }, ht.compare = function (t, e) {
    if (!wt(t) || !wt(e)) throw new TypeError("Arguments must be Buffers");
    if (t === e) return 0;
    for (var r = t.length, n = e.length, o = 0, a = Math.min(r, n); o < a; ++o) {
      if (t[o] !== e[o]) {
        r = t[o], n = e[o];
        break;
      }
    }
    return r < n ? -1 : n < r ? 1 : 0;
  }, ht.isEncoding = function (t) {
    switch (String(t).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, ht.concat = function (t, e) {
    if (!lt(t)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === t.length) return ht.alloc(0);
    var r;
    if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
      e += t[r].length;
    }
    var n = ht.allocUnsafe(e),
      o = 0;
    for (r = 0; r < t.length; ++r) {
      var a = t[r];
      if (!wt(a)) throw new TypeError('"list" argument must be an Array of Buffers');
      a.copy(n, o), o += a.length;
    }
    return n;
  }, ht.byteLength = jt, ht.prototype._isBuffer = !0, ht.prototype.swap16 = function () {
    var t = this.length;
    if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var e = 0; e < t; e += 2) {
      Ot(this, e, e + 1);
    }
    return this;
  }, ht.prototype.swap32 = function () {
    var t = this.length;
    if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var e = 0; e < t; e += 4) {
      Ot(this, e, e + 3), Ot(this, e + 1, e + 2);
    }
    return this;
  }, ht.prototype.swap64 = function () {
    var t = this.length;
    if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var e = 0; e < t; e += 8) {
      Ot(this, e, e + 7), Ot(this, e + 1, e + 6), Ot(this, e + 2, e + 5), Ot(this, e + 3, e + 4);
    }
    return this;
  }, ht.prototype.toString = function () {
    var t = 0 | this.length;
    return 0 === t ? "" : 0 === arguments.length ? Ut(this, 0, t) : xt.apply(this, arguments);
  }, ht.prototype.equals = function (t) {
    if (!wt(t)) throw new TypeError("Argument must be a Buffer");
    return this === t || 0 === ht.compare(this, t);
  }, ht.prototype.inspect = function () {
    var t = "";
    return this.length > 0 && (t = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (t += " ... ")), "<Buffer " + t + ">";
  }, ht.prototype.compare = function (t, e, r, n, o) {
    if (!wt(t)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
    if (n >= o && e >= r) return 0;
    if (n >= o) return -1;
    if (e >= r) return 1;
    if (this === t) return 0;
    for (var a = (o >>>= 0) - (n >>>= 0), i = (r >>>= 0) - (e >>>= 0), u = Math.min(a, i), c = this.slice(n, o), s = t.slice(e, r), f = 0; f < u; ++f) {
      if (c[f] !== s[f]) {
        a = c[f], i = s[f];
        break;
      }
    }
    return a < i ? -1 : i < a ? 1 : 0;
  }, ht.prototype.includes = function (t, e, r) {
    return -1 !== this.indexOf(t, e, r);
  }, ht.prototype.indexOf = function (t, e, r) {
    return _t(this, t, e, r, !0);
  }, ht.prototype.lastIndexOf = function (t, e, r) {
    return _t(this, t, e, r, !1);
  }, ht.prototype.write = function (t, e, r, n) {
    if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
      if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
    }
    var o = this.length - e;
    if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    n || (n = "utf8");
    for (var a = !1;;) {
      switch (n) {
        case "hex":
          return At(this, t, e, r);
        case "utf8":
        case "utf-8":
          return kt(this, t, e, r);
        case "ascii":
          return Et(this, t, e, r);
        case "latin1":
        case "binary":
          return Pt(this, t, e, r);
        case "base64":
          return Ct(this, t, e, r);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Rt(this, t, e, r);
        default:
          if (a) throw new TypeError("Unknown encoding: " + n);
          n = ("" + n).toLowerCase(), a = !0;
      }
    }
  }, ht.prototype.toJSON = function () {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  var Dt = 4096;
  function Tt(t, e, r) {
    var n = "";
    r = Math.min(t.length, r);
    for (var o = e; o < r; ++o) {
      n += String.fromCharCode(127 & t[o]);
    }
    return n;
  }
  function Mt(t, e, r) {
    var n = "";
    r = Math.min(t.length, r);
    for (var o = e; o < r; ++o) {
      n += String.fromCharCode(t[o]);
    }
    return n;
  }
  function Nt(t, e, r) {
    var n = t.length;
    (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
    for (var o = "", a = e; a < r; ++a) {
      o += Jt(t[a]);
    }
    return o;
  }
  function zt(t, e, r) {
    for (var n = t.slice(e, r), o = "", a = 0; a < n.length; a += 2) {
      o += String.fromCharCode(n[a] + 256 * n[a + 1]);
    }
    return o;
  }
  function Lt(t, e, r) {
    if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
    if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
  }
  function Ft(t, e, r, n, o, a) {
    if (!wt(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (e > o || e < a) throw new RangeError('"value" argument is out of bounds');
    if (r + n > t.length) throw new RangeError("Index out of range");
  }
  function Bt(t, e, r, n) {
    e < 0 && (e = 65535 + e + 1);
    for (var o = 0, a = Math.min(t.length - r, 2); o < a; ++o) {
      t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
    }
  }
  function qt(t, e, r, n) {
    e < 0 && (e = 4294967295 + e + 1);
    for (var o = 0, a = Math.min(t.length - r, 4); o < a; ++o) {
      t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
    }
  }
  function $t(t, e, r, n, o, a) {
    if (r + n > t.length) throw new RangeError("Index out of range");
    if (r < 0) throw new RangeError("Index out of range");
  }
  function Yt(t, e, r, n, o) {
    return o || $t(t, 0, r, 4), st(t, e, r, n, 23, 4), r + 4;
  }
  function Gt(t, e, r, n, o) {
    return o || $t(t, 0, r, 8), st(t, e, r, n, 52, 8), r + 8;
  }
  ht.prototype.slice = function (t, e) {
    var r,
      n = this.length;
    if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), ht.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = ht.prototype;else {
      var o = e - t;
      r = new ht(o, void 0);
      for (var a = 0; a < o; ++a) {
        r[a] = this[a + t];
      }
    }
    return r;
  }, ht.prototype.readUIntLE = function (t, e, r) {
    t |= 0, e |= 0, r || Lt(t, e, this.length);
    for (var n = this[t], o = 1, a = 0; ++a < e && (o *= 256);) {
      n += this[t + a] * o;
    }
    return n;
  }, ht.prototype.readUIntBE = function (t, e, r) {
    t |= 0, e |= 0, r || Lt(t, e, this.length);
    for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
      n += this[t + --e] * o;
    }
    return n;
  }, ht.prototype.readUInt8 = function (t, e) {
    return e || Lt(t, 1, this.length), this[t];
  }, ht.prototype.readUInt16LE = function (t, e) {
    return e || Lt(t, 2, this.length), this[t] | this[t + 1] << 8;
  }, ht.prototype.readUInt16BE = function (t, e) {
    return e || Lt(t, 2, this.length), this[t] << 8 | this[t + 1];
  }, ht.prototype.readUInt32LE = function (t, e) {
    return e || Lt(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
  }, ht.prototype.readUInt32BE = function (t, e) {
    return e || Lt(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
  }, ht.prototype.readIntLE = function (t, e, r) {
    t |= 0, e |= 0, r || Lt(t, e, this.length);
    for (var n = this[t], o = 1, a = 0; ++a < e && (o *= 256);) {
      n += this[t + a] * o;
    }
    return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
  }, ht.prototype.readIntBE = function (t, e, r) {
    t |= 0, e |= 0, r || Lt(t, e, this.length);
    for (var n = e, o = 1, a = this[t + --n]; n > 0 && (o *= 256);) {
      a += this[t + --n] * o;
    }
    return a >= (o *= 128) && (a -= Math.pow(2, 8 * e)), a;
  }, ht.prototype.readInt8 = function (t, e) {
    return e || Lt(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
  }, ht.prototype.readInt16LE = function (t, e) {
    e || Lt(t, 2, this.length);
    var r = this[t] | this[t + 1] << 8;
    return 32768 & r ? 4294901760 | r : r;
  }, ht.prototype.readInt16BE = function (t, e) {
    e || Lt(t, 2, this.length);
    var r = this[t + 1] | this[t] << 8;
    return 32768 & r ? 4294901760 | r : r;
  }, ht.prototype.readInt32LE = function (t, e) {
    return e || Lt(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
  }, ht.prototype.readInt32BE = function (t, e) {
    return e || Lt(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
  }, ht.prototype.readFloatLE = function (t, e) {
    return e || Lt(t, 4, this.length), ct(this, t, !0, 23, 4);
  }, ht.prototype.readFloatBE = function (t, e) {
    return e || Lt(t, 4, this.length), ct(this, t, !1, 23, 4);
  }, ht.prototype.readDoubleLE = function (t, e) {
    return e || Lt(t, 8, this.length), ct(this, t, !0, 52, 8);
  }, ht.prototype.readDoubleBE = function (t, e) {
    return e || Lt(t, 8, this.length), ct(this, t, !1, 52, 8);
  }, ht.prototype.writeUIntLE = function (t, e, r, n) {
    (t = +t, e |= 0, r |= 0, n) || Ft(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
    var o = 1,
      a = 0;
    for (this[e] = 255 & t; ++a < r && (o *= 256);) {
      this[e + a] = t / o & 255;
    }
    return e + r;
  }, ht.prototype.writeUIntBE = function (t, e, r, n) {
    (t = +t, e |= 0, r |= 0, n) || Ft(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
    var o = r - 1,
      a = 1;
    for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
      this[e + o] = t / a & 255;
    }
    return e + r;
  }, ht.prototype.writeUInt8 = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 1, 255, 0), ht.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
  }, ht.prototype.writeUInt16LE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 2, 65535, 0), ht.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : Bt(this, t, e, !0), e + 2;
  }, ht.prototype.writeUInt16BE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 2, 65535, 0), ht.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : Bt(this, t, e, !1), e + 2;
  }, ht.prototype.writeUInt32LE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 4, 4294967295, 0), ht.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : qt(this, t, e, !0), e + 4;
  }, ht.prototype.writeUInt32BE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 4, 4294967295, 0), ht.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : qt(this, t, e, !1), e + 4;
  }, ht.prototype.writeIntLE = function (t, e, r, n) {
    if (t = +t, e |= 0, !n) {
      var o = Math.pow(2, 8 * r - 1);
      Ft(this, t, e, r, o - 1, -o);
    }
    var a = 0,
      i = 1,
      u = 0;
    for (this[e] = 255 & t; ++a < r && (i *= 256);) {
      t < 0 && 0 === u && 0 !== this[e + a - 1] && (u = 1), this[e + a] = (t / i >> 0) - u & 255;
    }
    return e + r;
  }, ht.prototype.writeIntBE = function (t, e, r, n) {
    if (t = +t, e |= 0, !n) {
      var o = Math.pow(2, 8 * r - 1);
      Ft(this, t, e, r, o - 1, -o);
    }
    var a = r - 1,
      i = 1,
      u = 0;
    for (this[e + a] = 255 & t; --a >= 0 && (i *= 256);) {
      t < 0 && 0 === u && 0 !== this[e + a + 1] && (u = 1), this[e + a] = (t / i >> 0) - u & 255;
    }
    return e + r;
  }, ht.prototype.writeInt8 = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 1, 127, -128), ht.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
  }, ht.prototype.writeInt16LE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 2, 32767, -32768), ht.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : Bt(this, t, e, !0), e + 2;
  }, ht.prototype.writeInt16BE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 2, 32767, -32768), ht.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : Bt(this, t, e, !1), e + 2;
  }, ht.prototype.writeInt32LE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 4, 2147483647, -2147483648), ht.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : qt(this, t, e, !0), e + 4;
  }, ht.prototype.writeInt32BE = function (t, e, r) {
    return t = +t, e |= 0, r || Ft(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), ht.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : qt(this, t, e, !1), e + 4;
  }, ht.prototype.writeFloatLE = function (t, e, r) {
    return Yt(this, t, e, !0, r);
  }, ht.prototype.writeFloatBE = function (t, e, r) {
    return Yt(this, t, e, !1, r);
  }, ht.prototype.writeDoubleLE = function (t, e, r) {
    return Gt(this, t, e, !0, r);
  }, ht.prototype.writeDoubleBE = function (t, e, r) {
    return Gt(this, t, e, !1, r);
  }, ht.prototype.copy = function (t, e, r, n) {
    if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
    if (0 === t.length || 0 === this.length) return 0;
    if (e < 0) throw new RangeError("targetStart out of bounds");
    if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
    if (n < 0) throw new RangeError("sourceEnd out of bounds");
    n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
    var o,
      a = n - r;
    if (this === t && r < e && e < n) for (o = a - 1; o >= 0; --o) {
      t[o + e] = this[o + r];
    } else if (a < 1e3 || !ht.TYPED_ARRAY_SUPPORT) for (o = 0; o < a; ++o) {
      t[o + e] = this[o + r];
    } else Uint8Array.prototype.set.call(t, this.subarray(r, r + a), e);
    return a;
  }, ht.prototype.fill = function (t, e, r, n) {
    if ("string" == typeof t) {
      if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
        var o = t.charCodeAt(0);
        o < 256 && (t = o);
      }
      if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
      if ("string" == typeof n && !ht.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
    } else "number" == typeof t && (t &= 255);
    if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
    if (r <= e) return this;
    var a;
    if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (a = e; a < r; ++a) {
      this[a] = t;
    } else {
      var i = wt(t) ? t : Zt(new ht(t, n).toString()),
        u = i.length;
      for (a = 0; a < r - e; ++a) {
        this[a + e] = i[a % u];
      }
    }
    return this;
  };
  var Wt = /[^+\/0-9A-Za-z-_]/g;
  function Jt(t) {
    return t < 16 ? "0" + t.toString(16) : t.toString(16);
  }
  function Zt(t, e) {
    var r;
    e = e || 1 / 0;
    for (var n = t.length, o = null, a = [], i = 0; i < n; ++i) {
      if ((r = t.charCodeAt(i)) > 55295 && r < 57344) {
        if (!o) {
          if (r > 56319) {
            (e -= 3) > -1 && a.push(239, 191, 189);
            continue;
          }
          if (i + 1 === n) {
            (e -= 3) > -1 && a.push(239, 191, 189);
            continue;
          }
          o = r;
          continue;
        }
        if (r < 56320) {
          (e -= 3) > -1 && a.push(239, 191, 189), o = r;
          continue;
        }
        r = 65536 + (o - 55296 << 10 | r - 56320);
      } else o && (e -= 3) > -1 && a.push(239, 191, 189);
      if (o = null, r < 128) {
        if ((e -= 1) < 0) break;
        a.push(r);
      } else if (r < 2048) {
        if ((e -= 2) < 0) break;
        a.push(r >> 6 | 192, 63 & r | 128);
      } else if (r < 65536) {
        if ((e -= 3) < 0) break;
        a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
      } else {
        if (!(r < 1114112)) throw new Error("Invalid code point");
        if ((e -= 4) < 0) break;
        a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
      }
    }
    return a;
  }
  function Vt(t) {
    return function (t) {
      var e, r, n, o, a, i;
      ot || at();
      var u = t.length;
      if (u % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      a = "=" === t[u - 2] ? 2 : "=" === t[u - 1] ? 1 : 0, i = new nt(3 * u / 4 - a), n = a > 0 ? u - 4 : u;
      var c = 0;
      for (e = 0, r = 0; e < n; e += 4, r += 3) {
        o = rt[t.charCodeAt(e)] << 18 | rt[t.charCodeAt(e + 1)] << 12 | rt[t.charCodeAt(e + 2)] << 6 | rt[t.charCodeAt(e + 3)], i[c++] = o >> 16 & 255, i[c++] = o >> 8 & 255, i[c++] = 255 & o;
      }
      return 2 === a ? (o = rt[t.charCodeAt(e)] << 2 | rt[t.charCodeAt(e + 1)] >> 4, i[c++] = 255 & o) : 1 === a && (o = rt[t.charCodeAt(e)] << 10 | rt[t.charCodeAt(e + 1)] << 4 | rt[t.charCodeAt(e + 2)] >> 2, i[c++] = o >> 8 & 255, i[c++] = 255 & o), i;
    }(function (t) {
      if ((t = function (t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
      }(t).replace(Wt, "")).length < 2) return "";
      for (; t.length % 4 != 0;) {
        t += "=";
      }
      return t;
    }(t));
  }
  function Ht(t, e, r, n) {
    for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
      e[o + r] = t[o];
    }
    return o;
  }
  function Qt(t) {
    return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
  }
  function Xt() {
    throw new Error("setTimeout has not been defined");
  }
  function Kt() {
    throw new Error("clearTimeout has not been defined");
  }
  var te = Xt,
    ee = Kt;
  function re(t) {
    if (te === setTimeout) return setTimeout(t, 0);
    if ((te === Xt || !te) && setTimeout) return te = setTimeout, setTimeout(t, 0);
    try {
      return te(t, 0);
    } catch (e) {
      try {
        return te.call(null, t, 0);
      } catch (e) {
        return te.call(this, t, 0);
      }
    }
  }
  "function" == typeof tt.setTimeout && (te = setTimeout), "function" == typeof tt.clearTimeout && (ee = clearTimeout);
  var ne,
    oe = [],
    ae = !1,
    ie = -1;
  function ue() {
    ae && ne && (ae = !1, ne.length ? oe = ne.concat(oe) : ie = -1, oe.length && ce());
  }
  function ce() {
    if (!ae) {
      var t = re(ue);
      ae = !0;
      for (var e = oe.length; e;) {
        for (ne = oe, oe = []; ++ie < e;) {
          ne && ne[ie].run();
        }
        ie = -1, e = oe.length;
      }
      ne = null, ae = !1, function (t) {
        if (ee === clearTimeout) return clearTimeout(t);
        if ((ee === Kt || !ee) && clearTimeout) return ee = clearTimeout, clearTimeout(t);
        try {
          ee(t);
        } catch (e) {
          try {
            return ee.call(null, t);
          } catch (e) {
            return ee.call(this, t);
          }
        }
      }(t);
    }
  }
  function se(t, e) {
    this.fun = t, this.array = e;
  }
  se.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  function fe() {}
  var le = fe,
    pe = fe,
    de = fe,
    he = fe,
    ye = fe,
    ve = fe,
    ge = fe;
  var be = tt.performance || {},
    me = be.now || be.mozNow || be.msNow || be.oNow || be.webkitNow || function () {
      return new Date().getTime();
    };
  var we = new Date();
  var je = {
      nextTick: function nextTick(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
          e[r - 1] = arguments[r];
        }
        oe.push(new se(t, e)), 1 !== oe.length || ae || re(ce);
      },
      title: "browser",
      browser: !0,
      env: {},
      argv: [],
      version: "",
      versions: {},
      on: le,
      addListener: pe,
      once: de,
      off: he,
      removeListener: ye,
      removeAllListeners: ve,
      emit: ge,
      binding: function binding(t) {
        throw new Error("process.binding is not supported");
      },
      cwd: function cwd() {
        return "/";
      },
      chdir: function chdir(t) {
        throw new Error("process.chdir is not supported");
      },
      umask: function umask() {
        return 0;
      },
      hrtime: function hrtime(t) {
        var e = .001 * me.call(be),
          r = Math.floor(e),
          n = Math.floor(e % 1 * 1e9);
        return t && (r -= t[0], (n -= t[1]) < 0 && (r--, n += 1e9)), [r, n];
      },
      platform: "browser",
      release: {},
      config: {},
      uptime: function uptime() {
        return (new Date() - we) / 1e3;
      }
    },
    xe = "function" == typeof Object.create ? function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : function (t, e) {
      t.super_ = e;
      var r = function r() {};
      r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
    },
    Oe = /%[sdj%]/g;
  function _e(t) {
    if (!Fe(t)) {
      for (var e = [], r = 0; r < arguments.length; r++) {
        e.push(Pe(arguments[r]));
      }
      return e.join(" ");
    }
    r = 1;
    for (var n = arguments, o = n.length, a = String(t).replace(Oe, function (t) {
        if ("%%" === t) return "%";
        if (r >= o) return t;
        switch (t) {
          case "%s":
            return String(n[r++]);
          case "%d":
            return Number(n[r++]);
          case "%j":
            try {
              return JSON.stringify(n[r++]);
            } catch (t) {
              return "[Circular]";
            }
          default:
            return t;
        }
      }), i = n[r]; r < o; i = n[++r]) {
      Ne(i) || !Ye(i) ? a += " " + i : a += " " + Pe(i);
    }
    return a;
  }
  function Se(t, e) {
    if (qe(tt.process)) return function () {
      return Se(t, e).apply(this, arguments);
    };
    if (!0 === je.noDeprecation) return t;
    var r = !1;
    return function () {
      if (!r) {
        if (je.throwDeprecation) throw new Error(e);
        je.traceDeprecation ? console.trace(e) : console.error(e), r = !0;
      }
      return t.apply(this, arguments);
    };
  }
  var Ae,
    ke = {};
  function Ee(t) {
    if (qe(Ae) && (Ae = je.env.NODE_DEBUG || ""), t = t.toUpperCase(), !ke[t]) if (new RegExp("\\b" + t + "\\b", "i").test(Ae)) {
      ke[t] = function () {
        var e = _e.apply(null, arguments);
        console.error("%s %d: %s", t, 0, e);
      };
    } else ke[t] = function () {};
    return ke[t];
  }
  function Pe(t, e) {
    var r = {
      seen: [],
      stylize: Re
    };
    return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), Me(e) ? r.showHidden = e : e && er(r, e), qe(r.showHidden) && (r.showHidden = !1), qe(r.depth) && (r.depth = 2), qe(r.colors) && (r.colors = !1), qe(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = Ce), Ie(r, t, r.depth);
  }
  function Ce(t, e) {
    var r = Pe.styles[e];
    return r ? "[" + Pe.colors[r][0] + "m" + t + "[" + Pe.colors[r][1] + "m" : t;
  }
  function Re(t, e) {
    return t;
  }
  function Ie(t, e, r) {
    if (t.customInspect && e && Je(e.inspect) && e.inspect !== Pe && (!e.constructor || e.constructor.prototype !== e)) {
      var n = e.inspect(r, t);
      return Fe(n) || (n = Ie(t, n, r)), n;
    }
    var o = function (t, e) {
      if (qe(e)) return t.stylize("undefined", "undefined");
      if (Fe(e)) {
        var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return t.stylize(r, "string");
      }
      if (Le(e)) return t.stylize("" + e, "number");
      if (Me(e)) return t.stylize("" + e, "boolean");
      if (Ne(e)) return t.stylize("null", "null");
    }(t, e);
    if (o) return o;
    var a = Object.keys(e),
      i = function (t) {
        var e = {};
        return t.forEach(function (t, r) {
          e[t] = !0;
        }), e;
      }(a);
    if (t.showHidden && (a = Object.getOwnPropertyNames(e)), We(e) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return Ue(e);
    if (0 === a.length) {
      if (Je(e)) {
        var u = e.name ? ": " + e.name : "";
        return t.stylize("[Function" + u + "]", "special");
      }
      if ($e(e)) return t.stylize(RegExp.prototype.toString.call(e), "regexp");
      if (Ge(e)) return t.stylize(Date.prototype.toString.call(e), "date");
      if (We(e)) return Ue(e);
    }
    var c,
      s = "",
      f = !1,
      l = ["{", "}"];
    (Te(e) && (f = !0, l = ["[", "]"]), Je(e)) && (s = " [Function" + (e.name ? ": " + e.name : "") + "]");
    return $e(e) && (s = " " + RegExp.prototype.toString.call(e)), Ge(e) && (s = " " + Date.prototype.toUTCString.call(e)), We(e) && (s = " " + Ue(e)), 0 !== a.length || f && 0 != e.length ? r < 0 ? $e(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(e), c = f ? function (t, e, r, n, o) {
      for (var a = [], i = 0, u = e.length; i < u; ++i) {
        rr(e, String(i)) ? a.push(De(t, e, r, n, String(i), !0)) : a.push("");
      }
      return o.forEach(function (o) {
        o.match(/^\d+$/) || a.push(De(t, e, r, n, o, !0));
      }), a;
    }(t, e, r, i, a) : a.map(function (n) {
      return De(t, e, r, i, n, f);
    }), t.seen.pop(), function (t, e, r) {
      if (t.reduce(function (t, e) {
        return e.indexOf("\n"), t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0) > 60) return r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1];
      return r[0] + e + " " + t.join(", ") + " " + r[1];
    }(c, s, l)) : l[0] + s + l[1];
  }
  function Ue(t) {
    return "[" + Error.prototype.toString.call(t) + "]";
  }
  function De(t, e, r, n, o, a) {
    var i, u, c;
    if ((c = Object.getOwnPropertyDescriptor(e, o) || {
      value: e[o]
    }).get ? u = c.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : c.set && (u = t.stylize("[Setter]", "special")), rr(n, o) || (i = "[" + o + "]"), u || (t.seen.indexOf(c.value) < 0 ? (u = Ne(r) ? Ie(t, c.value, null) : Ie(t, c.value, r - 1)).indexOf("\n") > -1 && (u = a ? u.split("\n").map(function (t) {
      return "  " + t;
    }).join("\n").substr(2) : "\n" + u.split("\n").map(function (t) {
      return "   " + t;
    }).join("\n")) : u = t.stylize("[Circular]", "special")), qe(i)) {
      if (a && o.match(/^\d+$/)) return u;
      (i = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (i = i.substr(1, i.length - 2), i = t.stylize(i, "name")) : (i = i.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), i = t.stylize(i, "string"));
    }
    return i + ": " + u;
  }
  function Te(t) {
    return Array.isArray(t);
  }
  function Me(t) {
    return "boolean" == typeof t;
  }
  function Ne(t) {
    return null === t;
  }
  function ze(t) {
    return null == t;
  }
  function Le(t) {
    return "number" == typeof t;
  }
  function Fe(t) {
    return "string" == typeof t;
  }
  function Be(t) {
    return "symbol" == typeof t;
  }
  function qe(t) {
    return void 0 === t;
  }
  function $e(t) {
    return Ye(t) && "[object RegExp]" === He(t);
  }
  function Ye(t) {
    return "object" == typeof t && null !== t;
  }
  function Ge(t) {
    return Ye(t) && "[object Date]" === He(t);
  }
  function We(t) {
    return Ye(t) && ("[object Error]" === He(t) || t instanceof Error);
  }
  function Je(t) {
    return "function" == typeof t;
  }
  function Ze(t) {
    return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
  }
  function Ve(t) {
    return ht.isBuffer(t);
  }
  function He(t) {
    return Object.prototype.toString.call(t);
  }
  function Qe(t) {
    return t < 10 ? "0" + t.toString(10) : t.toString(10);
  }
  Pe.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, Pe.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  };
  var Xe = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function Ke() {
    var t = new Date(),
      e = [Qe(t.getHours()), Qe(t.getMinutes()), Qe(t.getSeconds())].join(":");
    return [t.getDate(), Xe[t.getMonth()], e].join(" ");
  }
  function tr() {
    console.log("%s - %s", Ke(), _e.apply(null, arguments));
  }
  function er(t, e) {
    if (!e || !Ye(e)) return t;
    for (var r = Object.keys(e), n = r.length; n--;) {
      t[r[n]] = e[r[n]];
    }
    return t;
  }
  function rr(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }
  var nr = {
      inherits: xe,
      _extend: er,
      log: tr,
      isBuffer: Ve,
      isPrimitive: Ze,
      isFunction: Je,
      isError: We,
      isDate: Ge,
      isObject: Ye,
      isRegExp: $e,
      isUndefined: qe,
      isSymbol: Be,
      isString: Fe,
      isNumber: Le,
      isNullOrUndefined: ze,
      isNull: Ne,
      isBoolean: Me,
      isArray: Te,
      inspect: Pe,
      deprecate: Se,
      format: _e,
      debuglog: Ee
    },
    or = d(Object.freeze({
      __proto__: null,
      format: _e,
      deprecate: Se,
      debuglog: Ee,
      inspect: Pe,
      isArray: Te,
      isBoolean: Me,
      isNull: Ne,
      isNullOrUndefined: ze,
      isNumber: Le,
      isString: Fe,
      isSymbol: Be,
      isUndefined: qe,
      isRegExp: $e,
      isObject: Ye,
      isDate: Ge,
      isError: We,
      isFunction: Je,
      isPrimitive: Ze,
      isBuffer: Ve,
      log: tr,
      inherits: xe,
      _extend: er,
      default: nr
    })).inspect,
    ar = "function" == typeof Map && Map.prototype,
    ir = Object.getOwnPropertyDescriptor && ar ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
    ur = ar && ir && "function" == typeof ir.get ? ir.get : null,
    cr = ar && Map.prototype.forEach,
    sr = "function" == typeof Set && Set.prototype,
    fr = Object.getOwnPropertyDescriptor && sr ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
    lr = sr && fr && "function" == typeof fr.get ? fr.get : null,
    pr = sr && Set.prototype.forEach,
    dr = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
    hr = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
    yr = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
    vr = Boolean.prototype.valueOf,
    gr = Object.prototype.toString,
    br = Function.prototype.toString,
    mr = String.prototype.match,
    wr = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
    jr = Object.getOwnPropertySymbols,
    xr = "function" == typeof Symbol && "symbol" === l.default(Symbol.iterator) ? Symbol.prototype.toString : null,
    Or = "function" == typeof Symbol && "object" === l.default(Symbol.iterator),
    _r = Object.prototype.propertyIsEnumerable,
    Sr = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (t) {
      return t.__proto__;
    } : null),
    Ar = or.custom,
    kr = Ar && Ir(Ar) ? Ar : null,
    Er = "function" == typeof Symbol && void 0 !== Symbol.toStringTag ? Symbol.toStringTag : null;
  function Pr(t, e, r) {
    var n = "double" === (r.quoteStyle || e) ? '"' : "'";
    return n + t + n;
  }
  function Cr(t) {
    return String(t).replace(/"/g, "&quot;");
  }
  function Rr(t) {
    return !("[object Array]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
  }
  function Ir(t) {
    if (Or) return t && "object" === l.default(t) && t instanceof Symbol;
    if ("symbol" === l.default(t)) return !0;
    if (!t || "object" !== l.default(t) || !xr) return !1;
    try {
      return xr.call(t), !0;
    } catch (t) {}
    return !1;
  }
  var Ur = Object.prototype.hasOwnProperty || function (t) {
    return t in this;
  };
  function Dr(t, e) {
    return Ur.call(t, e);
  }
  function Tr(t) {
    return gr.call(t);
  }
  function Mr(t, e) {
    if (t.indexOf) return t.indexOf(e);
    for (var r = 0, n = t.length; r < n; r++) {
      if (t[r] === e) return r;
    }
    return -1;
  }
  function Nr(t, e) {
    if (t.length > e.maxStringLength) {
      var r = t.length - e.maxStringLength,
        n = "... " + r + " more character" + (r > 1 ? "s" : "");
      return Nr(t.slice(0, e.maxStringLength), e) + n;
    }
    return Pr(t.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, zr), "single", e);
  }
  function zr(t) {
    var e = t.charCodeAt(0),
      r = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[e];
    return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + e.toString(16).toUpperCase();
  }
  function Lr(t) {
    return "Object(" + t + ")";
  }
  function Fr(t) {
    return t + " { ? }";
  }
  function Br(t, e, r, n) {
    return t + " (" + e + ") {" + (n ? qr(r, n) : r.join(", ")) + "}";
  }
  function qr(t, e) {
    if (0 === t.length) return "";
    var r = "\n" + e.prev + e.base;
    return r + t.join("," + r) + "\n" + e.prev;
  }
  function $r(t, e) {
    var r = Rr(t),
      n = [];
    if (r) {
      n.length = t.length;
      for (var o = 0; o < t.length; o++) {
        n[o] = Dr(t, o) ? e(t[o], t) : "";
      }
    }
    var a,
      i = "function" == typeof jr ? jr(t) : [];
    if (Or) {
      a = {};
      for (var u = 0; u < i.length; u++) {
        a["$" + i[u]] = i[u];
      }
    }
    for (var c in t) {
      Dr(t, c) && (r && String(Number(c)) === c && c < t.length || Or && a["$" + c] instanceof Symbol || (/[^\w$]/.test(c) ? n.push(e(c, t) + ": " + e(t[c], t)) : n.push(c + ": " + e(t[c], t))));
    }
    if ("function" == typeof jr) for (var s = 0; s < i.length; s++) {
      _r.call(t, i[s]) && n.push("[" + e(i[s]) + "]: " + e(t[i[s]], t));
    }
    return n;
  }
  var Yr = V,
    Gr = function Gr(t, e) {
      var r = Q(t, !!e);
      return "function" == typeof r && K(t, ".prototype.") > -1 ? X(r) : r;
    },
    Wr = function t(e, r, n, o) {
      var a = r || {};
      if (Dr(a, "quoteStyle") && "single" !== a.quoteStyle && "double" !== a.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
      if (Dr(a, "maxStringLength") && ("number" == typeof a.maxStringLength ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : null !== a.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      var i = !Dr(a, "customInspect") || a.customInspect;
      if ("boolean" != typeof i && "symbol" !== i) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      if (Dr(a, "indent") && null !== a.indent && "\t" !== a.indent && !(parseInt(a.indent, 10) === a.indent && a.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
      if (void 0 === e) return "undefined";
      if (null === e) return "null";
      if ("boolean" == typeof e) return e ? "true" : "false";
      if ("string" == typeof e) return Nr(e, a);
      if ("number" == typeof e) return 0 === e ? 1 / 0 / e > 0 ? "0" : "-0" : String(e);
      if ("bigint" == typeof e) return String(e) + "n";
      var u = void 0 === a.depth ? 5 : a.depth;
      if (void 0 === n && (n = 0), n >= u && u > 0 && "object" === l.default(e)) return Rr(e) ? "[Array]" : "[Object]";
      var c = function (t, e) {
        var r;
        if ("\t" === t.indent) r = "\t";else {
          if (!("number" == typeof t.indent && t.indent > 0)) return null;
          r = Array(t.indent + 1).join(" ");
        }
        return {
          base: r,
          prev: Array(e + 1).join(r)
        };
      }(a, n);
      if (void 0 === o) o = [];else if (Mr(o, e) >= 0) return "[Circular]";
      function s(e, r, i) {
        if (r && (o = o.slice()).push(r), i) {
          var u = {
            depth: a.depth
          };
          return Dr(a, "quoteStyle") && (u.quoteStyle = a.quoteStyle), t(e, u, n + 1, o);
        }
        return t(e, a, n + 1, o);
      }
      if ("function" == typeof e) {
        var f = function (t) {
            if (t.name) return t.name;
            var e = mr.call(br.call(t), /^function\s*([\w$]+)/);
            if (e) return e[1];
            return null;
          }(e),
          p = $r(e, s);
        return "[Function" + (f ? ": " + f : " (anonymous)") + "]" + (p.length > 0 ? " { " + p.join(", ") + " }" : "");
      }
      if (Ir(e)) {
        var d = Or ? String(e).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : xr.call(e);
        return "object" !== l.default(e) || Or ? d : Lr(d);
      }
      if (function (t) {
        if (!t || "object" !== l.default(t)) return !1;
        if ("undefined" != typeof HTMLElement && t instanceof HTMLElement) return !0;
        return "string" == typeof t.nodeName && "function" == typeof t.getAttribute;
      }(e)) {
        for (var h = "<" + String(e.nodeName).toLowerCase(), y = e.attributes || [], v = 0; v < y.length; v++) {
          h += " " + y[v].name + "=" + Pr(Cr(y[v].value), "double", a);
        }
        return h += ">", e.childNodes && e.childNodes.length && (h += "..."), h += "</" + String(e.nodeName).toLowerCase() + ">";
      }
      if (Rr(e)) {
        if (0 === e.length) return "[]";
        var g = $r(e, s);
        return c && !function (t) {
          for (var e = 0; e < t.length; e++) {
            if (Mr(t[e], "\n") >= 0) return !1;
          }
          return !0;
        }(g) ? "[" + qr(g, c) + "]" : "[ " + g.join(", ") + " ]";
      }
      if (function (t) {
        return !("[object Error]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e)) {
        var b = $r(e, s);
        return 0 === b.length ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + b.join(", ") + " }";
      }
      if ("object" === l.default(e) && i) {
        if (kr && "function" == typeof e[kr]) return e[kr]();
        if ("symbol" !== i && "function" == typeof e.inspect) return e.inspect();
      }
      if (function (t) {
        if (!ur || !t || "object" !== l.default(t)) return !1;
        try {
          ur.call(t);
          try {
            lr.call(t);
          } catch (t) {
            return !0;
          }
          return t instanceof Map;
        } catch (t) {}
        return !1;
      }(e)) {
        var m = [];
        return cr.call(e, function (t, r) {
          m.push(s(r, e, !0) + " => " + s(t, e));
        }), Br("Map", ur.call(e), m, c);
      }
      if (function (t) {
        if (!lr || !t || "object" !== l.default(t)) return !1;
        try {
          lr.call(t);
          try {
            ur.call(t);
          } catch (t) {
            return !0;
          }
          return t instanceof Set;
        } catch (t) {}
        return !1;
      }(e)) {
        var w = [];
        return pr.call(e, function (t) {
          w.push(s(t, e));
        }), Br("Set", lr.call(e), w, c);
      }
      if (function (t) {
        if (!dr || !t || "object" !== l.default(t)) return !1;
        try {
          dr.call(t, dr);
          try {
            hr.call(t, hr);
          } catch (t) {
            return !0;
          }
          return t instanceof WeakMap;
        } catch (t) {}
        return !1;
      }(e)) return Fr("WeakMap");
      if (function (t) {
        if (!hr || !t || "object" !== l.default(t)) return !1;
        try {
          hr.call(t, hr);
          try {
            dr.call(t, dr);
          } catch (t) {
            return !0;
          }
          return t instanceof WeakSet;
        } catch (t) {}
        return !1;
      }(e)) return Fr("WeakSet");
      if (function (t) {
        if (!yr || !t || "object" !== l.default(t)) return !1;
        try {
          return yr.call(t), !0;
        } catch (t) {}
        return !1;
      }(e)) return Fr("WeakRef");
      if (function (t) {
        return !("[object Number]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e)) return Lr(s(Number(e)));
      if (function (t) {
        if (!t || "object" !== l.default(t) || !wr) return !1;
        try {
          return wr.call(t), !0;
        } catch (t) {}
        return !1;
      }(e)) return Lr(s(wr.call(e)));
      if (function (t) {
        return !("[object Boolean]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e)) return Lr(vr.call(e));
      if (function (t) {
        return !("[object String]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e)) return Lr(s(String(e)));
      if (!function (t) {
        return !("[object Date]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e) && !function (t) {
        return !("[object RegExp]" !== Tr(t) || Er && "object" === l.default(t) && Er in t);
      }(e)) {
        var j = $r(e, s),
          x = Sr ? Sr(e) === Object.prototype : e instanceof Object || e.constructor === Object,
          O = e instanceof Object ? "" : "null prototype",
          _ = !x && Er && Object(e) === e && Er in e ? Tr(e).slice(8, -1) : O ? "Object" : "",
          S = (x || "function" != typeof e.constructor ? "" : e.constructor.name ? e.constructor.name + " " : "") + (_ || O ? "[" + [].concat(_ || [], O || []).join(": ") + "] " : "");
        return 0 === j.length ? S + "{}" : c ? S + "{" + qr(j, c) + "}" : S + "{ " + j.join(", ") + " }";
      }
      return String(e);
    },
    Jr = Yr("%TypeError%"),
    Zr = Yr("%WeakMap%", !0),
    Vr = Yr("%Map%", !0),
    Hr = Gr("WeakMap.prototype.get", !0),
    Qr = Gr("WeakMap.prototype.set", !0),
    Xr = Gr("WeakMap.prototype.has", !0),
    Kr = Gr("Map.prototype.get", !0),
    tn = Gr("Map.prototype.set", !0),
    en = Gr("Map.prototype.has", !0),
    rn = function rn(t, e) {
      for (var r, n = t; null !== (r = n.next); n = r) {
        if (r.key === e) return n.next = r.next, r.next = t.next, t.next = r, r;
      }
    },
    nn = String.prototype.replace,
    on = /%20/g,
    an = "RFC3986",
    un = {
      default: an,
      formatters: {
        RFC1738: function RFC1738(t) {
          return nn.call(t, on, "+");
        },
        RFC3986: function RFC3986(t) {
          return String(t);
        }
      },
      RFC1738: "RFC1738",
      RFC3986: an
    },
    cn = un,
    sn = Object.prototype.hasOwnProperty,
    fn = Array.isArray,
    ln = function () {
      for (var t = [], e = 0; e < 256; ++e) {
        t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
      }
      return t;
    }(),
    pn = function pn(t, e) {
      for (var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n) {
        void 0 !== t[n] && (r[n] = t[n]);
      }
      return r;
    },
    dn = {
      arrayToObject: pn,
      assign: function assign(t, e) {
        return Object.keys(e).reduce(function (t, r) {
          return t[r] = e[r], t;
        }, t);
      },
      combine: function combine(t, e) {
        return [].concat(t, e);
      },
      compact: function compact(t) {
        for (var e = [{
            obj: {
              o: t
            },
            prop: "o"
          }], r = [], n = 0; n < e.length; ++n) {
          for (var o = e[n], a = o.obj[o.prop], i = Object.keys(a), u = 0; u < i.length; ++u) {
            var c = i[u],
              s = a[c];
            "object" === l.default(s) && null !== s && -1 === r.indexOf(s) && (e.push({
              obj: a,
              prop: c
            }), r.push(s));
          }
        }
        return function (t) {
          for (; t.length > 1;) {
            var e = t.pop(),
              r = e.obj[e.prop];
            if (fn(r)) {
              for (var n = [], o = 0; o < r.length; ++o) {
                void 0 !== r[o] && n.push(r[o]);
              }
              e.obj[e.prop] = n;
            }
          }
        }(e), t;
      },
      decode: function decode(t, e, r) {
        var n = t.replace(/\+/g, " ");
        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(n);
        } catch (t) {
          return n;
        }
      },
      encode: function encode(t, e, r, n, o) {
        if (0 === t.length) return t;
        var a = t;
        if ("symbol" === l.default(t) ? a = Symbol.prototype.toString.call(t) : "string" != typeof t && (a = String(t)), "iso-8859-1" === r) return escape(a).replace(/%u[0-9a-f]{4}/gi, function (t) {
          return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
        });
        for (var i = "", u = 0; u < a.length; ++u) {
          var c = a.charCodeAt(u);
          45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || o === cn.RFC1738 && (40 === c || 41 === c) ? i += a.charAt(u) : c < 128 ? i += ln[c] : c < 2048 ? i += ln[192 | c >> 6] + ln[128 | 63 & c] : c < 55296 || c >= 57344 ? i += ln[224 | c >> 12] + ln[128 | c >> 6 & 63] + ln[128 | 63 & c] : (u += 1, c = 65536 + ((1023 & c) << 10 | 1023 & a.charCodeAt(u)), i += ln[240 | c >> 18] + ln[128 | c >> 12 & 63] + ln[128 | c >> 6 & 63] + ln[128 | 63 & c]);
        }
        return i;
      },
      isBuffer: function isBuffer(t) {
        return !(!t || "object" !== l.default(t)) && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
      },
      isRegExp: function isRegExp(t) {
        return "[object RegExp]" === Object.prototype.toString.call(t);
      },
      maybeMap: function maybeMap(t, e) {
        if (fn(t)) {
          for (var r = [], n = 0; n < t.length; n += 1) {
            r.push(e(t[n]));
          }
          return r;
        }
        return e(t);
      },
      merge: function t(e, r, n) {
        if (!r) return e;
        if ("object" !== l.default(r)) {
          if (fn(e)) e.push(r);else {
            if (!e || "object" !== l.default(e)) return [e, r];
            (n && (n.plainObjects || n.allowPrototypes) || !sn.call(Object.prototype, r)) && (e[r] = !0);
          }
          return e;
        }
        if (!e || "object" !== l.default(e)) return [e].concat(r);
        var o = e;
        return fn(e) && !fn(r) && (o = pn(e, n)), fn(e) && fn(r) ? (r.forEach(function (r, o) {
          if (sn.call(e, o)) {
            var a = e[o];
            a && "object" === l.default(a) && r && "object" === l.default(r) ? e[o] = t(a, r, n) : e.push(r);
          } else e[o] = r;
        }), e) : Object.keys(r).reduce(function (e, o) {
          var a = r[o];
          return sn.call(e, o) ? e[o] = t(e[o], a, n) : e[o] = a, e;
        }, o);
      }
    },
    hn = function hn() {
      var t,
        e,
        r,
        n = {
          assert: function assert(t) {
            if (!n.has(t)) throw new Jr("Side channel does not contain " + Wr(t));
          },
          get: function get(n) {
            if (Zr && n && ("object" === l.default(n) || "function" == typeof n)) {
              if (t) return Hr(t, n);
            } else if (Vr) {
              if (e) return Kr(e, n);
            } else if (r) return function (t, e) {
              var r = rn(t, e);
              return r && r.value;
            }(r, n);
          },
          has: function has(n) {
            if (Zr && n && ("object" === l.default(n) || "function" == typeof n)) {
              if (t) return Xr(t, n);
            } else if (Vr) {
              if (e) return en(e, n);
            } else if (r) return function (t, e) {
              return !!rn(t, e);
            }(r, n);
            return !1;
          },
          set: function set(n, o) {
            Zr && n && ("object" === l.default(n) || "function" == typeof n) ? (t || (t = new Zr()), Qr(t, n, o)) : Vr ? (e || (e = new Vr()), tn(e, n, o)) : (r || (r = {
              key: {},
              next: null
            }), function (t, e, r) {
              var n = rn(t, e);
              n ? n.value = r : t.next = {
                key: e,
                next: t.next,
                value: r
              };
            }(r, n, o));
          }
        };
      return n;
    },
    yn = dn,
    vn = un,
    gn = Object.prototype.hasOwnProperty,
    bn = {
      brackets: function brackets(t) {
        return t + "[]";
      },
      comma: "comma",
      indices: function indices(t, e) {
        return t + "[" + e + "]";
      },
      repeat: function repeat(t) {
        return t;
      }
    },
    mn = Array.isArray,
    wn = String.prototype.split,
    jn = Array.prototype.push,
    xn = function xn(t, e) {
      jn.apply(t, mn(e) ? e : [e]);
    },
    On = Date.prototype.toISOString,
    _n = vn.default,
    Sn = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: yn.encode,
      encodeValuesOnly: !1,
      format: _n,
      formatter: vn.formatters[_n],
      indices: !1,
      serializeDate: function serializeDate(t) {
        return On.call(t);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
    An = {},
    kn = function t(e, r, n, o, a, i, u, c, s, f, p, d, h, y, v) {
      for (var g = e, b = v, m = 0, w = !1; void 0 !== (b = b.get(An)) && !w;) {
        var j = b.get(e);
        if (m += 1, void 0 !== j) {
          if (j === m) throw new RangeError("Cyclic object value");
          w = !0;
        }
        void 0 === b.get(An) && (m = 0);
      }
      if ("function" == typeof u ? g = u(r, g) : g instanceof Date ? g = f(g) : "comma" === n && mn(g) && (g = yn.maybeMap(g, function (t) {
        return t instanceof Date ? f(t) : t;
      })), null === g) {
        if (o) return i && !h ? i(r, Sn.encoder, y, "key", p) : r;
        g = "";
      }
      if (function (t) {
        return "string" == typeof t || "number" == typeof t || "boolean" == typeof t || "symbol" === l.default(t) || "bigint" == typeof t;
      }(g) || yn.isBuffer(g)) {
        if (i) {
          var x = h ? r : i(r, Sn.encoder, y, "key", p);
          if ("comma" === n && h) {
            for (var O = wn.call(String(g), ","), _ = "", S = 0; S < O.length; ++S) {
              _ += (0 === S ? "" : ",") + d(i(O[S], Sn.encoder, y, "value", p));
            }
            return [d(x) + "=" + _];
          }
          return [d(x) + "=" + d(i(g, Sn.encoder, y, "value", p))];
        }
        return [d(r) + "=" + d(String(g))];
      }
      var A,
        k = [];
      if (void 0 === g) return k;
      if ("comma" === n && mn(g)) A = [{
        value: g.length > 0 ? g.join(",") || null : void 0
      }];else if (mn(u)) A = u;else {
        var E = Object.keys(g);
        A = c ? E.sort(c) : E;
      }
      for (var P = 0; P < A.length; ++P) {
        var C = A[P],
          R = "object" === l.default(C) && void 0 !== C.value ? C.value : g[C];
        if (!a || null !== R) {
          var I = mn(g) ? "function" == typeof n ? n(r, C) : r : r + (s ? "." + C : "[" + C + "]");
          v.set(e, m);
          var U = hn();
          U.set(An, v), xn(k, t(R, I, n, o, a, i, u, c, s, f, p, d, h, y, U));
        }
      }
      return k;
    },
    En = dn,
    Pn = Object.prototype.hasOwnProperty,
    Cn = Array.isArray,
    Rn = {
      allowDots: !1,
      allowPrototypes: !1,
      allowSparse: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: En.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
    In = function In(t) {
      return t.replace(/&#(\d+);/g, function (t, e) {
        return String.fromCharCode(parseInt(e, 10));
      });
    },
    Un = function Un(t, e) {
      return t && "string" == typeof t && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
    },
    Dn = function Dn(t, e, r, n) {
      if (t) {
        var o = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t,
          a = /(\[[^[\]]*])/g,
          i = r.depth > 0 && /(\[[^[\]]*])/.exec(o),
          u = i ? o.slice(0, i.index) : o,
          c = [];
        if (u) {
          if (!r.plainObjects && Pn.call(Object.prototype, u) && !r.allowPrototypes) return;
          c.push(u);
        }
        for (var s = 0; r.depth > 0 && null !== (i = a.exec(o)) && s < r.depth;) {
          if (s += 1, !r.plainObjects && Pn.call(Object.prototype, i[1].slice(1, -1)) && !r.allowPrototypes) return;
          c.push(i[1]);
        }
        return i && c.push("[" + o.slice(i.index) + "]"), function (t, e, r, n) {
          for (var o = n ? e : Un(e, r), a = t.length - 1; a >= 0; --a) {
            var i,
              u = t[a];
            if ("[]" === u && r.parseArrays) i = [].concat(o);else {
              i = r.plainObjects ? Object.create(null) : {};
              var c = "[" === u.charAt(0) && "]" === u.charAt(u.length - 1) ? u.slice(1, -1) : u,
                s = parseInt(c, 10);
              r.parseArrays || "" !== c ? !isNaN(s) && u !== c && String(s) === c && s >= 0 && r.parseArrays && s <= r.arrayLimit ? (i = [])[s] = o : "__proto__" !== c && (i[c] = o) : i = {
                0: o
              };
            }
            o = i;
          }
          return o;
        }(c, e, r, n);
      }
    },
    Tn = function Tn(t, e) {
      var r,
        n = t,
        o = function (t) {
          if (!t) return Sn;
          if (null !== t.encoder && void 0 !== t.encoder && "function" != typeof t.encoder) throw new TypeError("Encoder has to be a function.");
          var e = t.charset || Sn.charset;
          if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var r = vn.default;
          if (void 0 !== t.format) {
            if (!gn.call(vn.formatters, t.format)) throw new TypeError("Unknown format option provided.");
            r = t.format;
          }
          var n = vn.formatters[r],
            o = Sn.filter;
          return ("function" == typeof t.filter || mn(t.filter)) && (o = t.filter), {
            addQueryPrefix: "boolean" == typeof t.addQueryPrefix ? t.addQueryPrefix : Sn.addQueryPrefix,
            allowDots: void 0 === t.allowDots ? Sn.allowDots : !!t.allowDots,
            charset: e,
            charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : Sn.charsetSentinel,
            delimiter: void 0 === t.delimiter ? Sn.delimiter : t.delimiter,
            encode: "boolean" == typeof t.encode ? t.encode : Sn.encode,
            encoder: "function" == typeof t.encoder ? t.encoder : Sn.encoder,
            encodeValuesOnly: "boolean" == typeof t.encodeValuesOnly ? t.encodeValuesOnly : Sn.encodeValuesOnly,
            filter: o,
            format: r,
            formatter: n,
            serializeDate: "function" == typeof t.serializeDate ? t.serializeDate : Sn.serializeDate,
            skipNulls: "boolean" == typeof t.skipNulls ? t.skipNulls : Sn.skipNulls,
            sort: "function" == typeof t.sort ? t.sort : null,
            strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : Sn.strictNullHandling
          };
        }(e);
      "function" == typeof o.filter ? n = (0, o.filter)("", n) : mn(o.filter) && (r = o.filter);
      var a,
        i = [];
      if ("object" !== l.default(n) || null === n) return "";
      a = e && e.arrayFormat in bn ? e.arrayFormat : e && "indices" in e ? e.indices ? "indices" : "repeat" : "indices";
      var u = bn[a];
      r || (r = Object.keys(n)), o.sort && r.sort(o.sort);
      for (var c = hn(), s = 0; s < r.length; ++s) {
        var f = r[s];
        o.skipNulls && null === n[f] || xn(i, kn(n[f], f, u, o.strictNullHandling, o.skipNulls, o.encode ? o.encoder : null, o.filter, o.sort, o.allowDots, o.serializeDate, o.format, o.formatter, o.encodeValuesOnly, o.charset, c));
      }
      var p = i.join(o.delimiter),
        d = !0 === o.addQueryPrefix ? "?" : "";
      return o.charsetSentinel && ("iso-8859-1" === o.charset ? d += "utf8=%26%2310003%3B&" : d += "utf8=%E2%9C%93&"), p.length > 0 ? d + p : "";
    },
    Mn = function Mn(t, e) {
      var r = function (t) {
        if (!t) return Rn;
        if (null !== t.decoder && void 0 !== t.decoder && "function" != typeof t.decoder) throw new TypeError("Decoder has to be a function.");
        if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var e = void 0 === t.charset ? Rn.charset : t.charset;
        return {
          allowDots: void 0 === t.allowDots ? Rn.allowDots : !!t.allowDots,
          allowPrototypes: "boolean" == typeof t.allowPrototypes ? t.allowPrototypes : Rn.allowPrototypes,
          allowSparse: "boolean" == typeof t.allowSparse ? t.allowSparse : Rn.allowSparse,
          arrayLimit: "number" == typeof t.arrayLimit ? t.arrayLimit : Rn.arrayLimit,
          charset: e,
          charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : Rn.charsetSentinel,
          comma: "boolean" == typeof t.comma ? t.comma : Rn.comma,
          decoder: "function" == typeof t.decoder ? t.decoder : Rn.decoder,
          delimiter: "string" == typeof t.delimiter || En.isRegExp(t.delimiter) ? t.delimiter : Rn.delimiter,
          depth: "number" == typeof t.depth || !1 === t.depth ? +t.depth : Rn.depth,
          ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
          interpretNumericEntities: "boolean" == typeof t.interpretNumericEntities ? t.interpretNumericEntities : Rn.interpretNumericEntities,
          parameterLimit: "number" == typeof t.parameterLimit ? t.parameterLimit : Rn.parameterLimit,
          parseArrays: !1 !== t.parseArrays,
          plainObjects: "boolean" == typeof t.plainObjects ? t.plainObjects : Rn.plainObjects,
          strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : Rn.strictNullHandling
        };
      }(e);
      if ("" === t || null == t) return r.plainObjects ? Object.create(null) : {};
      for (var n = "string" == typeof t ? function (t, e) {
          var r,
            n = {},
            o = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t,
            a = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit,
            i = o.split(e.delimiter, a),
            u = -1,
            c = e.charset;
          if (e.charsetSentinel) for (r = 0; r < i.length; ++r) {
            0 === i[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === i[r] ? c = "utf-8" : "utf8=%26%2310003%3B" === i[r] && (c = "iso-8859-1"), u = r, r = i.length);
          }
          for (r = 0; r < i.length; ++r) {
            if (r !== u) {
              var s,
                f,
                l = i[r],
                p = l.indexOf("]="),
                d = -1 === p ? l.indexOf("=") : p + 1;
              -1 === d ? (s = e.decoder(l, Rn.decoder, c, "key"), f = e.strictNullHandling ? null : "") : (s = e.decoder(l.slice(0, d), Rn.decoder, c, "key"), f = En.maybeMap(Un(l.slice(d + 1), e), function (t) {
                return e.decoder(t, Rn.decoder, c, "value");
              })), f && e.interpretNumericEntities && "iso-8859-1" === c && (f = In(f)), l.indexOf("[]=") > -1 && (f = Cn(f) ? [f] : f), Pn.call(n, s) ? n[s] = En.combine(n[s], f) : n[s] = f;
            }
          }
          return n;
        }(t, r) : t, o = r.plainObjects ? Object.create(null) : {}, a = Object.keys(n), i = 0; i < a.length; ++i) {
        var u = a[i],
          c = Dn(u, n[u], r, "string" == typeof t);
        o = En.merge(o, c, r);
      }
      return !0 === r.allowSparse ? o : En.compact(o);
    },
    Nn = {
      formats: un,
      parse: Mn,
      stringify: Tn
    },
    zn = "object" == l.default(tt) && tt && tt.Object === Object && tt;
  module.exports = zn;
  var Ln = d(Object.freeze({
      __proto__: null
    })),
    Fn = Ln,
    Bn = "object" == ("undefined" == typeof self ? "undefined" : l.default(self)) && self && self.Object === Object && self,
    qn = Fn || Bn || Function("return this")(),
    $n = qn.Symbol,
    Yn = $n,
    Gn = Object.prototype,
    Wn = Gn.hasOwnProperty,
    Jn = Gn.toString,
    Zn = Yn ? Yn.toStringTag : void 0;
  var Vn = function Vn(t) {
      var e = Wn.call(t, Zn),
        r = t[Zn];
      try {
        t[Zn] = void 0;
        var n = !0;
      } catch (t) {}
      var o = Jn.call(t);
      return n && (e ? t[Zn] = r : delete t[Zn]), o;
    },
    Hn = Object.prototype.toString;
  var Qn = Vn,
    Xn = function Xn(t) {
      return Hn.call(t);
    },
    Kn = $n ? $n.toStringTag : void 0;
  var to = function to(t) {
    return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : Kn && Kn in Object(t) ? Qn(t) : Xn(t);
  };
  var eo = function eo(t) {
      var e = l.default(t);
      return null != t && ("object" == e || "function" == e);
    },
    ro = to,
    no = eo;
  var oo,
    ao = function ao(t) {
      if (!no(t)) return !1;
      var e = ro(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    },
    io = qn["__core-js_shared__"],
    uo = (oo = /[^.]+$/.exec(io && io.keys && io.keys.IE_PROTO || "")) ? "Symbol(src)_1." + oo : "";
  var co = function co(t) {
      return !!uo && uo in t;
    },
    so = Function.prototype.toString;
  var fo = function fo(t) {
      if (null != t) {
        try {
          return so.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    },
    lo = ao,
    po = co,
    ho = eo,
    yo = fo,
    vo = /^\[object .+?Constructor\]$/,
    go = Function.prototype,
    bo = Object.prototype,
    mo = go.toString,
    wo = bo.hasOwnProperty,
    jo = RegExp("^" + mo.call(wo).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var xo = function xo(t, e) {
      return null == t ? void 0 : t[e];
    },
    Oo = function Oo(t) {
      return !(!ho(t) || po(t)) && (lo(t) ? jo : vo).test(yo(t));
    },
    _o = xo;
  var So = function So(t, e) {
      var r = _o(t, e);
      return Oo(r) ? r : void 0;
    },
    Ao = So,
    ko = function () {
      try {
        var t = Ao(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();
  var Eo = function Eo(t, e, r) {
    "__proto__" == e && ko ? ko(t, e, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : t[e] = r;
  };
  var Po = function Po(t, e) {
      return t === e || t != t && e != e;
    },
    Co = Eo,
    Ro = Po,
    Io = Object.prototype.hasOwnProperty;
  var Uo = function Uo(t, e, r) {
      var n = t[e];
      Io.call(t, e) && Ro(n, r) && (void 0 !== r || e in t) || Co(t, e, r);
    },
    Do = Array.isArray;
  var To = function To(t) {
      return null != t && "object" == l.default(t);
    },
    Mo = to,
    No = To;
  var zo = function zo(t) {
      return "symbol" == l.default(t) || No(t) && "[object Symbol]" == Mo(t);
    },
    Lo = Do,
    Fo = zo,
    Bo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    qo = /^\w*$/;
  var $o = function $o(t, e) {
      if (Lo(t)) return !1;
      var r = l.default(t);
      return !("number" != r && "symbol" != r && "boolean" != r && null != t && !Fo(t)) || qo.test(t) || !Bo.test(t) || null != e && t in Object(e);
    },
    Yo = So(Object, "create"),
    Go = Yo;
  var Wo = function Wo() {
    this.__data__ = Go ? Go(null) : {}, this.size = 0;
  };
  var Jo = function Jo(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    },
    Zo = Yo,
    Vo = Object.prototype.hasOwnProperty;
  var Ho = function Ho(t) {
      var e = this.__data__;
      if (Zo) {
        var r = e[t];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
      }
      return Vo.call(e, t) ? e[t] : void 0;
    },
    Qo = Yo,
    Xo = Object.prototype.hasOwnProperty;
  var Ko = Yo;
  var ta = Wo,
    ea = Jo,
    ra = Ho,
    na = function na(t) {
      var e = this.__data__;
      return Qo ? void 0 !== e[t] : Xo.call(e, t);
    },
    oa = function oa(t, e) {
      var r = this.__data__;
      return this.size += this.has(t) ? 0 : 1, r[t] = Ko && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
  function aa(t) {
    var e = -1,
      r = null == t ? 0 : t.length;
    for (this.clear(); ++e < r;) {
      var n = t[e];
      this.set(n[0], n[1]);
    }
  }
  aa.prototype.clear = ta, aa.prototype.delete = ea, aa.prototype.get = ra, aa.prototype.has = na, aa.prototype.set = oa;
  var ia = aa;
  var ua = function ua() {
      this.__data__ = [], this.size = 0;
    },
    ca = Po;
  var sa = function sa(t, e) {
      for (var r = t.length; r--;) {
        if (ca(t[r][0], e)) return r;
      }
      return -1;
    },
    fa = sa,
    la = Array.prototype.splice;
  var pa = sa;
  var da = sa;
  var ha = sa;
  var ya = ua,
    va = function va(t) {
      var e = this.__data__,
        r = fa(e, t);
      return !(r < 0) && (r == e.length - 1 ? e.pop() : la.call(e, r, 1), --this.size, !0);
    },
    ga = function ga(t) {
      var e = this.__data__,
        r = pa(e, t);
      return r < 0 ? void 0 : e[r][1];
    },
    ba = function ba(t) {
      return da(this.__data__, t) > -1;
    },
    ma = function ma(t, e) {
      var r = this.__data__,
        n = ha(r, t);
      return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
    };
  function wa(t) {
    var e = -1,
      r = null == t ? 0 : t.length;
    for (this.clear(); ++e < r;) {
      var n = t[e];
      this.set(n[0], n[1]);
    }
  }
  wa.prototype.clear = ya, wa.prototype.delete = va, wa.prototype.get = ga, wa.prototype.has = ba, wa.prototype.set = ma;
  var ja = wa,
    xa = So(qn, "Map"),
    Oa = ia,
    _a = ja,
    Sa = xa;
  var Aa = function Aa(t) {
    var e = l.default(t);
    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
  };
  var ka = function ka(t, e) {
      var r = t.__data__;
      return Aa(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
    },
    Ea = ka;
  var Pa = ka;
  var Ca = ka;
  var Ra = ka;
  var Ia = function Ia() {
      this.size = 0, this.__data__ = {
        hash: new Oa(),
        map: new (Sa || _a)(),
        string: new Oa()
      };
    },
    Ua = function Ua(t) {
      var e = Ea(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    },
    Da = function Da(t) {
      return Pa(this, t).get(t);
    },
    Ta = function Ta(t) {
      return Ca(this, t).has(t);
    },
    Ma = function Ma(t, e) {
      var r = Ra(this, t),
        n = r.size;
      return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
    };
  function Na(t) {
    var e = -1,
      r = null == t ? 0 : t.length;
    for (this.clear(); ++e < r;) {
      var n = t[e];
      this.set(n[0], n[1]);
    }
  }
  Na.prototype.clear = Ia, Na.prototype.delete = Ua, Na.prototype.get = Da, Na.prototype.has = Ta, Na.prototype.set = Ma;
  var za = Na,
    La = za;
  function Fa(t, e) {
    if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
    var r = function r() {
      var n = arguments,
        o = e ? e.apply(this, n) : n[0],
        a = r.cache;
      if (a.has(o)) return a.get(o);
      var i = t.apply(this, n);
      return r.cache = a.set(o, i) || a, i;
    };
    return r.cache = new (Fa.Cache || La)(), r;
  }
  Fa.Cache = La;
  var Ba = Fa;
  var qa = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    $a = /\\(\\)?/g,
    Ya = function (t) {
      var e = Ba(t, function (t) {
          return 500 === r.size && r.clear(), t;
        }),
        r = e.cache;
      return e;
    }(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(qa, function (t, r, n, o) {
        e.push(n ? o.replace($a, "$1") : r || t);
      }), e;
    }),
    Ga = Ya;
  var Wa = function Wa(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;) {
        o[r] = e(t[r], r, t);
      }
      return o;
    },
    Ja = Wa,
    Za = Do,
    Va = zo,
    Ha = $n ? $n.prototype : void 0,
    Qa = Ha ? Ha.toString : void 0;
  var Xa = function t(e) {
      if ("string" == typeof e) return e;
      if (Za(e)) return Ja(e, t) + "";
      if (Va(e)) return Qa ? Qa.call(e) : "";
      var r = e + "";
      return "0" == r && 1 / e == -Infinity ? "-0" : r;
    },
    Ka = Xa;
  var ti = function ti(t) {
      return null == t ? "" : Ka(t);
    },
    ei = Do,
    ri = $o,
    ni = Ga,
    oi = ti;
  var ai = function ai(t, e) {
      return ei(t) ? t : ri(t, e) ? [t] : ni(oi(t));
    },
    ii = /^(?:0|[1-9]\d*)$/;
  var ui = function ui(t, e) {
      var r = l.default(t);
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == r || "symbol" != r && ii.test(t)) && t > -1 && t % 1 == 0 && t < e;
    },
    ci = zo;
  var si = function si(t) {
      if ("string" == typeof t || ci(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -Infinity ? "-0" : e;
    },
    fi = Uo,
    li = ai,
    pi = ui,
    di = eo,
    hi = si;
  var yi = function yi(t, e, r, n) {
      if (!di(t)) return t;
      for (var o = -1, a = (e = li(e, t)).length, i = a - 1, u = t; null != u && ++o < a;) {
        var c = hi(e[o]),
          s = r;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;
        if (o != i) {
          var f = u[c];
          void 0 === (s = n ? n(f, c, u) : void 0) && (s = di(f) ? f : pi(e[o + 1]) ? [] : {});
        }
        fi(u, c, s), u = u[c];
      }
      return t;
    },
    vi = yi;
  var gi = function gi(t, e, r) {
      return null == t ? t : vi(t, e, r);
    },
    bi = ai,
    mi = si;
  var wi = function wi(t, e) {
      for (var r = 0, n = (e = bi(e, t)).length; null != t && r < n;) {
        t = t[mi(e[r++])];
      }
      return r && r == n ? t : void 0;
    },
    ji = wi;
  var xi = function xi(t, e, r) {
    var n = null == t ? void 0 : ji(t, e);
    return void 0 === n ? r : n;
  };
  var Oi = za,
    _i = function _i(t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    },
    Si = function Si(t) {
      return this.__data__.has(t);
    };
  function Ai(t) {
    var e = -1,
      r = null == t ? 0 : t.length;
    for (this.__data__ = new Oi(); ++e < r;) {
      this.add(t[e]);
    }
  }
  Ai.prototype.add = Ai.prototype.push = _i, Ai.prototype.has = Si;
  var ki = Ai;
  var Ei = function Ei(t, e, r, n) {
    for (var o = t.length, a = r + (n ? 1 : -1); n ? a-- : ++a < o;) {
      if (e(t[a], a, t)) return a;
    }
    return -1;
  };
  var Pi = Ei,
    Ci = function Ci(t) {
      return t != t;
    },
    Ri = function Ri(t, e, r) {
      for (var n = r - 1, o = t.length; ++n < o;) {
        if (t[n] === e) return n;
      }
      return -1;
    };
  var Ii = function Ii(t, e, r) {
    return e == e ? Ri(t, e, r) : Pi(t, Ci, r);
  };
  var Ui = function Ui(t, e) {
    return !!(null == t ? 0 : t.length) && Ii(t, e, 0) > -1;
  };
  var Di = function Di(t, e, r) {
    for (var n = -1, o = null == t ? 0 : t.length; ++n < o;) {
      if (r(e, t[n])) return !0;
    }
    return !1;
  };
  var Ti = function Ti(t, e) {
      return t.has(e);
    },
    Mi = So(qn, "Set");
  var Ni = function Ni(t) {
      var e = -1,
        r = Array(t.size);
      return t.forEach(function (t) {
        r[++e] = t;
      }), r;
    },
    zi = Mi,
    Li = function Li() {},
    Fi = zi && 1 / Ni(new zi([, -0]))[1] == 1 / 0 ? function (t) {
      return new zi(t);
    } : Li,
    Bi = ki,
    qi = Ui,
    $i = Di,
    Yi = Ti,
    Gi = Fi,
    Wi = Ni;
  var Ji = function Ji(t, e, r) {
      var n = -1,
        o = qi,
        a = t.length,
        i = !0,
        u = [],
        c = u;
      if (r) i = !1, o = $i;else if (a >= 200) {
        var s = e ? null : Gi(t);
        if (s) return Wi(s);
        i = !1, o = Yi, c = new Bi();
      } else c = e ? [] : u;
      t: for (; ++n < a;) {
        var f = t[n],
          l = e ? e(f) : f;
        if (f = r || 0 !== f ? f : 0, i && l == l) {
          for (var p = c.length; p--;) {
            if (c[p] === l) continue t;
          }
          e && c.push(l), u.push(f);
        } else o(c, l, r) || (c !== u && c.push(l), u.push(f));
      }
      return u;
    },
    Zi = Ji;
  var Vi = function Vi(t) {
      return t && t.length ? Zi(t) : [];
    },
    Hi = ja;
  var Qi = ja,
    Xi = xa,
    Ki = za;
  var tu = ja,
    eu = function eu() {
      this.__data__ = new Hi(), this.size = 0;
    },
    ru = function ru(t) {
      var e = this.__data__,
        r = e.delete(t);
      return this.size = e.size, r;
    },
    nu = function nu(t) {
      return this.__data__.get(t);
    },
    ou = function ou(t) {
      return this.__data__.has(t);
    },
    au = function au(t, e) {
      var r = this.__data__;
      if (r instanceof Qi) {
        var n = r.__data__;
        if (!Xi || n.length < 199) return n.push([t, e]), this.size = ++r.size, this;
        r = this.__data__ = new Ki(n);
      }
      return r.set(t, e), this.size = r.size, this;
    };
  function iu(t) {
    var e = this.__data__ = new tu(t);
    this.size = e.size;
  }
  iu.prototype.clear = eu, iu.prototype.delete = ru, iu.prototype.get = nu, iu.prototype.has = ou, iu.prototype.set = au;
  var uu = iu;
  var cu = ki,
    su = function su(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length; ++r < n;) {
        if (e(t[r], r, t)) return !0;
      }
      return !1;
    },
    fu = Ti;
  var lu = function lu(t, e, r, n, o, a) {
      var i = 1 & r,
        u = t.length,
        c = e.length;
      if (u != c && !(i && c > u)) return !1;
      var s = a.get(t),
        f = a.get(e);
      if (s && f) return s == e && f == t;
      var l = -1,
        p = !0,
        d = 2 & r ? new cu() : void 0;
      for (a.set(t, e), a.set(e, t); ++l < u;) {
        var h = t[l],
          y = e[l];
        if (n) var v = i ? n(y, h, l, e, t, a) : n(h, y, l, t, e, a);
        if (void 0 !== v) {
          if (v) continue;
          p = !1;
          break;
        }
        if (d) {
          if (!su(e, function (t, e) {
            if (!fu(d, e) && (h === t || o(h, t, r, n, a))) return d.push(e);
          })) {
            p = !1;
            break;
          }
        } else if (h !== y && !o(h, y, r, n, a)) {
          p = !1;
          break;
        }
      }
      return a.delete(t), a.delete(e), p;
    },
    pu = qn.Uint8Array;
  var du = function du(t) {
      var e = -1,
        r = Array(t.size);
      return t.forEach(function (t, n) {
        r[++e] = [n, t];
      }), r;
    },
    hu = pu,
    yu = Po,
    vu = lu,
    gu = du,
    bu = Ni,
    mu = $n ? $n.prototype : void 0,
    wu = mu ? mu.valueOf : void 0;
  var ju = function ju(t, e, r, n, o, a, i) {
    switch (r) {
      case "[object DataView]":
        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
        t = t.buffer, e = e.buffer;
      case "[object ArrayBuffer]":
        return !(t.byteLength != e.byteLength || !a(new hu(t), new hu(e)));
      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return yu(+t, +e);
      case "[object Error]":
        return t.name == e.name && t.message == e.message;
      case "[object RegExp]":
      case "[object String]":
        return t == e + "";
      case "[object Map]":
        var u = gu;
      case "[object Set]":
        var c = 1 & n;
        if (u || (u = bu), t.size != e.size && !c) return !1;
        var s = i.get(t);
        if (s) return s == e;
        n |= 2, i.set(t, e);
        var f = vu(u(t), u(e), n, o, a, i);
        return i.delete(t), f;
      case "[object Symbol]":
        if (wu) return wu.call(t) == wu.call(e);
    }
    return !1;
  };
  var xu = function xu(t, e) {
      for (var r = -1, n = e.length, o = t.length; ++r < n;) {
        t[o + r] = e[r];
      }
      return t;
    },
    Ou = xu,
    _u = Do;
  var Su = function Su(t, e, r) {
    var n = e(t);
    return _u(t) ? n : Ou(n, r(t));
  };
  var Au = function Au() {
      return [];
    },
    ku = function ku(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length, o = 0, a = []; ++r < n;) {
        var i = t[r];
        e(i, r, t) && (a[o++] = i);
      }
      return a;
    },
    Eu = Au,
    Pu = Object.prototype.propertyIsEnumerable,
    Cu = Object.getOwnPropertySymbols,
    Ru = Cu ? function (t) {
      return null == t ? [] : (t = Object(t), ku(Cu(t), function (e) {
        return Pu.call(t, e);
      }));
    } : Eu,
    Iu = Ru;
  var Uu = function Uu(t, e) {
      for (var r = -1, n = Array(t); ++r < t;) {
        n[r] = e(r);
      }
      return n;
    },
    Du = to,
    Tu = To;
  var Mu = function Mu(t) {
      return Tu(t) && "[object Arguments]" == Du(t);
    },
    Nu = To,
    zu = Object.prototype,
    Lu = zu.hasOwnProperty,
    Fu = zu.propertyIsEnumerable,
    Bu = Mu(function () {
      return arguments;
    }()) ? Mu : function (t) {
      return Nu(t) && Lu.call(t, "callee") && !Fu.call(t, "callee");
    },
    qu = Bu,
    $u = {
      exports: {}
    };
  var Yu = function Yu() {
    return !1;
  };
  !function (t, e) {
    var r = qn,
      n = Yu,
      o = e && !e.nodeType && e,
      a = o && t && !t.nodeType && t,
      i = a && a.exports === o ? r.Buffer : void 0,
      u = (i ? i.isBuffer : void 0) || n;
    t.exports = u;
  }($u, $u.exports);
  var Gu = function Gu(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    },
    Wu = to,
    Ju = Gu,
    Zu = To,
    Vu = {};
  Vu["[object Float32Array]"] = Vu["[object Float64Array]"] = Vu["[object Int8Array]"] = Vu["[object Int16Array]"] = Vu["[object Int32Array]"] = Vu["[object Uint8Array]"] = Vu["[object Uint8ClampedArray]"] = Vu["[object Uint16Array]"] = Vu["[object Uint32Array]"] = !0, Vu["[object Arguments]"] = Vu["[object Array]"] = Vu["[object ArrayBuffer]"] = Vu["[object Boolean]"] = Vu["[object DataView]"] = Vu["[object Date]"] = Vu["[object Error]"] = Vu["[object Function]"] = Vu["[object Map]"] = Vu["[object Number]"] = Vu["[object Object]"] = Vu["[object RegExp]"] = Vu["[object Set]"] = Vu["[object String]"] = Vu["[object WeakMap]"] = !1;
  var Hu = function Hu(t) {
    return Zu(t) && Ju(t.length) && !!Vu[Wu(t)];
  };
  var Qu = function Qu(t) {
      return function (e) {
        return t(e);
      };
    },
    Xu = {
      exports: {}
    };
  !function (t, e) {
    var r = Ln,
      n = e && !e.nodeType && e,
      o = n && t && !t.nodeType && t,
      a = o && o.exports === n && r.process,
      i = function () {
        try {
          var t = o && o.require && o.require("util").types;
          return t || a && a.binding && a.binding("util");
        } catch (t) {}
      }();
    t.exports = i;
  }(Xu, Xu.exports);
  var Ku = Hu,
    tc = Qu,
    ec = Xu.exports,
    rc = ec && ec.isTypedArray,
    nc = rc ? tc(rc) : Ku,
    oc = Uu,
    ac = qu,
    ic = Do,
    uc = $u.exports,
    cc = ui,
    sc = nc,
    fc = Object.prototype.hasOwnProperty;
  var lc = function lc(t, e) {
      var r = ic(t),
        n = !r && ac(t),
        o = !r && !n && uc(t),
        a = !r && !n && !o && sc(t),
        i = r || n || o || a,
        u = i ? oc(t.length, String) : [],
        c = u.length;
      for (var s in t) {
        !e && !fc.call(t, s) || i && ("length" == s || o && ("offset" == s || "parent" == s) || a && ("buffer" == s || "byteLength" == s || "byteOffset" == s) || cc(s, c)) || u.push(s);
      }
      return u;
    },
    pc = Object.prototype;
  var dc = function dc(t) {
    var e = t && t.constructor;
    return t === ("function" == typeof e && e.prototype || pc);
  };
  var hc = function hc(t, e) {
      return function (r) {
        return t(e(r));
      };
    },
    yc = hc(Object.keys, Object),
    vc = dc,
    gc = yc,
    bc = Object.prototype.hasOwnProperty;
  var mc = function mc(t) {
      if (!vc(t)) return gc(t);
      var e = [];
      for (var r in Object(t)) {
        bc.call(t, r) && "constructor" != r && e.push(r);
      }
      return e;
    },
    wc = ao,
    jc = Gu;
  var xc = function xc(t) {
      return null != t && jc(t.length) && !wc(t);
    },
    Oc = lc,
    _c = mc,
    Sc = xc;
  var Ac = function Ac(t) {
      return Sc(t) ? Oc(t) : _c(t);
    },
    kc = Su,
    Ec = Iu,
    Pc = Ac;
  var Cc = function Cc(t) {
      return kc(t, Pc, Ec);
    },
    Rc = Cc,
    Ic = Object.prototype.hasOwnProperty;
  var Uc = function Uc(t, e, r, n, o, a) {
      var i = 1 & r,
        u = Rc(t),
        c = u.length;
      if (c != Rc(e).length && !i) return !1;
      for (var s = c; s--;) {
        var f = u[s];
        if (!(i ? f in e : Ic.call(e, f))) return !1;
      }
      var l = a.get(t),
        p = a.get(e);
      if (l && p) return l == e && p == t;
      var d = !0;
      a.set(t, e), a.set(e, t);
      for (var h = i; ++s < c;) {
        var y = t[f = u[s]],
          v = e[f];
        if (n) var g = i ? n(v, y, f, e, t, a) : n(y, v, f, t, e, a);
        if (!(void 0 === g ? y === v || o(y, v, r, n, a) : g)) {
          d = !1;
          break;
        }
        h || (h = "constructor" == f);
      }
      if (d && !h) {
        var b = t.constructor,
          m = e.constructor;
        b == m || !("constructor" in t) || !("constructor" in e) || "function" == typeof b && b instanceof b && "function" == typeof m && m instanceof m || (d = !1);
      }
      return a.delete(t), a.delete(e), d;
    },
    Dc = So(qn, "DataView"),
    Tc = xa,
    Mc = So(qn, "Promise"),
    Nc = Mi,
    zc = So(qn, "WeakMap"),
    Lc = to,
    Fc = fo,
    Bc = "[object Map]",
    qc = "[object Promise]",
    $c = "[object Set]",
    Yc = "[object WeakMap]",
    Gc = "[object DataView]",
    Wc = Fc(Dc),
    Jc = Fc(Tc),
    Zc = Fc(Mc),
    Vc = Fc(Nc),
    Hc = Fc(zc),
    Qc = Lc;
  (Dc && Qc(new Dc(new ArrayBuffer(1))) != Gc || Tc && Qc(new Tc()) != Bc || Mc && Qc(Mc.resolve()) != qc || Nc && Qc(new Nc()) != $c || zc && Qc(new zc()) != Yc) && (Qc = function Qc(t) {
    var e = Lc(t),
      r = "[object Object]" == e ? t.constructor : void 0,
      n = r ? Fc(r) : "";
    if (n) switch (n) {
      case Wc:
        return Gc;
      case Jc:
        return Bc;
      case Zc:
        return qc;
      case Vc:
        return $c;
      case Hc:
        return Yc;
    }
    return e;
  });
  var Xc = Qc,
    Kc = uu,
    ts = lu,
    es = ju,
    rs = Uc,
    ns = Xc,
    os = Do,
    as = $u.exports,
    is = nc,
    us = "[object Arguments]",
    cs = "[object Array]",
    ss = "[object Object]",
    fs = Object.prototype.hasOwnProperty;
  var ls = function ls(t, e, r, n, o, a) {
      var i = os(t),
        u = os(e),
        c = i ? cs : ns(t),
        s = u ? cs : ns(e),
        f = (c = c == us ? ss : c) == ss,
        l = (s = s == us ? ss : s) == ss,
        p = c == s;
      if (p && as(t)) {
        if (!as(e)) return !1;
        i = !0, f = !1;
      }
      if (p && !f) return a || (a = new Kc()), i || is(t) ? ts(t, e, r, n, o, a) : es(t, e, c, r, n, o, a);
      if (!(1 & r)) {
        var d = f && fs.call(t, "__wrapped__"),
          h = l && fs.call(e, "__wrapped__");
        if (d || h) {
          var y = d ? t.value() : t,
            v = h ? e.value() : e;
          return a || (a = new Kc()), o(y, v, r, n, a);
        }
      }
      return !!p && (a || (a = new Kc()), rs(t, e, r, n, o, a));
    },
    ps = ls,
    ds = To;
  var hs = function t(e, r, n, o, a) {
      return e === r || (null == e || null == r || !ds(e) && !ds(r) ? e != e && r != r : ps(e, r, n, o, t, a));
    },
    ys = uu,
    vs = hs;
  var gs = function gs(t, e, r, n) {
      var o = r.length,
        a = o,
        i = !n;
      if (null == t) return !a;
      for (t = Object(t); o--;) {
        var u = r[o];
        if (i && u[2] ? u[1] !== t[u[0]] : !(u[0] in t)) return !1;
      }
      for (; ++o < a;) {
        var c = (u = r[o])[0],
          s = t[c],
          f = u[1];
        if (i && u[2]) {
          if (void 0 === s && !(c in t)) return !1;
        } else {
          var l = new ys();
          if (n) var p = n(s, f, c, t, e, l);
          if (!(void 0 === p ? vs(f, s, 3, n, l) : p)) return !1;
        }
      }
      return !0;
    },
    bs = eo;
  var ms = function ms(t) {
      return t == t && !bs(t);
    },
    ws = ms,
    js = Ac;
  var xs = function xs(t) {
    for (var e = js(t), r = e.length; r--;) {
      var n = e[r],
        o = t[n];
      e[r] = [n, o, ws(o)];
    }
    return e;
  };
  var Os = function Os(t, e) {
      return function (r) {
        return null != r && r[t] === e && (void 0 !== e || t in Object(r));
      };
    },
    _s = gs,
    Ss = xs,
    As = Os;
  var ks = function ks(t) {
    var e = Ss(t);
    return 1 == e.length && e[0][2] ? As(e[0][0], e[0][1]) : function (r) {
      return r === t || _s(r, t, e);
    };
  };
  var Es = function Es(t, e) {
      return null != t && e in Object(t);
    },
    Ps = ai,
    Cs = qu,
    Rs = Do,
    Is = ui,
    Us = Gu,
    Ds = si;
  var Ts = function Ts(t, e, r) {
      for (var n = -1, o = (e = Ps(e, t)).length, a = !1; ++n < o;) {
        var i = Ds(e[n]);
        if (!(a = null != t && r(t, i))) break;
        t = t[i];
      }
      return a || ++n != o ? a : !!(o = null == t ? 0 : t.length) && Us(o) && Is(i, o) && (Rs(t) || Cs(t));
    },
    Ms = Es,
    Ns = Ts;
  var zs = function zs(t, e) {
      return null != t && Ns(t, e, Ms);
    },
    Ls = hs,
    Fs = xi,
    Bs = zs,
    qs = $o,
    $s = ms,
    Ys = Os,
    Gs = si;
  var Ws = function Ws(t, e) {
    return qs(t) && $s(e) ? Ys(Gs(t), e) : function (r) {
      var n = Fs(r, t);
      return void 0 === n && n === e ? Bs(r, t) : Ls(e, n, 3);
    };
  };
  var Js = function Js(t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    },
    Zs = wi;
  var Vs = function Vs(t) {
      return function (e) {
        return Zs(e, t);
      };
    },
    Hs = Js,
    Qs = Vs,
    Xs = $o,
    Ks = si;
  var tf = ks,
    ef = Ws,
    rf = function rf(t) {
      return t;
    },
    nf = Do,
    of = function of(t) {
      return Xs(t) ? Hs(Ks(t)) : Qs(t);
    };
  var af = function af(t) {
      return "function" == typeof t ? t : null == t ? rf : "object" == l.default(t) ? nf(t) ? ef(t[0], t[1]) : tf(t) : of(t);
    },
    uf = af,
    cf = xc,
    sf = Ac;
  var ff = function ff(t) {
      return function (e, r, n) {
        var o = Object(e);
        if (!cf(e)) {
          var a = uf(r);
          e = sf(e), r = function r(t) {
            return a(o[t], t, o);
          };
        }
        var i = t(e, r, n);
        return i > -1 ? o[a ? e[i] : i] : void 0;
      };
    },
    lf = /\s/;
  var pf = function pf(t) {
      for (var e = t.length; e-- && lf.test(t.charAt(e));) {
        ;
      }
      return e;
    },
    df = /^\s+/;
  var hf = function hf(t) {
      return t ? t.slice(0, pf(t) + 1).replace(df, "") : t;
    },
    yf = eo,
    vf = zo,
    gf = /^[-+]0x[0-9a-f]+$/i,
    bf = /^0b[01]+$/i,
    mf = /^0o[0-7]+$/i,
    wf = parseInt;
  var jf = function jf(t) {
      if ("number" == typeof t) return t;
      if (vf(t)) return NaN;
      if (yf(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = yf(e) ? e + "" : e;
      }
      if ("string" != typeof t) return 0 === t ? t : +t;
      t = hf(t);
      var r = bf.test(t);
      return r || mf.test(t) ? wf(t.slice(2), r ? 2 : 8) : gf.test(t) ? NaN : +t;
    },
    xf = jf,
    Of = 1 / 0;
  var _f = function _f(t) {
    return t ? (t = xf(t)) === Of || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
  };
  var Sf = function Sf(t) {
      var e = _f(t),
        r = e % 1;
      return e == e ? r ? e - r : e : 0;
    },
    Af = Ei,
    kf = af,
    Ef = Sf,
    Pf = Math.max;
  var Cf = ff(function (t, e, r) {
      var n = null == t ? 0 : t.length;
      if (!n) return -1;
      var o = null == r ? 0 : Ef(r);
      return o < 0 && (o = Pf(n + o, 0)), Af(t, kf(e), o);
    }),
    Rf = Sf,
    If = jf,
    Uf = ti,
    Df = qn.isFinite,
    Tf = Math.min;
  var Mf = function Mf(t) {
      var e = Math[t];
      return function (t, r) {
        if (t = If(t), (r = null == r ? 0 : Tf(Rf(r), 292)) && Df(t)) {
          var n = (Uf(t) + "e").split("e"),
            o = e(n[0] + "e" + (+n[1] + r));
          return +((n = (Uf(o) + "e").split("e"))[0] + "e" + (+n[1] - r));
        }
        return e(t);
      };
    },
    Nf = Mf("round");
  var zf = function zf(t, e, r) {
    var n = -1,
      o = t.length;
    e < 0 && (e = -e > o ? 0 : o + e), (r = r > o ? o : r) < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
    for (var a = Array(o); ++n < o;) {
      a[n] = t[n + e];
    }
    return a;
  };
  var Lf = function Lf(t, e, r) {
      var n = t.length;
      return r = void 0 === r ? n : r, !e && r >= n ? t : zf(t, e, r);
    },
    Ff = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
  var Bf = function Bf(t) {
    return Ff.test(t);
  };
  var qf = function qf(t) {
      return t.split("");
    },
    $f = "[\\ud800-\\udfff]",
    Yf = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
    Gf = "\\ud83c[\\udffb-\\udfff]",
    Wf = "[^\\ud800-\\udfff]",
    Jf = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Zf = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    Vf = "(?:" + Yf + "|" + Gf + ")" + "?",
    Hf = "[\\ufe0e\\ufe0f]?",
    Qf = Hf + Vf + ("(?:\\u200d(?:" + [Wf, Jf, Zf].join("|") + ")" + Hf + Vf + ")*"),
    Xf = "(?:" + [Wf + Yf + "?", Yf, Jf, Zf, $f].join("|") + ")",
    Kf = RegExp(Gf + "(?=" + Gf + ")|" + Xf + Qf, "g");
  var tl = qf,
    el = Bf,
    rl = function rl(t) {
      return t.match(Kf) || [];
    };
  var nl = Lf,
    ol = Bf,
    al = function al(t) {
      return el(t) ? rl(t) : tl(t);
    },
    il = ti;
  var ul = function ul(t) {
      return function (e) {
        e = il(e);
        var r = ol(e) ? al(e) : void 0,
          n = r ? r[0] : e.charAt(0),
          o = r ? nl(r, 1).join("") : e.slice(1);
        return n[t]() + o;
      };
    },
    cl = ul("toUpperCase"),
    sl = ti,
    fl = cl;
  var ll = function ll(t) {
    return fl(sl(t).toLowerCase());
  };
  var pl = function pl(t, e, r, n) {
    var o = -1,
      a = null == t ? 0 : t.length;
    for (n && a && (r = t[++o]); ++o < a;) {
      r = e(r, t[o], o, t);
    }
    return r;
  };
  var dl = function dl(t) {
      return function (e) {
        return null == t ? void 0 : t[e];
      };
    },
    hl = dl({
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    }),
    yl = ti,
    vl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    gl = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
  var bl = function bl(t) {
      return (t = yl(t)) && t.replace(vl, hl).replace(gl, "");
    },
    ml = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  var wl = function wl(t) {
      return t.match(ml) || [];
    },
    jl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  var xl = function xl(t) {
      return jl.test(t);
    },
    Ol = "\\u2700-\\u27bf",
    _l = "a-z\\xdf-\\xf6\\xf8-\\xff",
    Sl = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    Al = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    kl = "[" + Al + "]",
    El = "\\d+",
    Pl = "[\\u2700-\\u27bf]",
    Cl = "[" + _l + "]",
    Rl = "[^\\ud800-\\udfff" + Al + El + Ol + _l + Sl + "]",
    Il = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Ul = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    Dl = "[" + Sl + "]",
    Tl = "(?:" + Cl + "|" + Rl + ")",
    Ml = "(?:" + Dl + "|" + Rl + ")",
    Nl = "(?:['’](?:d|ll|m|re|s|t|ve))?",
    zl = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
    Ll = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
    Fl = "[\\ufe0e\\ufe0f]?",
    Bl = Fl + Ll + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", Il, Ul].join("|") + ")" + Fl + Ll + ")*"),
    ql = "(?:" + [Pl, Il, Ul].join("|") + ")" + Bl,
    $l = RegExp([Dl + "?" + Cl + "+" + Nl + "(?=" + [kl, Dl, "$"].join("|") + ")", Ml + "+" + zl + "(?=" + [kl, Dl + Tl, "$"].join("|") + ")", Dl + "?" + Tl + "+" + Nl, Dl + "+" + zl, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", El, ql].join("|"), "g");
  var Yl = wl,
    Gl = xl,
    Wl = ti,
    Jl = function Jl(t) {
      return t.match($l) || [];
    };
  var Zl = pl,
    Vl = bl,
    Hl = function Hl(t, e, r) {
      return t = Wl(t), void 0 === (e = r ? void 0 : e) ? Gl(t) ? Jl(t) : Yl(t) : t.match(e) || [];
    },
    Ql = RegExp("['’]", "g");
  var Xl = function Xl(t) {
      return function (e) {
        return Zl(Hl(Vl(e).replace(Ql, "")), t, "");
      };
    },
    Kl = ll,
    tp = Xl(function (t, e, r) {
      return e = e.toLowerCase(), t + (r ? Kl(e) : e);
    }),
    ep = Xl(function (t, e, r) {
      return t + (r ? "_" : "") + e.toLowerCase();
    });
  var rp = function rp(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r, t);) {
        ;
      }
      return t;
    },
    np = Uo,
    op = Eo;
  var ap = function ap(t, e, r, n) {
      var o = !r;
      r || (r = {});
      for (var a = -1, i = e.length; ++a < i;) {
        var u = e[a],
          c = n ? n(r[u], t[u], u, r, t) : void 0;
        void 0 === c && (c = t[u]), o ? op(r, u, c) : np(r, u, c);
      }
      return r;
    },
    ip = ap,
    up = Ac;
  var cp = function cp(t, e) {
    return t && ip(e, up(e), t);
  };
  var sp = function sp(t) {
      var e = [];
      if (null != t) for (var r in Object(t)) {
        e.push(r);
      }
      return e;
    },
    fp = eo,
    lp = dc,
    pp = sp,
    dp = Object.prototype.hasOwnProperty;
  var hp = function hp(t) {
      if (!fp(t)) return pp(t);
      var e = lp(t),
        r = [];
      for (var n in t) {
        ("constructor" != n || !e && dp.call(t, n)) && r.push(n);
      }
      return r;
    },
    yp = lc,
    vp = hp,
    gp = xc;
  var bp = function bp(t) {
      return gp(t) ? yp(t, !0) : vp(t);
    },
    mp = ap,
    wp = bp;
  var jp = function jp(t, e) {
      return t && mp(e, wp(e), t);
    },
    xp = {
      exports: {}
    };
  !function (t, e) {
    var r = qn,
      n = e && !e.nodeType && e,
      o = n && t && !t.nodeType && t,
      a = o && o.exports === n ? r.Buffer : void 0,
      i = a ? a.allocUnsafe : void 0;
    t.exports = function (t, e) {
      if (e) return t.slice();
      var r = t.length,
        n = i ? i(r) : new t.constructor(r);
      return t.copy(n), n;
    };
  }(xp, xp.exports);
  var Op = function Op(t, e) {
      var r = -1,
        n = t.length;
      for (e || (e = Array(n)); ++r < n;) {
        e[r] = t[r];
      }
      return e;
    },
    _p = ap,
    Sp = Iu;
  var Ap = function Ap(t, e) {
      return _p(t, Sp(t), e);
    },
    kp = hc(Object.getPrototypeOf, Object),
    Ep = xu,
    Pp = kp,
    Cp = Iu,
    Rp = Au,
    Ip = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        Ep(e, Cp(t)), t = Pp(t);
      }
      return e;
    } : Rp,
    Up = ap,
    Dp = Ip;
  var Tp = function Tp(t, e) {
      return Up(t, Dp(t), e);
    },
    Mp = Su,
    Np = Ip,
    zp = bp;
  var Lp = function Lp(t) {
      return Mp(t, zp, Np);
    },
    Fp = Object.prototype.hasOwnProperty;
  var Bp = function Bp(t) {
      var e = t.length,
        r = new t.constructor(e);
      return e && "string" == typeof t[0] && Fp.call(t, "index") && (r.index = t.index, r.input = t.input), r;
    },
    qp = pu;
  var $p = function $p(t) {
      var e = new t.constructor(t.byteLength);
      return new qp(e).set(new qp(t)), e;
    },
    Yp = $p;
  var Gp = function Gp(t, e) {
      var r = e ? Yp(t.buffer) : t.buffer;
      return new t.constructor(r, t.byteOffset, t.byteLength);
    },
    Wp = /\w*$/;
  var Jp = function Jp(t) {
      var e = new t.constructor(t.source, Wp.exec(t));
      return e.lastIndex = t.lastIndex, e;
    },
    Zp = $n ? $n.prototype : void 0,
    Vp = Zp ? Zp.valueOf : void 0;
  var Hp = $p;
  var Qp = $p,
    Xp = Gp,
    Kp = Jp,
    td = function td(t) {
      return Vp ? Object(Vp.call(t)) : {};
    },
    ed = function ed(t, e) {
      var r = e ? Hp(t.buffer) : t.buffer;
      return new t.constructor(r, t.byteOffset, t.length);
    };
  var rd = function rd(t, e, r) {
      var n = t.constructor;
      switch (e) {
        case "[object ArrayBuffer]":
          return Qp(t);
        case "[object Boolean]":
        case "[object Date]":
          return new n(+t);
        case "[object DataView]":
          return Xp(t, r);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return ed(t, r);
        case "[object Map]":
        case "[object Set]":
          return new n();
        case "[object Number]":
        case "[object String]":
          return new n(t);
        case "[object RegExp]":
          return Kp(t);
        case "[object Symbol]":
          return td(t);
      }
    },
    nd = eo,
    od = Object.create,
    ad = function () {
      function t() {}
      return function (e) {
        if (!nd(e)) return {};
        if (od) return od(e);
        t.prototype = e;
        var r = new t();
        return t.prototype = void 0, r;
      };
    }(),
    id = ad,
    ud = kp,
    cd = dc;
  var sd = function sd(t) {
      return "function" != typeof t.constructor || cd(t) ? {} : id(ud(t));
    },
    fd = Xc,
    ld = To;
  var pd = function pd(t) {
      return ld(t) && "[object Map]" == fd(t);
    },
    dd = Qu,
    hd = Xu.exports,
    yd = hd && hd.isMap,
    vd = yd ? dd(yd) : pd,
    gd = Xc,
    bd = To;
  var md = function md(t) {
      return bd(t) && "[object Set]" == gd(t);
    },
    wd = Qu,
    jd = Xu.exports,
    xd = jd && jd.isSet,
    Od = xd ? wd(xd) : md,
    _d = uu,
    Sd = rp,
    Ad = Uo,
    kd = cp,
    Ed = jp,
    Pd = xp.exports,
    Cd = Op,
    Rd = Ap,
    Id = Tp,
    Ud = Cc,
    Dd = Lp,
    Td = Xc,
    Md = Bp,
    Nd = rd,
    zd = sd,
    Ld = Do,
    Fd = $u.exports,
    Bd = vd,
    qd = eo,
    $d = Od,
    Yd = Ac,
    Gd = bp,
    Wd = "[object Arguments]",
    Jd = "[object Function]",
    Zd = "[object Object]",
    Vd = {};
  Vd[Wd] = Vd["[object Array]"] = Vd["[object ArrayBuffer]"] = Vd["[object DataView]"] = Vd["[object Boolean]"] = Vd["[object Date]"] = Vd["[object Float32Array]"] = Vd["[object Float64Array]"] = Vd["[object Int8Array]"] = Vd["[object Int16Array]"] = Vd["[object Int32Array]"] = Vd["[object Map]"] = Vd["[object Number]"] = Vd[Zd] = Vd["[object RegExp]"] = Vd["[object Set]"] = Vd["[object String]"] = Vd["[object Symbol]"] = Vd["[object Uint8Array]"] = Vd["[object Uint8ClampedArray]"] = Vd["[object Uint16Array]"] = Vd["[object Uint32Array]"] = !0, Vd["[object Error]"] = Vd[Jd] = Vd["[object WeakMap]"] = !1;
  var Hd = function t(e, r, n, o, a, i) {
      var u,
        c = 1 & r,
        s = 2 & r,
        f = 4 & r;
      if (n && (u = a ? n(e, o, a, i) : n(e)), void 0 !== u) return u;
      if (!qd(e)) return e;
      var l = Ld(e);
      if (l) {
        if (u = Md(e), !c) return Cd(e, u);
      } else {
        var p = Td(e),
          d = p == Jd || "[object GeneratorFunction]" == p;
        if (Fd(e)) return Pd(e, c);
        if (p == Zd || p == Wd || d && !a) {
          if (u = s || d ? {} : zd(e), !c) return s ? Id(e, Ed(u, e)) : Rd(e, kd(u, e));
        } else {
          if (!Vd[p]) return a ? e : {};
          u = Nd(e, p, c);
        }
      }
      i || (i = new _d());
      var h = i.get(e);
      if (h) return h;
      i.set(e, u), $d(e) ? e.forEach(function (o) {
        u.add(t(o, r, n, o, e, i));
      }) : Bd(e) && e.forEach(function (o, a) {
        u.set(a, t(o, r, n, a, e, i));
      });
      var y = l ? void 0 : (f ? s ? Dd : Ud : s ? Gd : Yd)(e);
      return Sd(y || e, function (o, a) {
        y && (o = e[a = o]), Ad(u, a, t(o, r, n, a, e, i));
      }), u;
    },
    Qd = Hd;
  var Xd = function Xd(t) {
      return Qd(t, 5);
    },
    Kd = hs;
  var th = function th(t, e) {
      return Kd(t, e);
    },
    eh = function eh(t) {
      return function (t) {
        return !!t && "object" === l.default(t);
      }(t) && !function (t) {
        var e = Object.prototype.toString.call(t);
        return "[object RegExp]" === e || "[object Date]" === e || function (t) {
          return t.$$typeof === rh;
        }(t);
      }(t);
    };
  var rh = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
  function nh(t, e) {
    return !1 !== e.clone && e.isMergeableObject(t) ? ch((r = t, Array.isArray(r) ? [] : {}), t, e) : t;
    var r;
  }
  function oh(t, e, r) {
    return t.concat(e).map(function (t) {
      return nh(t, r);
    });
  }
  function ah(t) {
    return Object.keys(t).concat(function (t) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function (e) {
        return t.propertyIsEnumerable(e);
      }) : [];
    }(t));
  }
  function ih(t, e) {
    try {
      return e in t;
    } catch (t) {
      return !1;
    }
  }
  function uh(t, e, r) {
    var n = {};
    return r.isMergeableObject(t) && ah(t).forEach(function (e) {
      n[e] = nh(t[e], r);
    }), ah(e).forEach(function (o) {
      (function (t, e) {
        return ih(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
      })(t, o) || (ih(t, o) && r.isMergeableObject(e[o]) ? n[o] = function (t, e) {
        if (!e.customMerge) return ch;
        var r = e.customMerge(t);
        return "function" == typeof r ? r : ch;
      }(o, r)(t[o], e[o], r) : n[o] = nh(e[o], r));
    }), n;
  }
  function ch(t, e, r) {
    (r = r || {}).arrayMerge = r.arrayMerge || oh, r.isMergeableObject = r.isMergeableObject || eh, r.cloneUnlessOtherwiseSpecified = nh;
    var n = Array.isArray(e);
    return n === Array.isArray(t) ? n ? r.arrayMerge(t, e, r) : uh(t, e, r) : nh(e, r);
  }
  ch.all = function (t, e) {
    if (!Array.isArray(t)) throw new Error("first argument should be an array");
    return t.reduce(function (t, r) {
      return ch(t, r, e);
    }, {});
  };
  var sh = ch,
    fh = "[object Symbol]",
    lh = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
    ph = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    dh = "\\u2700-\\u27bf",
    hh = "a-z\\xdf-\\xf6\\xf8-\\xff",
    yh = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    vh = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    gh = "['’]",
    bh = "[\\ud800-\\udfff]",
    mh = "[" + vh + "]",
    wh = "[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",
    jh = "\\d+",
    xh = "[\\u2700-\\u27bf]",
    Oh = "[" + hh + "]",
    _h = "[^\\ud800-\\udfff" + vh + jh + dh + hh + yh + "]",
    Sh = "\\ud83c[\\udffb-\\udfff]",
    Ah = "[^\\ud800-\\udfff]",
    kh = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Eh = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    Ph = "[" + yh + "]",
    Ch = "(?:" + Oh + "|" + _h + ")",
    Rh = "(?:" + Ph + "|" + _h + ")",
    Ih = "(?:['’](?:d|ll|m|re|s|t|ve))?",
    Uh = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
    Dh = "(?:" + wh + "|" + Sh + ")" + "?",
    Th = "[\\ufe0e\\ufe0f]?",
    Mh = Th + Dh + ("(?:\\u200d(?:" + [Ah, kh, Eh].join("|") + ")" + Th + Dh + ")*"),
    Nh = "(?:" + [xh, kh, Eh].join("|") + ")" + Mh,
    zh = "(?:" + [Ah + wh + "?", wh, kh, Eh, bh].join("|") + ")",
    Lh = RegExp(gh, "g"),
    Fh = RegExp(wh, "g"),
    Bh = RegExp(Sh + "(?=" + Sh + ")|" + zh + Mh, "g"),
    qh = RegExp([Ph + "?" + Oh + "+" + Ih + "(?=" + [mh, Ph, "$"].join("|") + ")", Rh + "+" + Uh + "(?=" + [mh, Ph + Ch, "$"].join("|") + ")", Ph + "?" + Ch + "+" + Ih, Ph + "+" + Uh, jh, Nh].join("|"), "g"),
    $h = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]"),
    Yh = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
    Gh = "object" == l.default(tt) && tt && tt.Object === Object && tt,
    Wh = "object" == ("undefined" == typeof self ? "undefined" : l.default(self)) && self && self.Object === Object && self,
    Jh = Gh || Wh || Function("return this")();
  var Zh,
    Vh = (Zh = {
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "ss"
    }, function (t) {
      return null == Zh ? void 0 : Zh[t];
    });
  function Hh(t) {
    return $h.test(t);
  }
  function Qh(t) {
    return Hh(t) ? function (t) {
      return t.match(Bh) || [];
    }(t) : function (t) {
      return t.split("");
    }(t);
  }
  var Xh = Object.prototype.toString,
    Kh = Jh.Symbol,
    ty = Kh ? Kh.prototype : void 0,
    ey = ty ? ty.toString : void 0;
  function ry(t) {
    if ("string" == typeof t) return t;
    if (function (t) {
      return "symbol" == l.default(t) || function (t) {
        return !!t && "object" == l.default(t);
      }(t) && Xh.call(t) == fh;
    }(t)) return ey ? ey.call(t) : "";
    var e = t + "";
    return "0" == e && 1 / t == -Infinity ? "-0" : e;
  }
  function ny(t, e, r) {
    var n = t.length;
    return r = void 0 === r ? n : r, !e && r >= n ? t : function (t, e, r) {
      var n = -1,
        o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (r = r > o ? o : r) < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++n < o;) {
        a[n] = t[n + e];
      }
      return a;
    }(t, e, r);
  }
  function oy(t) {
    return null == t ? "" : ry(t);
  }
  var ay,
    iy = (ay = function ay(t, e, r) {
      return e = e.toLowerCase(), t + (r ? cy(oy(e).toLowerCase()) : e);
    }, function (t) {
      return function (t, e, r, n) {
        var o = -1,
          a = t ? t.length : 0;
        for (n && a && (r = t[++o]); ++o < a;) {
          r = e(r, t[o], o, t);
        }
        return r;
      }(function (t, e, r) {
        return t = oy(t), void 0 === (e = r ? void 0 : e) ? function (t) {
          return Yh.test(t);
        }(t) ? function (t) {
          return t.match(qh) || [];
        }(t) : function (t) {
          return t.match(lh) || [];
        }(t) : t.match(e) || [];
      }(function (t) {
        return (t = oy(t)) && t.replace(ph, Vh).replace(Fh, "");
      }(t).replace(Lh, "")), ay, "");
    });
  var uy,
    cy = (uy = "toUpperCase", function (t) {
      var e = Hh(t = oy(t)) ? Qh(t) : void 0,
        r = e ? e[0] : t.charAt(0),
        n = e ? ny(e, 1).join("") : t.slice(1);
      return r[uy]() + n;
    });
  module.exports = iy;
  var sy = d(Object.freeze({
      __proto__: null
    })),
    fy = "[object Symbol]",
    ly = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
    py = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    dy = "\\u2700-\\u27bf",
    hy = "a-z\\xdf-\\xf6\\xf8-\\xff",
    yy = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    vy = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    gy = "['’]",
    by = "[" + vy + "]",
    my = "[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",
    wy = "\\d+",
    jy = "[\\u2700-\\u27bf]",
    xy = "[" + hy + "]",
    Oy = "[^\\ud800-\\udfff" + vy + wy + dy + hy + yy + "]",
    _y = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Sy = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    Ay = "[" + yy + "]",
    ky = "(?:" + xy + "|" + Oy + ")",
    Ey = "(?:" + Ay + "|" + Oy + ")",
    Py = "(?:['’](?:d|ll|m|re|s|t|ve))?",
    Cy = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
    Ry = "(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?",
    Iy = "[\\ufe0e\\ufe0f]?",
    Uy = Iy + Ry + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", _y, Sy].join("|") + ")" + Iy + Ry + ")*"),
    Dy = "(?:" + [jy, _y, Sy].join("|") + ")" + Uy,
    Ty = RegExp(gy, "g"),
    My = RegExp(my, "g"),
    Ny = RegExp([Ay + "?" + xy + "+" + Py + "(?=" + [by, Ay, "$"].join("|") + ")", Ey + "+" + Cy + "(?=" + [by, Ay + ky, "$"].join("|") + ")", Ay + "?" + ky + "+" + Py, Ay + "+" + Cy, wy, Dy].join("|"), "g"),
    zy = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
    Ly = "object" == l.default(tt) && tt && tt.Object === Object && tt,
    Fy = "object" == ("undefined" == typeof self ? "undefined" : l.default(self)) && self && self.Object === Object && self,
    By = Ly || Fy || Function("return this")();
  var qy = function (t) {
    return function (e) {
      return null == t ? void 0 : t[e];
    };
  }({
    "À": "A",
    "Á": "A",
    "Â": "A",
    "Ã": "A",
    "Ä": "A",
    "Å": "A",
    "à": "a",
    "á": "a",
    "â": "a",
    "ã": "a",
    "ä": "a",
    "å": "a",
    "Ç": "C",
    "ç": "c",
    "Ð": "D",
    "ð": "d",
    "È": "E",
    "É": "E",
    "Ê": "E",
    "Ë": "E",
    "è": "e",
    "é": "e",
    "ê": "e",
    "ë": "e",
    "Ì": "I",
    "Í": "I",
    "Î": "I",
    "Ï": "I",
    "ì": "i",
    "í": "i",
    "î": "i",
    "ï": "i",
    "Ñ": "N",
    "ñ": "n",
    "Ò": "O",
    "Ó": "O",
    "Ô": "O",
    "Õ": "O",
    "Ö": "O",
    "Ø": "O",
    "ò": "o",
    "ó": "o",
    "ô": "o",
    "õ": "o",
    "ö": "o",
    "ø": "o",
    "Ù": "U",
    "Ú": "U",
    "Û": "U",
    "Ü": "U",
    "ù": "u",
    "ú": "u",
    "û": "u",
    "ü": "u",
    "Ý": "Y",
    "ý": "y",
    "ÿ": "y",
    "Æ": "Ae",
    "æ": "ae",
    "Þ": "Th",
    "þ": "th",
    "ß": "ss",
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "ss"
  });
  var $y = Object.prototype.toString,
    Yy = By.Symbol,
    Gy = Yy ? Yy.prototype : void 0,
    Wy = Gy ? Gy.toString : void 0;
  function Jy(t) {
    if ("string" == typeof t) return t;
    if (function (t) {
      return "symbol" == l.default(t) || function (t) {
        return !!t && "object" == l.default(t);
      }(t) && $y.call(t) == fy;
    }(t)) return Wy ? Wy.call(t) : "";
    var e = t + "";
    return "0" == e && 1 / t == -Infinity ? "-0" : e;
  }
  function Zy(t) {
    return null == t ? "" : Jy(t);
  }
  var Vy = function (t) {
    return function (e) {
      return function (t, e, r, n) {
        var o = -1,
          a = t ? t.length : 0;
        for (n && a && (r = t[++o]); ++o < a;) {
          r = e(r, t[o], o, t);
        }
        return r;
      }(function (t, e, r) {
        if (t = Zy(t), void 0 === (e = r ? void 0 : e)) return function (t) {
          return zy.test(t);
        }(t) ? function (t) {
          return t.match(Ny) || [];
        }(t) : function (t) {
          return t.match(ly) || [];
        }(t);
        return t.match(e) || [];
      }(function (t) {
        return (t = Zy(t)) && t.replace(py, qy).replace(My, "");
      }(e).replace(Ty, "")), t, "");
    };
  }(function (t, e, r) {
    return t + (r ? "_" : "") + e.toLowerCase();
  });
  module.exports = Vy;
  var Hy = sy,
    Qy = d(Object.freeze({
      __proto__: null
    }));
  var Xy = function t(e, r) {
      return e && e.constructor === Object ? Object.keys(e).forEach(function (n) {
        var o = e[n];
        delete e[n], "camel" === r ? n = Hy(n) : "snake" === r ? n = Qy(n) : "upper" === r ? n = n.toUpperCase() : "lower" === r ? n = n.toLowerCase() : "function" == typeof r && (n = r(n)), e[n] = t(o, r);
      }) : e && e.constructor === Array && (e = e.map(function (e) {
        return t(e, r);
      })), e;
    },
    Ky = {};
  function tv(t, e) {
    if (!e || "object" !== l.default(e)) return t;
    if (!t || "object" !== l.default(t)) return t;
    return sh(t, e, {
      arrayMerge: function arrayMerge(t, e, r) {
        var n = t.slice();
        return e.forEach(function (e, o) {
          void 0 === n[o] ? n[o] = r.cloneUnlessOtherwiseSpecified(e, r) : r.isMergeableObject(e) ? n[o] = tv(t[o], e) : -1 === t.indexOf(e) && n.push(e);
        }), n;
      }
    });
  }
  function ev(t) {
    Ky = t;
  }
  function rv() {
    return Ky;
  }
  function nv(t) {
    return t && "object" === l.default(t) && !(t instanceof Array);
  }
  function ov(t) {
    if (!t) return t;
    var e = JSON.parse(JSON.stringify(t));
    return Xy(e, cv);
  }
  function av(t) {
    return "string" == typeof t ? t.split(".").map(tp).join(".") : t;
  }
  function iv(t) {
    if (!t) return t;
    var e = JSON.parse(JSON.stringify(t));
    return Xy(e, uv);
  }
  function uv(t) {
    return ("$" === t[0] ? "$" : "") + ep(t).replace(/\_([0-9])/g, "$1");
  }
  function cv(t) {
    return ("$" === t[0] ? "$" : "") + tp(t).replace(/\_([0-9])/g, "$1");
  }
  function sv(t) {
    return fv(lv(t));
  }
  function fv(t) {
    return "string" == typeof t ? t.replace(/^[/]+/, "") : "";
  }
  function lv(t) {
    return "string" == typeof t ? t.replace(/[/]+$/, "") : "";
  }
  function pv(t) {
    return Nn.stringify(t);
  }
  function dv(t, e, r) {
    return t instanceof Array ? t.reduce(e, r) : r;
  }
  function hv() {
    return !("undefined" != typeof window && window && window.document);
  }
  function yv(t) {
    return "function" == typeof t;
  }
  function vv(t, e, r) {
    return {
      list: r.indexOf("list") >= 0 ? function (r) {
        return t("get", e, void 0, r);
      } : void 0,
      get: r.indexOf("get") >= 0 ? function (r, n) {
        return t("get", e, r, n);
      } : void 0
    };
  }
  function gv(t, e, r) {
    return bv.apply(this, arguments);
  }
  function bv() {
    return bv = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i, u;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return o = Ky.vaultUrl, a = Ky.timeout, i = mv(), u = "swell_vault_response_".concat(i), n = {
                $jsonp: {
                  method: e,
                  callback: u
                },
                $data: n,
                $key: Ky.key
              }, t.abrupt("return", new Promise(function (t, e) {
                var i = document.createElement("script");
                i.type = "text/javascript", i.src = "".concat(lv(o), "/").concat(fv(r), "?").concat(wv(n));
                var c = setTimeout(function () {
                  window[u]({
                    $error: "Request timed out after ".concat(a / 1e3, " seconds"),
                    $status: 500
                  });
                }, a);
                window[u] = function (r) {
                  if (clearTimeout(c), r && r.$error) {
                    var n = new Error(r.$error);
                    n.code = "request_error", n.status = r.$status, e(n);
                  } else if (!r || r.$status >= 300) {
                    var o = new Error("A connection error occurred while making the request");
                    o.code = "connection_error", o.status = r.$status, e(o);
                  } else t(Ky.useCamelCase ? ov(r.$data) : r.$data);
                  delete window[u], i.parentNode.removeChild(i);
                }, document.getElementsByTagName("head")[0].appendChild(i);
              }));
            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), bv.apply(this, arguments);
  }
  function mv() {
    return window.__swell_vault_request_id = window.__swell_vault_request_id || 0, window.__swell_vault_request_id++, window.__swell_vault_request_id;
  }
  function wv(t) {
    var e = [],
      r = function r(t, _r2) {
        "function" == typeof _r2 ? _r2 = _r2() : null == _r2 && (_r2 = ""), e[e.length] = encodeURIComponent(t) + "=" + encodeURIComponent(_r2);
      };
    for (var n in t) {
      xv(n, t[n], r);
    }
    return e.join("&").replace(" ", "+");
  }
  var jv = /\[\]$/;
  function xv(t, e, r) {
    var n;
    if (e instanceof Array) for (var o = 0; o < e.length; o++) {
      jv.test(t) ? r(t, v) : xv(t + "[" + ("object" === ("undefined" == typeof v ? "undefined" : l.default(v)) && null != v ? o : "") + "]", v, r);
    } else if (e && "object" === l.default(e)) for (n in e) {
      xv(t + "[" + n + "]", e[n], r);
    } else r(t, e);
  }
  function Ov(t) {
    return "undefined" != typeof btoa ? btoa(t) : Buffer.from(t).toString("base64");
  }
  function _v(t) {
    var e = t.search.substr(1),
      r = {};
    return e.split("&").forEach(function (t) {
      var e = t.split("=");
      r[e[0]] = decodeURIComponent(e[1]);
    }), r;
  }
  function Sv() {
    var t = window.location.origin + window.location.pathname;
    window.history.pushState({
      path: t
    }, "", t);
  }
  var Av,
    kv = {
      createToken: (Av = s.default(f.default.mark(function t(e) {
        var r, n, o, a, i, u, c, s, l;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (r = null, n = null, o = null, e || (r = "Card details are missing in `swell.card.createToken(card)`", o = ""), (a = iv(e)).nonce || (this.validateNumber(a.number) || (r = "Card number appears to be invalid", n = "invalid_card_number", o = "number"), a.exp && (i = this.expiry(a.exp), a.exp_month = i.month, a.exp_year = i.year), this.validateExpiry(a.exp_month, a.exp_year) || (r = "Card expiry appears to be invalid", n = "invalid_card_expiry", o = "exp_month"), this.validateCVC(a.cvc) || (r = "Card CVC code appears to be invalid", n = "invalid_card_cvc", o = "exp_cvc")), !r) {
                  t.next = 12;
                  break;
                }
                throw (u = new Error(r)).code = n || "invalid_card", u.status = 402, u.param = o, u;
              case 12:
                return t.next = 14, gv("post", "/tokens", a);
              case 14:
                if (!(c = t.sent).errors) {
                  t.next = 22;
                  break;
                }
                throw s = Object.keys(c.errors)[0], (l = new Error(c.errors[s].message || "Unknown error")).code = "vault_error", l.status = 402, l.param = s, l;
              case 22:
                return t.abrupt("return", c);
              case 23:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function (t) {
        return Av.apply(this, arguments);
      }),
      expiry: function expiry(t) {
        if (t && t.month && t.year) return t;
        var e = new String(t).split(/[\s\/\-]+/, 2),
          r = e[0],
          n = e[1];
        n && 2 === n.length && /^\d+$/.test(n) && (n = new Date().getFullYear().toString().substring(0, 2) + n);
        return {
          month: ~~r,
          year: ~~n
        };
      },
      types: function types() {
        var t, e, r, n;
        for (e = {}, t = r = 40; r <= 49; t = ++r) {
          e[t] = "Visa";
        }
        for (t = n = 50; n <= 59; t = ++n) {
          e[t] = "MasterCard";
        }
        return e[34] = e[37] = "American Express", e[60] = e[62] = e[64] = e[65] = "Discover", e[35] = "JCB", e[30] = e[36] = e[38] = e[39] = "Diners Club", e;
      },
      type: function type(t) {
        return this.types()[t.slice(0, 2)] || "Unknown";
      },
      luhnCheck: function luhnCheck(t) {
        var e, r, n, o, a, i;
        for (n = !0, o = 0, a = 0, i = (r = (t + "").split("").reverse()).length; a < i; a++) {
          e = r[a], e = parseInt(e, 10), (n = !n) && (e *= 2), e > 9 && (e -= 9), o += e;
        }
        return o % 10 == 0;
      },
      validateNumber: function validateNumber(t) {
        return (t = (t + "").replace(/\s+|-/g, "")).length >= 10 && t.length <= 16 && this.luhnCheck(t);
      },
      validateExpiry: function validateExpiry(t, e) {
        var r, n;
        return t = String(t).trim(), e = String(e).trim(), !!/^\d+$/.test(t) && !!/^\d+$/.test(e) && parseInt(t, 10) <= 12 && (n = new Date(e, t), r = new Date(), n.setMonth(n.getMonth() - 1), n.setMonth(n.getMonth() + 1, 1), n > r);
      },
      validateCVC: function validateCVC(t) {
        return t = String(t).trim(), /^\d+$/.test(t) && t.length >= 3 && t.length <= 4;
      }
    };
  function Ev(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Pv(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Ev(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ev(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  var Cv = 604800;
  function Rv(t) {
    if (!hv()) {
      var e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([.$?*|{}()[]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : void 0;
    }
  }
  function Iv(t, e) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if (!hv()) {
      (r = Pv({
        path: "/",
        "max-age": Cv,
        samesite: "lax"
      }, r)).expires && r.expires.toUTCString && (r.expires = r.expires.toUTCString());
      var n = encodeURIComponent(t) + "=" + encodeURIComponent(e);
      for (var o in r) {
        n += "; " + o;
        var a = r[o];
        !0 !== a && (n += "=" + a);
      }
      document.cookie = n;
    }
  }
  function Uv(t, e) {
    var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!r) {
      if (Array.isArray(t) || (r = function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return Dv(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Dv(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n2 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n2 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n2++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a,
      i = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return i = t.done, t;
      },
      e: function e(t) {
        u = !0, a = t;
      },
      f: function f() {
        try {
          i || null == r.return || r.return();
        } finally {
          if (u) throw a;
        }
      }
    };
  }
  function Dv(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function Tv(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Mv(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Tv(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Tv(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  var Nv,
    zv,
    Lv = {},
    Fv = {
      options: {
        enabled: !0,
        debug: !1
      },
      debug: function debug() {
        var t;
        this.options.debug && (t = console).log.apply(t, arguments);
      },
      values: function values(t) {
        var e = t.model,
          r = t.id,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        if (this.debug.apply(this, ["cache.values"].concat(Array.prototype.slice.call(arguments))), void 0 === n) return xi(Lv, "".concat(e, ".").concat(r), {});
        for (var o in n) {
          gi(Lv, "".concat(e, ".").concat(r, ".").concat(o), n[o]);
        }
      },
      preset: function preset(t) {
        this.debug.apply(this, ["cache.preset"].concat(Array.prototype.slice.call(arguments)));
        var e = this.values(t),
          r = e.presets,
          n = void 0 === r ? [] : r;
        n.push(t), this.values(t, {
          presets: n
        });
      },
      set: function set(t) {
        this.debug.apply(this, ["cache.set"].concat(Array.prototype.slice.call(arguments)));
        var e = t.model,
          r = t.id,
          n = t.path,
          o = t.value,
          a = this.values(t),
          i = a.data,
          u = void 0 === i ? {} : i,
          c = a.record;
        if (a.presets, null !== r) {
          if (void 0 === c) return this.preset(t);
          u = tv(c || {}, u);
          var s = rv(),
            f = s.useCamelCase;
          if (f && o && "object" === l.default(o) && (o = ov(o)), n || o instanceof Array) {
            var p = Mv({}, u || {}),
              d = f ? av(n) : n;
            gi(p, d || "", o), u = p;
          } else u = o && "object" === l.default(o) ? tv(u = u || {}, o) : o;
          this.values(t, {
            data: u
          });
          try {
            var h = Lv[e][r];
            void 0 !== h && (void 0 !== h.data && (h.data = JSON.parse(JSON.stringify(h.data))), void 0 !== h.record && (h.record = JSON.parse(JSON.stringify(h.record))));
          } catch (t) {}
        }
      },
      get: function get(t, e) {
        this.debug.apply(this, ["cache.get"].concat(Array.prototype.slice.call(arguments)));
        var r = this.values({
            model: t,
            id: e
          }),
          n = r.data,
          o = r.recordTimer;
        if (this.debug.apply(this, ["cache.get:data+recordTimer"].concat(Array.prototype.slice.call(arguments))), o) return n;
      },
      setRecord: function setRecord(t, e) {
        var r = this;
        this.debug.apply(this, ["cache.setRecord"].concat(Array.prototype.slice.call(arguments)));
        var n = this.values(e),
          o = n.recordTimer,
          a = n.presets;
        if (o && clearTimeout(o), o = setTimeout(function () {
          r.values(e, {
            record: void 0,
            recordTimer: void 0
          });
        }, 5e3), this.values(e, {
          record: void 0 !== t ? t : null,
          recordTimer: o
        }), a) {
          var i,
            u = Uv(a);
          try {
            for (u.s(); !(i = u.n()).done;) {
              var c = i.value;
              this.set(c);
            }
          } catch (t) {
            u.e(t);
          } finally {
            u.f();
          }
          this.values(e, {
            presets: void 0
          });
        }
        var s = this.get(e.model, e.id);
        return void 0 !== s ? s : t;
      },
      getFetch: (Nv = s.default(f.default.mark(function t(e, r, n) {
        var o,
          a,
          i = arguments;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!this.options.enabled) {
                  t.next = 5;
                  break;
                }
                if (this.debug.apply(this, ["cache.getFetch"].concat(Array.prototype.slice.call(i))), void 0 === (o = this.get(e, r))) {
                  t.next = 5;
                  break;
                }
                return t.abrupt("return", o);
              case 5:
                return t.next = 7, n();
              case 7:
                return a = t.sent, t.abrupt("return", this.setRecord(a, {
                  model: e,
                  id: r
                }));
              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function (t, e, r) {
        return Nv.apply(this, arguments);
      }),
      clear: function clear() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        this.debug.apply(this, ["cache.clear"].concat(Array.prototype.slice.call(arguments))), t ? gi(Lv, e ? "".concat(t, ".").concat(e) : t, void 0) : Lv = {};
      }
    };
  function Bv(t) {
    var e = vv(t, "/attributes", ["list", "get"]),
      r = e.get;
    return {
      get: function get(t) {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
          n[o - 1] = arguments[o];
        }
        return Fv.getFetch("attributes", t, function () {
          return r.apply(void 0, [t].concat(n));
        });
      },
      list: e.list
    };
  }
  function qv(t, e) {
    var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!r) {
      if (Array.isArray(t) || (r = function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return $v(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $v(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n3 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n3 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n3++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a,
      i = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return i = t.done, t;
      },
      e: function e(t) {
        u = !0, a = t;
      },
      f: function f() {
        try {
          i || null == r.return || r.return();
        } finally {
          if (u) throw a;
        }
      }
    };
  }
  function $v(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function Yv(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Gv(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Yv(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Yv(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  function Wv(t) {
    var e = t || [];
    if (t && "object" === l.default(t) && !(t instanceof Array)) for (var r in e = [], t) {
      e.push({
        id: r,
        value: t[r]
      });
    }
    return e instanceof Array ? e.map(function (t) {
      return {
        id: t.id || t.name,
        value: t.value
      };
    }) : e;
  }
  function Jv(t, e, r) {
    var n,
      o = zv.useCamelCase ? iv(t) : t,
      a = Zv(o, r),
      i = Gv(Gv({}, o), {}, {
        price: a.price || 0,
        sale_price: a.sale_price,
        orig_price: a.orig_price,
        stock_status: o.stock_status
      }),
      u = 0,
      s = [],
      f = Wv(e),
      l = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return t.options ? dv(e ? t.options.filter(e) : t.options, function (t, e) {
          var r,
            n = dv(e.values, function (t, e) {
              var r;
              return Gv(Gv({}, t), {}, (r = {}, c.default(r, e.id, Gv(Gv({}, e), {}, {
                id: e.id
              })), c.default(r, e.name, Gv(Gv({}, e), {}, {
                id: e.id
              })), r));
            }, {});
          return Gv(Gv({}, t), {}, (r = {}, c.default(r, e.id, Gv(Gv({}, e), {}, {
            values: n
          })), c.default(r, e.name, Gv(Gv({}, e), {}, {
            values: n
          })), r));
        }, {}) : {};
      }(o),
      p = qv(f);
    try {
      for (p.s(); !(n = p.n()).done;) {
        var d = n.value;
        l[d.id] && l[d.id].values[d.value] && (l[d.id].variant ? s.push(l[d.id].values[d.value].id) : u += l[d.id].values[d.value].price || 0);
      }
    } catch (t) {
      p.e(t);
    } finally {
      p.f();
    }
    if (s.length > 0) {
      var h = function (t, e) {
        if (e.length > 0) {
          var r = t.variants && t.variants.results;
          if (r.length > 0) {
            var n,
              o = qv(r);
            try {
              for (o.s(); !(n = o.n()).done;) {
                var a = n.value,
                  i = iv(a);
                if (th(i.option_value_ids.sort(), e.sort())) return a;
              }
            } catch (t) {
              o.e(t);
            } finally {
              o.f();
            }
          }
        }
        return null;
      }(o, s);
      if (h) {
        var y = a;
        try {
          y = Zv(h, r);
        } catch (t) {}
        i.variant_id = h.id, i.price = y.price || 0, i.sale_price = y.sale_price || a.sale_price, i.orig_price = y.orig_price || a.orig_price, i.stock_status = h.stock_status, i.stock_level = h.stock_level || 0, i.images = (h.images && h.images.length ? h.images : o.images) || [];
      }
    }
    return u > 0 && (i.price += u, i.sale_price && (i.sale_price += u), i.orig_price && (i.orig_price += u)), void 0 === i.sale_price && delete i.sale_price, void 0 === i.orig_price && delete i.orig_price, zv.useCamelCase ? ov(i) : i;
  }
  function Zv(t, e) {
    var r = xi(e, "plan_id", xi(e, "plan")),
      n = xi(e, "type", "string" == typeof e ? e : void 0 !== r ? "subscription" : "standard"),
      o = xi(t, "purchase_options.".concat(n));
    if (!o && "standard" !== n) throw new Error("Product purchase option '".concat(n, "' not found or not active"));
    if (o) {
      if (o.plans) if (void 0 !== r) {
        if (!(o = Cf(o.plans, {
          id: r
        }))) throw new Error("Subscription purchase plan '".concat(r, "' not found or not active"));
      } else o = o.plans[0];
      return Gv(Gv({}, o), {}, {
        price: "number" == typeof o.price ? o.price : t.price,
        sale_price: "number" == typeof o.sale_price ? o.sale_price : t.sale_price,
        orig_price: "number" == typeof o.orig_price ? o.orig_price : t.orig_price
      });
    }
    return {
      type: "standard",
      price: t.price,
      sale_price: t.sale_price,
      orig_price: t.orig_price
    };
  }
  function Vv() {
    return Vv = s.default(f.default.mark(function t(e, r, n) {
      var o, a;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, Bv(e).list({
                filterable: !0
              });
            case 2:
              return o = t.sent, a = o.results, t.abrupt("return", Hv(r, Gv(Gv({}, n), {}, {
                filterableAttributes: a
              })));
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Vv.apply(this, arguments);
  }
  function Hv(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = (e.attributes || void 0 === e.attributes) && Xv(t);
    e.filterableAttributes && (r = r.filter(function (t) {
      return e.filterableAttributes.find(function (e) {
        return t.id === e.id;
      });
    }));
    var n = (e.categories || void 0 === e.categories) && Qv(t),
      o = (e.price || void 0 === e.price) && Kv(t),
      a = [];
    return o && a.push({
      id: "price",
      label: "Price",
      type: "range",
      options: [{
        value: o.min,
        label: o.min
      }, {
        value: o.max,
        label: o.max
      }],
      interval: o.interval
    }), n && n.length > 0 && a.push({
      id: "category",
      label: "Category",
      type: "select",
      options: n.map(function (t) {
        return {
          value: t.slug,
          label: t.name
        };
      })
    }), r && r.length > 0 && (a = [].concat(p.default(a), p.default(dv(r, function (t, e) {
      return [].concat(p.default(t), p.default("category" !== e.id && "price" !== e.id && e.values instanceof Array && e.values.length > 0 ? [{
        id: e.id,
        label: e.name,
        type: "select",
        options: e.values.map(function (t) {
          return {
            value: t,
            label: t
          };
        })
      }] : []));
    }, [])))), a;
  }
  function Qv(t) {
    var e = [],
      r = t && t.results || (t.id ? [t] : t);
    if (r instanceof Array) {
      var n,
        o = qv(r);
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a = n.value;
          if (a.categories) {
            var i,
              u = qv(a.categories);
            try {
              for (u.s(); !(i = u.n()).done;) {
                var c = i.value;
                if (c) Cf(e, {
                  id: c.id
                }) || e.push(c);
              }
            } catch (t) {
              u.e(t);
            } finally {
              u.f();
            }
          }
        }
      } catch (t) {
        o.e(t);
      } finally {
        o.f();
      }
    }
    return e;
  }
  function Xv(t) {
    var e = [],
      r = t && t.results || (t.id ? [t] : t);
    if (r instanceof Array) {
      var n,
        o = qv(r);
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a = n.value;
          if (a.attributes) for (var i in a.attributes) {
            if (a.attributes[i]) {
              var u = a.attributes[i].value,
                c = Cf(e, {
                  id: ep(i)
                });
              c ? c.values = Vi([].concat(p.default(c.values), p.default(u instanceof Array ? u : [u]))) : e.push(Gv(Gv({}, a.attributes[i]), {}, {
                value: void 0,
                values: p.default(u instanceof Array ? u : [u])
              }));
            }
          }
        }
      } catch (t) {
        o.e(t);
      } finally {
        o.f();
      }
    }
    return e;
  }
  function Kv(t) {
    var e,
      r,
      n,
      o = t && t.results || (t.id ? [t] : t);
    if (o instanceof Array) {
      var a,
        i = qv(o);
      try {
        for (i.s(); !(a = i.n()).done;) {
          var u = a.value;
          (void 0 === r || u.price > r) && (r = Math.ceil(u.price)), (void 0 === e || u.price < e) && (e = Math.floor(u.price));
        }
      } catch (t) {
        i.e(t);
      } finally {
        i.f();
      }
    }
    if (e === r) return null;
    for ((n = Math.ceil((r - e) / 10) || 1) > 1e3 ? n = 1e3 : n > 100 ? n = 100 : n > 10 && (n = 10), r % n > 0 && (r = n + r - r % n), e % n > 0 && (e -= e % n); (r - e) / n % 1 > 0;) {
      r++;
    }
    return {
      min: e,
      max: r,
      interval: n
    };
  }
  function tg(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function eg(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? tg(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tg(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  function rg(t, e) {
    return {
      state: null,
      order: null,
      settings: null,
      requested: !1,
      pendingRequests: [],
      cacheClear: null,
      requestStateChange: (u = s.default(f.default.mark(function e(r, n, o, a) {
        var i = this;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.requestStateSync(s.default(f.default.mark(function e() {
                  var u;
                  return f.default.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return e.next = 2, t(r, n, o, a);
                        case 2:
                          if (!(u = e.sent) || !u.errors) {
                            e.next = 5;
                            break;
                          }
                          return e.abrupt("return", u);
                        case 5:
                          return i.state = u, e.abrupt("return", u);
                        case 7:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }))));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (t, e, r, n) {
        return u.apply(this, arguments);
      }),
      requestStateSync: (i = s.default(f.default.mark(function t(e) {
        var r,
          n,
          o,
          a = this;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!this.state) {
                  t.next = 6;
                  break;
                }
                return t.next = 3, e();
              case 3:
                return t.abrupt("return", t.sent);
              case 6:
                if (!this.requested) {
                  t.next = 8;
                  break;
                }
                return t.abrupt("return", new Promise(function (t) {
                  a.pendingRequests.push({
                    handler: e,
                    resolve: t
                  });
                }));
              case 8:
                return this.requested = !0, t.next = 11, e();
              case 11:
                for (r = t.sent, this.requested = !1; this.pendingRequests.length > 0;) {
                  n = this.pendingRequests.shift(), o = n.handler, (0, n.resolve)(o());
                }
                return t.abrupt("return", r);
              case 15:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function (t) {
        return i.apply(this, arguments);
      }),
      get: function get() {
        var t;
        return this.cacheClear && (this.cacheClear = null, t = {
          $cache: !1
        }), this.requestStateChange("get", "/cart", void 0, t);
      },
      clearCache: function clearCache() {
        this.cacheClear = !0;
      },
      getItemData: function getItemData(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = Xd(t);
        return "string" == typeof t && (r = eg(eg({}, e || {}), {}, {
          product_id: t
        })), r && r.options && (r.options = Wv(r.options)), r;
      },
      addItem: function addItem(t, e) {
        return this.requestStateChange("post", "/cart/items", this.getItemData(t, e));
      },
      updateItem: function updateItem(t, e) {
        return this.requestStateChange("put", "/cart/items/".concat(t), this.getItemData(e));
      },
      setItems: function setItems(t) {
        var e = t;
        return e && e.map && (e = e.map(this.getItemData)), this.requestStateChange("put", "/cart/items", e);
      },
      removeItem: function removeItem(t) {
        return this.requestStateChange("delete", "/cart/items/".concat(t));
      },
      recover: function recover(t) {
        return this.requestStateChange("put", "/cart/recover/".concat(t));
      },
      update: function update(t) {
        var e = t;
        return e.items && e.items.map && (e = eg(eg({}, e), {}, {
          items: e.items.map(this.getItemData)
        })), this.requestStateChange("put", "/cart", e);
      },
      applyCoupon: function applyCoupon(t) {
        return this.requestStateChange("put", "/cart/coupon", {
          code: t
        });
      },
      removeCoupon: function removeCoupon() {
        return this.requestStateChange("delete", "/cart/coupon");
      },
      applyGiftcard: function applyGiftcard(t) {
        return this.requestStateChange("post", "/cart/giftcards", {
          code: t
        });
      },
      removeGiftcard: function removeGiftcard(t) {
        return this.requestStateChange("delete", "/cart/giftcards/".concat(t));
      },
      getShippingRates: (a = s.default(f.default.mark(function t() {
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, this.requestStateChange("get", "/cart/shipment-rating");
              case 2:
                return t.abrupt("return", this.state[e.useCamelCase ? "shipmentRating" : "shipment_rating"]);
              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function () {
        return a.apply(this, arguments);
      }),
      submitOrder: (o = s.default(f.default.mark(function e() {
        var r;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, t("post", "/cart/order");
              case 2:
                if (!(r = e.sent).errors) {
                  e.next = 5;
                  break;
                }
                return e.abrupt("return", r);
              case 5:
                return this.state = null, this.order = r, e.abrupt("return", r);
              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      }),
      getOrder: (n = s.default(f.default.mark(function e() {
        var r,
          n,
          o = arguments;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!(r = o.length > 0 && void 0 !== o[0] ? o[0] : void 0)) {
                  e.next = 7;
                  break;
                }
                return e.next = 4, t("get", "/cart/order", {
                  checkout_id: r
                });
              case 4:
                n = e.sent, e.next = 10;
                break;
              case 7:
                return e.next = 9, t("get", "/cart/order");
              case 9:
                n = e.sent;
              case 10:
                return this.order = n, e.abrupt("return", n);
              case 12:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return n.apply(this, arguments);
      }),
      getSettings: (r = s.default(f.default.mark(function e() {
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, t("get", "/cart/settings");
              case 2:
                return this.settings = e.sent, e.abrupt("return", this.settings);
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    };
    var r, n, o, a, i, u;
  }
  function ng(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function og(t, e) {
    var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!r) {
      if (Array.isArray(t) || (r = function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ag(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ag(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n4 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n4 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n4++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a,
      i = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return i = t.done, t;
      },
      e: function e(t) {
        u = !0, a = t;
      },
      f: function f() {
        try {
          i || null == r.return || r.return();
        } finally {
          if (u) throw a;
        }
      }
    };
  }
  function ag(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function ig(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function ug(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? ig(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ig(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  function cg(t, e) {
    return {
      state: null,
      menuState: null,
      paymentState: null,
      subscriptionState: null,
      sessionState: null,
      localizedState: {},
      refresh: function refresh() {
        return this.state = null, this.menuState = null, this.paymentState = null, this.subscriptionState = null, this.sessionState = null, this.localizedState = {}, this.get();
      },
      getState: function getState(e, r) {
        var n = this,
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          a = o.id,
          i = void 0 === a ? void 0 : a,
          u = o.def,
          c = void 0 === u ? void 0 : u,
          s = o.refresh,
          f = void 0 !== s && s;
        return this[r] && !f || (this[r] = t("get", e)), this[r] && "function" == typeof this[r].then ? this[r].then(function (t) {
          return n[r] = t, n.getLocalizedState(r, i, c);
        }) : this.getLocalizedState(r, i, c);
      },
      getLocalizedState: function getLocalizedState(t, e, r) {
        var n = this.getCurrentLocale(),
          o = this.localizedState;
        return o.code !== n && (o.code = n, delete o[n]), o[n] || (o[n] = {}), o[n][t] || (o[n][t] = this.decodeLocale(this[t])), e ? xi(o[n][t], e, r) : o[n][t];
      },
      findState: function findState(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = r.where,
          o = void 0 === n ? void 0 : n,
          a = r.def,
          i = void 0 === a ? void 0 : a,
          u = this.getState(t, e);
        return u && "function" == typeof u.then ? u.then(function (t) {
          return Cf(t, o) || i;
        }) : Cf(u, o) || i;
      },
      get: function get() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return this.getState("/settings", "state", {
          id: t,
          def: e
        });
      },
      getCurrentLocale: function getCurrentLocale() {
        return e.api.locale.selected();
      },
      getStoreLocale: function getStoreLocale() {
        return xi(this.state, "store.locale");
      },
      getStoreLocales: function getStoreLocales() {
        return xi(this.state, "store.locales");
      },
      set: function set(t) {
        var r = t.model,
          n = t.path,
          o = t.value,
          a = this.getCurrentLocale(),
          i = r ? "".concat(r.replace(/s$/, ""), "State") : "state",
          u = e.useCamelCase,
          c = {};
        n ? gi(c, n, o) : c = o, u && (c = ov(c)), this[i] = tv(this[i] || {}, c), this.localizedState[a] && (this.localizedState[a][i] = this.decodeLocale(this[i]));
      },
      menus: function menus() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return this.findState("/settings/menus", "menuState", {
          where: {
            id: t
          },
          def: e
        });
      },
      payments: function payments() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return this.getState("/settings/payments", "paymentState", {
          id: t,
          def: e
        });
      },
      subscriptions: function subscriptions() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return this.getState("/settings/subscriptions", "subscriptionState", {
          id: t,
          def: e
        });
      },
      session: function session() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return this.getState("/session", "sessionState", {
          id: t,
          def: e
        });
      },
      decodeLocale: function decodeLocale(t) {
        var r = this.getCurrentLocale();
        if (!t || "object" !== l.default(t)) return t;
        var n = this.getStoreLocales();
        return n = n ? n.reduce(function (t, e) {
          return ug(ug({}, t), {}, c.default({}, e.code, e));
        }, {}) : {}, sg(Xd(t), r, n, e);
      },
      load: (r = s.default(f.default.mark(function e() {
        var r, n, o, a, i, u;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, t("get", "/settings/all");
              case 3:
                r = e.sent, n = r.settings, o = r.menus, a = r.payments, i = r.subscriptions, u = r.session, this.localizedState = {}, this.set({
                  value: n
                }), this.set({
                  model: "menus",
                  value: o
                }), this.set({
                  model: "payments",
                  value: a
                }), this.set({
                  model: "subscriptions",
                  value: i
                }), this.set({
                  model: "session",
                  value: u
                }), e.next = 20;
                break;
              case 17:
                e.prev = 17, e.t0 = e.catch(0), console.error("Swell: unable to loading settings (".concat(e.t0, ")"));
              case 20:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[0, 17]]);
      })), function () {
        return r.apply(this, arguments);
      })
    };
    var r;
  }
  function sg(t, e, r, n) {
    if (nv(t)) for (var o = 0, a = Object.keys(t); o < a.length; o++) {
      var i = a[o];
      "$locale" === i && (fg(e, t, i, r, n), delete t.$locale), void 0 !== t[i] && (t[i] = sg(t[i], e, r, n));
    } else if (t instanceof Array) for (var u = 0; u < t.length; u++) {
      t[u] = sg(t[u], e, r, n);
    }
    return t;
  }
  function fg(t, e, r, n, o) {
    if (t && nv(e[r])) {
      for (var a, i, u, c = 0, s = Object.keys(e[r]); c < s.length; c++) {
        var f = s[c],
          l = f.replace(/\-.+$/, ""),
          p = o.useCamelCase ? tp(t) : t;
        f !== t && f !== p && l !== p || (a = t, i = n[t]);
      }
      if (!a && nv(n)) for (var d = 0, h = Object.keys(n); d < h.length; d++) {
        var y = h[d],
          v = y.replace(/\-.+$/, "");
        y !== t && v !== t || (a = y, i = n[y]);
      }
      var g = {};
      if (i) for (var b = i.fallback, m = b; b && ((u = u || []).push(b), g = ug(ug({}, e[r][b] || {}), g), m !== (b = n[b] && n[b].fallback));) {
        ;
      }
      for (var w = ug(ug({}, g), e[r][a] || {}), j = 0, x = Object.keys(w); j < x.length; j++) {
        var O = x[j],
          _ = null !== w[O] && "" !== w[O],
          S = u && !_;
        if (S) {
          var A,
            k = og(u);
          try {
            for (k.s(); !(A = k.n()).done;) {
              var E = A.value;
              if (!(S = !e[r][E] || null === e[r][E][O] || "" === e[r][E][O])) {
                e[O] = e[r][E][O];
                break;
              }
              if ("none" === E) {
                e[O] = null;
                break;
              }
            }
          } catch (t) {
            k.e(t);
          } finally {
            k.f();
          }
        } else _ && (e[O] = w[O]);
      }
    }
  }
  var lg = ti;
  var pg = function pg(t) {
    return lg(t).toLowerCase();
  };
  var dg = function dg(t) {
      return function (e, r, n) {
        for (var o = -1, a = Object(e), i = n(e), u = i.length; u--;) {
          var c = i[t ? u : ++o];
          if (!1 === r(a[c], c, a)) break;
        }
        return e;
      };
    },
    hg = dg(),
    yg = Ac;
  var vg = function vg(t, e) {
      return t && hg(t, e, yg);
    },
    gg = xc;
  var bg = function (t, e) {
    return function (r, n) {
      if (null == r) return r;
      if (!gg(r)) return t(r, n);
      for (var o = r.length, a = e ? o : -1, i = Object(r); (e ? a-- : ++a < o) && !1 !== n(i[a], a, i);) {
        ;
      }
      return r;
    };
  }(vg);
  var mg = pl,
    wg = bg,
    jg = af,
    xg = function xg(t, e, r, n, o) {
      return o(t, function (t, o, a) {
        r = n ? (n = !1, t) : e(r, t, o, a);
      }), r;
    },
    Og = Do;
  var _g = function _g(t, e, r) {
      var n = Og(t) ? mg : xg,
        o = arguments.length < 3;
      return n(t, jg(e), r, o, wg);
    },
    Sg = mc,
    Ag = Xc,
    kg = qu,
    Eg = Do,
    Pg = xc,
    Cg = $u.exports,
    Rg = dc,
    Ig = nc,
    Ug = Object.prototype.hasOwnProperty;
  var Dg = function Dg(t) {
      if (null == t) return !0;
      if (Pg(t) && (Eg(t) || "string" == typeof t || "function" == typeof t.splice || Cg(t) || Ig(t) || kg(t))) return !t.length;
      var e = Ag(t);
      if ("[object Map]" == e || "[object Set]" == e) return !t.size;
      if (Rg(t)) return !Sg(t).length;
      for (var r in t) {
        if (Ug.call(t, r)) return !1;
      }
      return !0;
    },
    Tg = bg,
    Mg = xc;
  var Ng = Wa,
    zg = af,
    Lg = function Lg(t, e) {
      var r = -1,
        n = Mg(t) ? Array(t.length) : [];
      return Tg(t, function (t, o, a) {
        n[++r] = e(t, o, a);
      }), n;
    },
    Fg = Do;
  var Bg = function Bg(t, e) {
    return (Fg(t) ? Ng : Lg)(t, zg(e));
  };
  function qg(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function $g(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? qg(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qg(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  var Yg = {
      city: "city",
      country: "country",
      line1: "address1",
      line2: "address2",
      postal_code: "zip",
      state: "state"
    },
    Gg = {
      name: "name",
      phone: "phone"
    };
  function Wg(t) {
    var e = t.account,
      r = void 0 === e ? {} : e,
      n = t.billing,
      o = t.shipping,
      a = xi(r, "shipping", {}),
      i = xi(r, "billing", {}),
      u = $g($g($g($g({}, a), i), o), n),
      c = function c(t) {
        return _g(t, function (t, e, r) {
          var n = u[e];
          return n && (t[r] = n), t;
        }, {});
      },
      s = c(Gg);
    if (!Dg(s)) {
      var f = c(Yg);
      return $g($g({}, s), Dg(f) ? {} : {
        address: f
      });
    }
  }
  function Jg(t) {
    var e = pg(xi(t, "currency", "eur")),
      r = Bg(t.items, function (t) {
        return {
          type: "sku",
          description: t.product.name,
          quantity: t.quantity,
          currency: e,
          amount: Math.round(100 * jf(t.price_total - t.discount_total))
        };
      }),
      n = xi(t, "tax_included_total");
    n && r.push({
      type: "tax",
      description: "Taxes",
      currency: e,
      amount: Math.round(100 * jf(n))
    });
    var o = xi(t, "shipping", {}),
      a = xi(t, "shipment_total", {});
    return o.price && r.push({
      type: "shipping",
      description: o.service_name,
      currency: e,
      amount: Math.round(100 * jf(a))
    }), r;
  }
  function Zg(t, e) {
    var r = function r(t, e) {
      return _g(t, function (t, r, n) {
        var o = e[r];
        return o && (t[n] = o), t;
      }, {});
    };
    t.klarna = $g($g({}, t.klarna), r({
      shipping_first_name: "first_name",
      shipping_last_name: "last_name"
    }, e.shipping));
    var n = r({
        phone: "phone"
      }, e.shipping),
      o = r(Yg, e.shipping);
    (n || o) && (t.source_order.shipping = $g($g({}, n || {}), o ? {
      address: o
    } : {})), t.klarna = $g($g({}, t.klarna), r({
      first_name: "first_name",
      last_name: "last_name"
    }, e.billing || xi(e, "account.billing") || e.shipping));
    var a = r({
        email: "email"
      }, e.account),
      i = r(Yg, e.billing || xi(e, "account.billing") || e.shipping);
    (a || i) && (t.owner = $g($g({}, a || {}), i ? {
      address: i
    } : {}));
  }
  function Vg(t, e) {
    var r = e.account,
      n = void 0 === r ? {} : r,
      o = e.billing,
      a = e.shipping,
      i = $g($g($g($g({}, n.shipping), n.billing), a), o),
      u = function (t, e) {
        return _g(t, function (t, r, n) {
          var o = e[r];
          return o && (t[n] = o), t;
        }, {});
      }(Yg, i);
    t.owner = $g($g({
      email: n.email,
      name: i.name || n.name
    }, i.phone ? {
      phone: i.phone
    } : n.phone ? {
      phone: n.phone
    } : {}), Dg(u) ? {} : {
      address: u
    });
  }
  function Hg(t, e, r) {
    return Qg.apply(this, arguments);
  }
  function Qg() {
    return (Qg = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i, u;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return o = Wg(n), t.next = 3, e.createPaymentMethod($g({
                type: "card",
                card: r
              }, o ? {
                billing_details: o
              } : {}));
            case 3:
              return a = t.sent, i = a.error, u = a.paymentMethod, t.abrupt("return", i ? {
                error: i
              } : {
                token: u.id,
                last4: u.card.last4,
                exp_month: u.card.exp_month,
                exp_year: u.card.exp_year,
                brand: u.card.brand,
                address_check: u.card.checks.address_line1_check,
                cvc_check: u.card.checks.cvc_check,
                zip_check: u.card.checks.address_zip_check
              });
            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function Xg(t, e) {
    return Kg.apply(this, arguments);
  }
  function Kg() {
    return Kg = s.default(f.default.mark(function t(e, r) {
      var n,
        o,
        a = arguments;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return n = a.length > 2 && void 0 !== a[2] ? a[2] : {}, o = Wg(n), t.next = 4, e.createPaymentMethod($g({
                type: "ideal",
                ideal: r
              }, o ? {
                billing_details: o
              } : {}));
            case 4:
              return t.abrupt("return", t.sent);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Kg.apply(this, arguments);
  }
  function tb(t, e) {
    return eb.apply(this, arguments);
  }
  function eb() {
    return (eb = s.default(f.default.mark(function t(e, r) {
      var n;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return Zg(n = {
                type: "klarna",
                flow: "redirect",
                amount: Math.round(100 * xi(r, "grand_total", 0)),
                currency: pg(xi(r, "currency", "eur")),
                klarna: {
                  product: "payment",
                  purchase_country: xi(r, "settings.country", "DE")
                },
                source_order: {
                  items: Jg(r)
                },
                redirect: {
                  return_url: window.location.href
                }
              }, r), t.next = 4, e.createSource(n);
            case 4:
              return t.abrupt("return", t.sent);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function rb(t, e) {
    return nb.apply(this, arguments);
  }
  function nb() {
    return (nb = s.default(f.default.mark(function t(e, r) {
      var n;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return Vg(n = {
                type: "bancontact",
                amount: Math.round(100 * xi(r, "grand_total", 0)),
                currency: pg(xi(r, "currency", "eur")),
                redirect: {
                  return_url: window.location.href
                }
              }, r), t.next = 4, e.createSource(n);
            case 4:
              return t.abrupt("return", t.sent);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function ob(t, e) {
    return ["BIF", "DJF", "JPY", "KRW", "PYG", "VND", "XAF", "XPF", "CLP", "GNF", "KMF", "MGA", "RWF", "VUV", "XOF"].includes(t.toUpperCase()) ? e : Math.round(100 * e);
  }
  function ab() {
    return Math.random().toString(36).substr(2, 9);
  }
  function ib(t) {
    return ub.apply(this, arguments);
  }
  function ub() {
    return (ub = s.default(f.default.mark(function t(e) {
      var r, n;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return r = window.location.origin + window.location.pathname, t.next = 3, e({
                gateway: "quickpay",
                params: {
                  action: "create",
                  continueurl: "".concat(r, "?gateway=quickpay&redirect_status=succeeded"),
                  cancelurl: "".concat(r, "?gateway=quickpay&redirect_status=canceled")
                }
              });
            case 3:
              (n = t.sent) && n.url && window.location.replace(n.url);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function cb(t, e) {
    return sb.apply(this, arguments);
  }
  function sb() {
    return (sb = s.default(f.default.mark(function t(e, r) {
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, r({
                gateway: "quickpay",
                params: {
                  action: "get",
                  id: e
                }
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function fb(t, e) {
    return lb.apply(this, arguments);
  }
  function lb() {
    return (lb = s.default(f.default.mark(function t(e, r) {
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, r({
                gateway: "quickpay",
                intent: {
                  currency: xi(e, "currency", "USD"),
                  order_id: ab()
                }
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function pb(t, e) {
    return db.apply(this, arguments);
  }
  function db() {
    return (db = s.default(f.default.mark(function t(e, r) {
      var n, o;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return n = window.location.origin + window.location.pathname, o = "".concat(n, "?gateway=paysafecard"), t.next = 4, r({
                gateway: "paysafecard",
                intent: {
                  type: "PAYSAFECARD",
                  amount: e.grand_total,
                  redirect: {
                    success_url: o,
                    failure_url: o
                  },
                  notification_url: o,
                  customer: {
                    id: xi(e, "account.id")
                  },
                  currency: xi(e, "currency", "USD")
                }
              });
            case 4:
              return t.abrupt("return", t.sent);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function hb(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function yb(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? hb(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hb(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  var vb = {
      given_name: "first_name",
      family_name: "last_name",
      city: "city",
      country: "country",
      phone: "phone",
      postal_code: "zip",
      street_address: "address1",
      street_address2: "address2",
      region: "state"
    },
    gb = function gb(t, e) {
      return yb(yb({}, (r = vb, n = t[e], _g(r, function (t, e, r) {
        var o = n[e];
        return o && (t[r] = o), t;
      }, {}))), {}, {
        email: xi(t, "account.email")
      });
      var r, n;
    };
  function bb(t) {
    var e = Bg(t.items, function (t) {
        return {
          type: "physical",
          name: xi(t, "product.name"),
          reference: xi(t, "product.sku") || xi(t, "product.slug"),
          quantity: t.quantity,
          unit_price: Math.round(100 * jf(t.price - t.discount_each)),
          total_amount: Math.round(100 * jf(t.price_total - t.discount_total)),
          tax_rate: 0,
          total_tax_amount: 0
        };
      }),
      r = xi(t, "tax_included_total"),
      n = 100 * jf(r);
    r && e.push({
      type: "sales_tax",
      name: "Taxes",
      quantity: 1,
      unit_price: n,
      total_amount: n,
      tax_rate: 0,
      total_tax_amount: 0
    });
    var o = xi(t, "shipping", {}),
      a = xi(t, "shipment_total", {}),
      i = 100 * jf(a);
    return o.price && e.push({
      type: "shipping_fee",
      name: o.service_name,
      quantity: 1,
      unit_price: i,
      total_amount: i,
      tax_rate: 0,
      total_tax_amount: 0
    }), e;
  }
  function mb(t, e) {
    return wb.apply(this, arguments);
  }
  function wb() {
    return (wb = s.default(f.default.mark(function t(e, r) {
      var n, o;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return n = "".concat(window.location.origin).concat(window.location.pathname, "?gateway=klarna_direct&sid={{session_id}}"), o = "".concat(n, "&authorization_token={{authorization_token}}"), t.abrupt("return", r({
                gateway: "klarna",
                intent: {
                  locale: e.display_locale || xi(e, "settings.locale") || "en-US",
                  purchase_country: xi(e, "billing.country") || xi(e, "shipping.country"),
                  purchase_currency: e.currency,
                  billing_address: gb(e, "billing"),
                  shipping_address: gb(e, "shipping"),
                  order_amount: Math.round(100 * xi(e, "grand_total", 0)),
                  order_lines: JSON.stringify(bb(e)),
                  merchant_urls: {
                    success: o,
                    back: n,
                    cancel: n,
                    error: n,
                    failure: n
                  }
                }
              }));
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function jb(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function xb(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? jb(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jb(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  var Ob = {},
    _b = {},
    Sb = {},
    Ab = null;
  function kb(t, e) {
    return Ab = e || Ab, {
      params: null,
      methodSettings: null,
      get: function get(e) {
        return t("get", "/payments", e);
      },
      methods: (l = s.default(f.default.mark(function e() {
        var r;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!this.methodSettings) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return", this.methodSettings);
              case 2:
                return e.next = 4, t("get", "/payment/methods");
              case 4:
                return r = e.sent, e.abrupt("return", this.methodSettings = r);
              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return l.apply(this, arguments);
      }),
      createElements: (c = s.default(f.default.mark(function e(r) {
        var n, o;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.params = r || {}, e.t0 = iv, e.next = 4, rg(t, Ab).get();
              case 4:
                if (e.t1 = e.sent, n = (0, e.t0)(e.t1)) {
                  e.next = 8;
                  break;
                }
                throw new Error("Cart not found");
              case 8:
                return e.t2 = iv, e.next = 11, cg(t, Ab).payments();
              case 11:
                if (e.t3 = e.sent, !(o = (0, e.t2)(e.t3)).error) {
                  e.next = 15;
                  break;
                }
                throw new Error(o.error);
              case 15:
                return e.next = 17, Eb(t, n, o, this.params);
              case 17:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (t) {
        return c.apply(this, arguments);
      }),
      tokenize: (u = s.default(f.default.mark(function e(r) {
        var n, o;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.t0 = iv, e.next = 3, rg(t, Ab).get();
              case 3:
                if (e.t1 = e.sent, n = (0, e.t0)(e.t1)) {
                  e.next = 7;
                  break;
                }
                throw new Error("Cart not found");
              case 7:
                return e.t2 = iv, e.next = 10, cg(t, Ab).payments();
              case 10:
                if (e.t3 = e.sent, !(o = (0, e.t2)(e.t3)).error) {
                  e.next = 14;
                  break;
                }
                throw new Error(o.error);
              case 14:
                return e.next = 16, Lb(t, r || this.params, o, n);
              case 16:
                return e.abrupt("return", e.sent);
              case 17:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (t) {
        return u.apply(this, arguments);
      }),
      handleRedirect: (i = s.default(f.default.mark(function e(r) {
        var n;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.t0 = iv, e.next = 3, rg(t, Ab).get();
              case 3:
                if (e.t1 = e.sent, n = (0, e.t0)(e.t1)) {
                  e.next = 7;
                  break;
                }
                throw new Error("Cart not found");
              case 7:
                return e.next = 9, Bb(t, r || this.params, n);
              case 9:
                return e.abrupt("return", e.sent);
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (t) {
        return i.apply(this, arguments);
      }),
      authenticate: (a = s.default(f.default.mark(function e(r) {
        var n, o;
        return f.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.get(r);
              case 2:
                if (n = e.sent) {
                  e.next = 5;
                  break;
                }
                throw new Error("Payment not found");
              case 5:
                return e.t0 = iv, e.next = 8, cg(t, Ab).payments();
              case 8:
                if (e.t1 = e.sent, !(o = (0, e.t0)(e.t1)).error) {
                  e.next = 12;
                  break;
                }
                throw new Error(o.error);
              case 12:
                return e.next = 14, Vb(t, n, o);
              case 14:
                return e.abrupt("return", e.sent);
              case 15:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (t) {
        return a.apply(this, arguments);
      }),
      createIntent: (o = s.default(f.default.mark(function t(e) {
        var r, n, o;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, gv("post", "/intent", e);
              case 2:
                if (!(r = t.sent).errors) {
                  t.next = 10;
                  break;
                }
                throw n = Object.keys(r.errors)[0], (o = new Error(r.errors[n].message || "Unknown error")).code = "vault_error", o.status = 402, o.param = n, o;
              case 10:
                return t.abrupt("return", r);
              case 11:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function (t) {
        return o.apply(this, arguments);
      }),
      updateIntent: (n = s.default(f.default.mark(function t(e) {
        var r, n, o;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, gv("put", "/intent", e);
              case 2:
                if (!(r = t.sent).errors) {
                  t.next = 10;
                  break;
                }
                throw n = Object.keys(r.errors)[0], (o = new Error(r.errors[n].message || "Unknown error")).code = "vault_error", o.status = 402, o.param = n, o;
              case 10:
                return t.abrupt("return", r);
              case 11:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function (t) {
        return n.apply(this, arguments);
      }),
      authorizeGateway: (r = s.default(f.default.mark(function t(e) {
        var r, n, o;
        return f.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, gv("post", "/authorization", e);
              case 2:
                if (!(r = t.sent).errors) {
                  t.next = 10;
                  break;
                }
                throw n = Object.keys(r.errors)[0], (o = new Error(r.errors[n].message || "Unknown error")).code = "vault_error", o.status = 402, o.param = n, o;
              case 10:
                return t.abrupt("return", r);
              case 11:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function (t) {
        return r.apply(this, arguments);
      })
    };
    var r, n, o, a, i, u, c, l;
  }
  function Eb(t, e, r, n) {
    return Pb.apply(this, arguments);
  }
  function Pb() {
    return Pb = s.default(f.default.mark(function t(e, r, n, o) {
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (!o.card) {
                t.next = 17;
                break;
              }
              if (n.card) {
                t.next = 5;
                break;
              }
              console.error("Payment element error: credit card payments are disabled. See Payment settings in the Swell dashboard for details."), t.next = 17;
              break;
            case 5:
              if ("braintree" !== n.card.gateway) {
                t.next = 11;
                break;
              }
              if (window.braintree) {
                t.next = 9;
                break;
              }
              return t.next = 9, Cb("braintree-web", "https://js.braintreegateway.com/web/3.57.0/js/client.min.js");
            case 9:
              t.next = 17;
              break;
            case 11:
              if ("stripe" !== n.card.gateway) {
                t.next = 17;
                break;
              }
              if (window.Stripe) {
                t.next = 15;
                break;
              }
              return t.next = 15, Cb("stripe-js", "https://js.stripe.com/v3/");
            case 15:
              return t.next = 17, Rb(e, n, o);
            case 17:
              if (!o.ideal) {
                t.next = 32;
                break;
              }
              if (n.card) {
                t.next = 22;
                break;
              }
              console.error("Payment element error: credit card payments are disabled. See Payment settings in the Swell dashboard for details."), t.next = 32;
              break;
            case 22:
              if (n.ideal) {
                t.next = 26;
                break;
              }
              console.error("Payment element error: iDEAL payments are disabled. See Payment settings in the Swell dashboard for details."), t.next = 32;
              break;
            case 26:
              if ("stripe" !== n.card.gateway) {
                t.next = 32;
                break;
              }
              if (window.Stripe) {
                t.next = 30;
                break;
              }
              return t.next = 30, Cb("stripe-js", "https://js.stripe.com/v3/");
            case 30:
              return t.next = 32, Rb(e, n, o);
            case 32:
              if (!o.paypal) {
                t.next = 56;
                break;
              }
              if (n.paypal) {
                t.next = 37;
                break;
              }
              console.error("Payment element error: PayPal payments are disabled. See Payment settings in the Swell dashboard for details."), t.next = 56;
              break;
            case 37:
              if (!n.card || "braintree" !== n.card.gateway || "braintree" !== n.paypal.gateway) {
                t.next = 51;
                break;
              }
              if (window.paypal) {
                t.next = 41;
                break;
              }
              return t.next = 41, Cb("paypal-sdk", "https://www.paypal.com/sdk/js?currency=".concat(r.currency, "&client-id=").concat(n.paypal.client_id, "&merchant-id=").concat(n.paypal.merchant_id, "&vault=true"));
            case 41:
              if (window.braintree) {
                t.next = 44;
                break;
              }
              return t.next = 44, Cb("braintree-web", "https://js.braintreegateway.com/web/3.57.0/js/client.min.js");
            case 44:
              if (!window.braintree || window.braintree.paypalCheckout) {
                t.next = 47;
                break;
              }
              return t.next = 47, Cb("braintree-web-paypal-checkout", "https://js.braintreegateway.com/web/3.57.0/js/paypal-checkout.min.js");
            case 47:
              return t.next = 49, Nb(e, r, n, o);
            case 49:
              t.next = 56;
              break;
            case 51:
              if (window.paypal) {
                t.next = 54;
                break;
              }
              return t.next = 54, Cb("paypal-sdk", "https://www.paypal.com/sdk/js?currency=".concat(r.currency, "&client-id=").concat(n.paypal.client_id, "&merchant-id=").concat(n.paypal.merchant_id, "&intent=authorize&commit=false"));
            case 54:
              return t.next = 56, Tb(e, r, n, o);
            case 56:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Pb.apply(this, arguments);
  }
  var Cb = function () {
    var t = s.default(f.default.mark(function t(e, r) {
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return Ob[e] = Ob[e] || new Promise(function (t) {
                var n = document.createElement("script");
                n.id = e, n.src = r, n.async = !0, n.type = "text/javascript", n.addEventListener("load", function () {
                  t(), Ob[e] = null;
                }, {
                  once: !0
                }), document.head.appendChild(n);
              }), t.abrupt("return", Ob[e]);
            case 2:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function (e, r) {
      return t.apply(this, arguments);
    };
  }();
  function Rb(t, e, r) {
    return Ib.apply(this, arguments);
  }
  function Ib() {
    return (Ib = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i, u;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              o = r.card.publishable_key, a = window.Stripe(o), i = a.elements(n.config), u = function u(t) {
                var e = xi(n, "card[".concat(t, "]")) || n.card || n.ideal,
                  r = e.options || {},
                  o = i.create(t, r);
                o.mount(e.elementId || "#".concat(t, "-element")), e.onChange && o.on("change", e.onChange), e.onReady && o.on("ready", e.onReady), e.onFocus && o.on("focus", e.onFocus), e.onBlur && o.on("blur", e.onBlur), e.onEscape && o.on("escape", e.onEscape), e.onClick && o.on("click", e.onClick), "card" !== t && "cardNumber" !== t && "idealBank" !== t || (_b.stripe = o);
              }, Sb.stripe = a, n.ideal ? u("idealBank") : n.card.separateElements ? (u("cardNumber"), u("cardExpiry"), u("cardCvc")) : u("card");
            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  function Ub(t, e, r) {
    return Db.apply(this, arguments);
  }
  function Db() {
    return Db = s.default(f.default.mark(function t(e, r, n) {
      var o;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (e) {
                t.next = 2;
                break;
              }
              return t.abrupt("return", !1);
            case 2:
              return t.next = 4, rg(r, n).get();
            case 4:
              if (o = t.sent, xi(o, "account.email")) {
                t.next = 10;
                break;
              }
              return t.abrupt("return", !0);
            case 10:
              return t.abrupt("return", !1);
            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Db.apply(this, arguments);
  }
  function Tb(t, e, r, n) {
    return Mb.apply(this, arguments);
  }
  function Mb() {
    return Mb = s.default(f.default.mark(function t(e, r, n, o) {
      var a, i, u, c, l, p, d, h, y, v;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (a = window.paypal, i = o.paypal, u = (i = void 0 === i ? {} : i).locale, c = i.style, l = i.elementId, p = r.capture_total, d = r.currency, h = r.guest, y = function y(t) {
                var e = xi(o, "paypal.onError");
                if (yv(e)) return e(t);
                throw new Error(t.message);
              }, v = function v() {
                var t = xi(o, "paypal.onSuccess");
                return yv(t) && t();
              }, p > 0) {
                t.next = 9;
                break;
              }
              throw new Error("Invalid PayPal button amount. Value should be greater than zero.");
            case 9:
              a.Buttons({
                locale: u || "en_US",
                style: c || {
                  layout: "horizontal",
                  height: 45,
                  color: "gold",
                  shape: "rect",
                  label: "paypal",
                  tagline: !1
                },
                createOrder: function createOrder(t, e) {
                  return e.order.create({
                    intent: "AUTHORIZE",
                    purchase_units: [{
                      amount: {
                        value: +p.toFixed(2),
                        currency_code: d
                      }
                    }]
                  });
                },
                onApprove: function onApprove(t, r) {
                  return r.order.get().then(function () {
                    var t = s.default(f.default.mark(function t(r) {
                      var n, o, a, i;
                      return f.default.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return n = r.id, o = r.payer, a = xi(r, "purchase_units[0].shipping"), t.next = 5, Ub(h, e, Ab);
                            case 5:
                              return i = t.sent, t.abrupt("return", rg(e).update(xb(xb({}, i && {
                                account: {
                                  email: o.email_address
                                }
                              }), {}, {
                                billing: {
                                  method: "paypal",
                                  paypal: {
                                    order_id: n
                                  }
                                },
                                shipping: {
                                  name: a.name.full_name,
                                  address1: a.address.address_line_1,
                                  address2: a.address.address_line_2,
                                  state: a.address.admin_area_1,
                                  city: a.address.admin_area_2,
                                  zip: a.address.postal_code,
                                  country: a.address.country_code
                                }
                              })));
                            case 7:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }()).then(v).catch(y);
                }
              }, y).render(l || "#paypal-button");
            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Mb.apply(this, arguments);
  }
  function Nb(t, e, r, n) {
    return zb.apply(this, arguments);
  }
  function zb() {
    return zb = s.default(f.default.mark(function t(e, r, n, o) {
      var a, i, u;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, gv("post", "/authorization", {
                gateway: "braintree"
              });
            case 2:
              if (!(a = t.sent).error) {
                t.next = 5;
                break;
              }
              throw new Error(a.error);
            case 5:
              i = window.braintree, u = window.paypal, i.client.create({
                authorization: a
              }).then(function (t) {
                return i.paypalCheckout.create({
                  client: t
                });
              }).then(function (t) {
                return u.Buttons({
                  style: o.paypal.style || {},
                  createBillingAgreement: function createBillingAgreement() {
                    return t.createPayment({
                      flow: "vault",
                      currency: r.currency,
                      amount: r.grand_total
                    });
                  },
                  onApprove: function onApprove(r, n) {
                    return t.tokenizePayment(r).then(function (t) {
                      var r = t.nonce;
                      return rg(e, Ab).update({
                        billing: {
                          paypal: {
                            nonce: r
                          }
                        }
                      });
                    }).then(function () {
                      return yv(o.paypal.onSuccess) && o.paypal.onSuccess(r, n);
                    }).catch(yv(o.paypal.onError) ? o.paypal.onError : function (t) {
                      return console.error("PayPal error", t);
                    });
                  },
                  onCancel: yv(o.paypal.onCancel) ? function () {
                    return o.paypal.onCancel();
                  } : function () {
                    return console.log("PayPal payment cancelled");
                  },
                  onError: yv(o.paypal.onError) ? function (t) {
                    return o.paypal.onError(t);
                  } : function (t) {
                    return console.error("PayPal error", t);
                  }
                }).render(o.paypal.elementId || "#paypal-button");
              }).catch(yv(o.paypal.onError) ? o.paypal.onError : function (t) {
                return console.error("PayPal error", t);
              });
            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), zb.apply(this, arguments);
  }
  function Lb(t, e, r, n) {
    return Fb.apply(this, arguments);
  }
  function Fb() {
    return Fb = s.default(f.default.mark(function t(e, r, n, o) {
      var a, i, u, c, s, l, p, d, h, y, v, g, b, m, w, j, x, O, _, S, A, k, E, P, C, R, I, U, D, T, M, N, z;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (a = o.capture_total, i = o.auth_total, u = function u(t) {
                var e = xi(r, "card.onError") || xi(r, "ideal.onError") || xi(r, "klarna.onError") || xi(r, "bancontact.onError") || xi(r, "paysafecard.onError");
                if (yv(e)) return e(t);
                throw new Error(t.message);
              }, c = function c(t) {
                var e = xi(r, "card.onSuccess") || xi(r, "ideal.onSuccess");
                if (yv(e)) return e(t);
              }, r) {
                t.next = 5;
                break;
              }
              return t.abrupt("return", u({
                message: "Tokenization parameters not passed"
              }));
            case 5:
              if (!r.card || !n.card) {
                t.next = 56;
                break;
              }
              if ("stripe" !== n.card.gateway || !_b.stripe || !Sb.stripe) {
                t.next = 41;
                break;
              }
              return s = Sb.stripe, t.next = 10, Hg(s, _b.stripe, o);
            case 10:
              if (!(l = t.sent).error) {
                t.next = 15;
                break;
              }
              return t.abrupt("return", u(l.error));
            case 15:
              if (!(a < 1)) {
                t.next = 17;
                break;
              }
              return t.abrupt("return", rg(e, Ab).update({
                billing: {
                  method: "card",
                  card: l
                }
              }).then(c).catch(u));
            case 17:
              return p = pg(xi(o, "currency", "usd")), d = ob(p, a + i), h = xi(o, "account.stripe_customer"), t.t0 = iv, t.next = 23, kb(e).createIntent({
                gateway: "stripe",
                intent: xb({
                  payment_method: l.token,
                  amount: d,
                  currency: p,
                  capture_method: "manual",
                  setup_future_usage: "off_session"
                }, h ? {
                  customer: h
                } : {})
              }).catch(u);
            case 23:
              if (t.t1 = t.sent, !(y = (0, t.t0)(t.t1)) || "requires_confirmation" !== y.status) {
                t.next = 39;
                break;
              }
              return t.next = 28, s.confirmCardPayment(y.client_secret);
            case 28:
              if (v = t.sent, g = v.paymentIntent, !(b = v.error)) {
                t.next = 35;
                break;
              }
              t.t2 = u(b), t.next = 38;
              break;
            case 35:
              return t.next = 37, rg(e, Ab).update({
                billing: {
                  method: "card",
                  card: l,
                  intent: {
                    stripe: xb({
                      id: g.id
                    }, !!i && {
                      auth_amount: i
                    })
                  }
                }
              }).then(c).catch(u);
            case 37:
              t.t2 = t.sent;
            case 38:
              return t.abrupt("return", t.t2);
            case 39:
              t.next = 54;
              break;
            case 41:
              if ("quickpay" !== n.card.gateway) {
                t.next = 54;
                break;
              }
              return t.next = 44, fb(o, kb(e).createIntent).catch(u);
            case 44:
              if (m = t.sent) {
                t.next = 49;
                break;
              }
              return t.abrupt("return");
            case 49:
              if (!m.error) {
                t.next = 51;
                break;
              }
              return t.abrupt("return", u(m.error));
            case 51:
              return t.next = 53, rg(e, Ab).update({
                billing: {
                  method: "card",
                  intent: {
                    quickpay: {
                      id: m
                    }
                  }
                }
              });
            case 53:
              ib(kb(e).authorizeGateway).catch(u);
            case 54:
              t.next = 134;
              break;
            case 56:
              if (!r.ideal || !n.ideal) {
                t.next = 83;
                break;
              }
              if (!(n.card && "stripe" === n.card.gateway && _b.stripe && Sb.stripe)) {
                t.next = 81;
                break;
              }
              return t.next = 60, Xg(Sb.stripe, _b.stripe, o.billing);
            case 60:
              if (w = t.sent, j = w.error, x = w.paymentMethod, !j) {
                t.next = 65;
                break;
              }
              return t.abrupt("return", u(j));
            case 65:
              return O = pg(xi(o, "currency", "eur")), _ = ob(O, a), t.t3 = iv, t.next = 70, kb(e).createIntent({
                gateway: "stripe",
                intent: {
                  payment_method: x.id,
                  amount: _,
                  currency: O,
                  payment_method_types: "ideal",
                  confirmation_method: "manual",
                  confirm: !0,
                  return_url: window.location.href
                }
              }).catch(u);
            case 70:
              if (t.t4 = t.sent, !(S = (0, t.t3)(t.t4))) {
                t.next = 81;
                break;
              }
              return t.next = 75, rg(e, Ab).update({
                billing: {
                  method: "ideal",
                  ideal: {
                    token: x.id
                  },
                  intent: {
                    stripe: {
                      id: S.id
                    }
                  }
                }
              }).catch(u);
            case 75:
              if (t.t5 = "requires_action" === S.status || "requires_source_action" === S.status, !t.t5) {
                t.next = 80;
                break;
              }
              return t.next = 79, Sb.stripe.handleCardAction(S.client_secret);
            case 79:
              t.t5 = t.sent;
            case 80:
              return t.abrupt("return", t.t5);
            case 81:
              t.next = 134;
              break;
            case 83:
              if (!r.klarna || !n.klarna) {
                t.next = 110;
                break;
              }
              if ("klarna" !== n.klarna.gateway) {
                t.next = 91;
                break;
              }
              return t.next = 87, mb(o, kb(e).createIntent).catch(u);
            case 87:
              return A = t.sent, t.abrupt("return", A && window.location.replace(A.redirect_url));
            case 91:
              if (!n.card || "stripe" !== n.card.gateway) {
                t.next = 108;
                break;
              }
              if (window.Stripe) {
                t.next = 95;
                break;
              }
              return t.next = 95, Cb("stripe-js", "https://js.stripe.com/v3/");
            case 95:
              return k = n.card.publishable_key, E = window.Stripe(k), t.t6 = iv, t.next = 100, cg(e, Ab).get();
            case 100:
              return t.t7 = t.sent, P = (0, t.t6)(t.t7), t.next = 104, tb(E, xb(xb({}, o), {}, {
                settings: P.store
              }));
            case 104:
              return C = t.sent, R = C.error, I = C.source, t.abrupt("return", R ? u(R) : rg(e, Ab).update({
                billing: {
                  method: "klarna"
                }
              }).then(function () {
                return window.location.replace(I.redirect.url);
              }).catch(u));
            case 108:
              t.next = 134;
              break;
            case 110:
              if (!r.bancontact || !n.bancontact) {
                t.next = 125;
                break;
              }
              if (!n.card || "stripe" !== n.card.gateway) {
                t.next = 123;
                break;
              }
              if (window.Stripe) {
                t.next = 115;
                break;
              }
              return t.next = 115, Cb("stripe-js", "https://js.stripe.com/v3/");
            case 115:
              return U = n.card.publishable_key, D = window.Stripe(U), t.next = 119, rb(D, o);
            case 119:
              return T = t.sent, M = T.error, N = T.source, t.abrupt("return", M ? u(M) : rg(e, Ab).update({
                billing: {
                  method: "bancontact"
                }
              }).then(function () {
                return window.location.replace(N.redirect.url);
              }).catch(u));
            case 123:
              t.next = 134;
              break;
            case 125:
              if (!r.paysafecard || !n.paysafecard) {
                t.next = 134;
                break;
              }
              return t.next = 128, pb(o, kb(e).createIntent).catch(u);
            case 128:
              if (z = t.sent) {
                t.next = 131;
                break;
              }
              return t.abrupt("return");
            case 131:
              return t.next = 133, rg(e, Ab).update({
                billing: {
                  method: "paysafecard",
                  intent: {
                    paysafecard: {
                      id: z.id
                    }
                  }
                }
              });
            case 133:
              return t.abrupt("return", window.location.replace(z.redirect.auth_url));
            case 134:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Fb.apply(this, arguments);
  }
  function Bb(t, e, r) {
    return qb.apply(this, arguments);
  }
  function qb() {
    return qb = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i, u, c;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (o = function o(t) {
                var e = xi(r, "card.onError") || xi(r, "paysafecard.onError") || xi(r, "klarna.onError");
                if (yv(e)) return e(t);
                throw new Error(t.message);
              }, a = function a(t) {
                var e = xi(r, "card.onSuccess") || xi(r, "paysafecard.onSuccess") || xi(r, "klarna.onSuccess");
                if (yv(e)) return e(t);
              }, i = _v(window.location), Sv(), "quickpay" !== (u = i.gateway)) {
                t.next = 11;
                break;
              }
              return t.next = 8, $b(e, n, r, i);
            case 8:
              c = t.sent, t.next = 21;
              break;
            case 11:
              if ("paysafecard" !== u) {
                t.next = 17;
                break;
              }
              return t.next = 14, Gb(e, n, r, i);
            case 14:
              c = t.sent, t.next = 21;
              break;
            case 17:
              if ("klarna_direct" !== u) {
                t.next = 21;
                break;
              }
              return t.next = 20, Jb(e, n, r, i);
            case 20:
              c = t.sent;
            case 21:
              if (c) {
                t.next = 25;
                break;
              }
              return t.abrupt("return");
            case 25:
              if (!c.error) {
                t.next = 29;
                break;
              }
              return t.abrupt("return", o(c.error));
            case 29:
              return t.abrupt("return", a(c));
            case 30:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), qb.apply(this, arguments);
  }
  function $b(t, e, r, n) {
    return Yb.apply(this, arguments);
  }
  function Yb() {
    return Yb = s.default(f.default.mark(function t(e, r, n, o) {
      var a, i, u;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              a = o.redirect_status, i = o.card_id, t.t0 = a, t.next = "succeeded" === t.t0 ? 4 : "canceled" === t.t0 ? 18 : 19;
              break;
            case 4:
              return t.next = 6, cb(i, kb(e).authorizeGateway);
            case 6:
              if (u = t.sent) {
                t.next = 11;
                break;
              }
              return t.abrupt("return");
            case 11:
              if (!u.error) {
                t.next = 15;
                break;
              }
              return t.abrupt("return", u);
            case 15:
              return t.next = 17, rg(e, Ab).update({
                billing: {
                  method: "card",
                  card: u
                }
              });
            case 17:
              return t.abrupt("return", {
                success: !0
              });
            case 18:
              return t.abrupt("return", {
                error: {
                  message: "We are unable to authenticate your payment method. Please choose a different payment method and try again."
                }
              });
            case 19:
              return t.abrupt("return", {
                error: {
                  message: "Unknown redirect status: ".concat(a, ".")
                }
              });
            case 20:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Yb.apply(this, arguments);
  }
  function Gb(t, e) {
    return Wb.apply(this, arguments);
  }
  function Wb() {
    return Wb = s.default(f.default.mark(function t(e, r) {
      var n, o;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (n = xi(r, "billing.intent.paysafecard.id")) {
                t.next = 3;
                break;
              }
              return t.abrupt("return", {
                error: {
                  message: "Paysafecard payment ID not defined."
                }
              });
            case 3:
              return t.next = 5, kb(e).updateIntent({
                gateway: "paysafecard",
                intent: {
                  payment_id: n
                }
              });
            case 5:
              if (o = t.sent) {
                t.next = 8;
                break;
              }
              return t.abrupt("return");
            case 8:
              t.t0 = o.status, t.next = "AUTHORIZED" === t.t0 ? 11 : "CANCELED_CUSTOMER" === t.t0 ? 12 : 13;
              break;
            case 11:
              return t.abrupt("return", {
                success: !0
              });
            case 12:
              return t.abrupt("return", {
                error: {
                  message: "We are unable to authenticate your payment method. Please choose a different payment method and try again."
                }
              });
            case 13:
              return t.abrupt("return", {
                error: {
                  message: "Unknown redirect status: ".concat(o.status, ".")
                }
              });
            case 14:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Wb.apply(this, arguments);
  }
  function Jb(t, e, r, n) {
    return Zb.apply(this, arguments);
  }
  function Zb() {
    return Zb = s.default(f.default.mark(function t(e, r, n, o) {
      var a;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (a = o.authorization_token) {
                t.next = 3;
                break;
              }
              return t.abrupt("return", {
                error: {
                  message: "We are unable to authenticate your payment method. Please choose a different payment method and try again."
                }
              });
            case 3:
              return t.next = 5, rg(e, Ab).update({
                billing: {
                  method: "klarna",
                  klarna: {
                    token: a
                  }
                }
              });
            case 5:
              return t.abrupt("return", {
                success: !0
              });
            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Zb.apply(this, arguments);
  }
  function Vb(t, e, r) {
    return Hb.apply(this, arguments);
  }
  function Hb() {
    return Hb = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (o = r.method, a = r.gateway, "card" !== o) {
                t.next = 12;
                break;
              }
              if (i = n.card) {
                t.next = 7;
                break;
              }
              console.error("Authenticate error: credit card payments are disabled. See Payment settings in the Swell dashboard for details."), t.next = 12;
              break;
            case 7:
              if ("stripe" !== a || "stripe" !== i.gateway) {
                t.next = 12;
                break;
              }
              if (window.Stripe) {
                t.next = 11;
                break;
              }
              return t.next = 11, Cb("stripe-js", "https://js.stripe.com/v3/");
            case 11:
              return t.abrupt("return", Qb(e, r, n));
            case 12:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Hb.apply(this, arguments);
  }
  function Qb(t, e, r) {
    return Xb.apply(this, arguments);
  }
  function Xb() {
    return Xb = s.default(f.default.mark(function t(e, r, n) {
      var o, a, i, u, c, s, l;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return o = r.transaction_id, a = r.card, i = (a = void 0 === a ? {} : a).token, u = n.card.publishable_key, t.next = 6, kb(e, Ab).updateIntent({
                gateway: "stripe",
                intent: {
                  id: o,
                  payment_method: i
                }
              }).catch(function (t) {
                return {
                  error: t
                };
              });
            case 6:
              if (!(c = t.sent).error) {
                t.next = 9;
                break;
              }
              return t.abrupt("return", c);
            case 9:
              return s = window.Stripe(u), t.next = 12, s.confirmCardPayment(c.client_secret);
            case 12:
              return l = t.sent, t.abrupt("return", l.error ? {
                error: {
                  message: l.error.message,
                  code: l.error.code
                }
              } : {
                status: l.status
              });
            case 14:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), Xb.apply(this, arguments);
  }
  var Kb = {};
  function tm(t) {
    return t && t.default || t;
  }
  function em(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function rm(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? em(Object(r), !0).forEach(function (e) {
        c.default(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : em(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  module.exports = tt.fetch = tt.fetch || (void 0 === je ? tm(require("unfetch")) : function (t, e) {
    return tm(require("node-fetch"))(String(t).replace(/^\/\//g, "https://"), e);
  });
  var nm = {
      store: null,
      key: null,
      url: null,
      useCamelCase: null,
      previewContent: null
    },
    om = {
      options: nm,
      request: am,
      init: function init(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        nm.key = e, nm.store = t, nm.url = r.url ? lv(r.url) : "https://".concat(t, ".swell.store"), nm.vaultUrl = r.vaultUrl ? lv(r.vaultUrl) : "https://vault.schema.io", nm.timeout = r.timeout && parseInt(r.timeout, 10) || 2e4, nm.useCamelCase = r.useCamelCase || !1, nm.previewContent = r.previewContent || !1, nm.session = r.session, nm.locale = r.locale, nm.currency = r.currency, nm.api = om, ev(nm);
      },
      auth: function auth() {
        return this.init.apply(this, arguments);
      },
      get: function get(t, e) {
        return am("get", t, e);
      },
      put: function put(t, e) {
        return am("put", t, e);
      },
      post: function post(t, e) {
        return am("post", t, e);
      },
      delete: function _delete(t, e) {
        return am("delete", t, e);
      },
      cache: Fv,
      card: kv,
      cart: rg(am, nm),
      account: function (t) {
        return {
          state: null,
          requestStateChange: (e = s.default(f.default.mark(function e(r, n, o, a) {
            var i;
            return f.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, t(r, n, o, a);
                  case 2:
                    if (!(i = e.sent) || !i.errors) {
                      e.next = 5;
                      break;
                    }
                    return e.abrupt("return", i);
                  case 5:
                    return e.abrupt("return", this.state = i);
                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (t, r, n, o) {
            return e.apply(this, arguments);
          }),
          get: function get(t) {
            return this.requestStateChange("get", "/account", t);
          },
          create: function create(t) {
            return this.requestStateChange("post", "/account", t);
          },
          update: function update(t) {
            return this.requestStateChange("put", "/account", t);
          },
          login: function login(t, e) {
            return e && e.password_token ? this.requestStateChange("post", "/account/login", {
              email: t,
              password_token: e.password_token
            }) : this.requestStateChange("post", "/account/login", {
              email: t,
              password: e
            });
          },
          logout: function logout() {
            return this.state = null, t("post", "/account/logout");
          },
          recover: function recover(e) {
            return t("post", "/account/recover", e);
          },
          listAddresses: function listAddresses(e) {
            return t("get", "/account/addresses", e);
          },
          createAddress: function createAddress(e) {
            return t("post", "/account/addresses", e);
          },
          updateAddress: function updateAddress(e, r) {
            return t("put", "/account/addresses/".concat(e), r);
          },
          deleteAddress: function deleteAddress(e) {
            return t("delete", "/account/addresses/".concat(e));
          },
          listCards: function listCards(e) {
            return t("get", "/account/cards", e);
          },
          createCard: function createCard(e) {
            return t("post", "/account/cards", e);
          },
          updateCard: function updateCard(e, r) {
            return t("put", "/account/cards/".concat(e), r);
          },
          deleteCard: function deleteCard(e) {
            return t("delete", "/account/cards/".concat(e));
          },
          listOrders: function listOrders(e) {
            return t("get", "/account/orders", e);
          },
          getOrder: function getOrder(e) {
            return t("get", "/account/orders/".concat(e));
          },
          getAddresses: function getAddresses(e) {
            return t("get", "/account/addresses", e);
          },
          getCards: function getCards(e) {
            return t("get", "/account/cards", e);
          },
          getOrders: function getOrders(e) {
            return t("get", "/account/orders", e);
          }
        };
        var e;
      }(am),
      products: function (t, e) {
        zv = e;
        var r = vv(t, "/products", ["list", "get"]),
          n = r.get;
        return {
          get: function get(t) {
            for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
              r[o - 1] = arguments[o];
            }
            return Fv.getFetch("products", t, function () {
              return n.apply(void 0, [t].concat(r));
            });
          },
          list: r.list,
          variation: Jv,
          categories: Qv,
          attributes: Xv,
          priceRange: Kv,
          filters: Hv,
          filterableAttributeFilters: function filterableAttributeFilters(e, r) {
            return function (t, e, r) {
              return Vv.apply(this, arguments);
            }(t, e, r);
          }
        };
      }(am, nm),
      categories: function (t) {
        var e = vv(t, "/categories", ["list", "get"]),
          r = e.get;
        return {
          get: function get(t) {
            for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
              n[o - 1] = arguments[o];
            }
            return Fv.getFetch("categories", t, function () {
              return r.apply(void 0, [t].concat(n));
            });
          },
          list: e.list
        };
      }(am),
      attributes: Bv(am),
      subscriptions: function (t) {
        var e = vv(t, "/subscriptions", ["list", "get"]),
          r = e.get;
        return {
          get: function get(t) {
            for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
              n[o - 1] = arguments[o];
            }
            return Fv.getFetch("subscriptions", t, function () {
              return r.apply(void 0, [t].concat(n));
            });
          },
          list: e.list,
          getCleanData: function getCleanData(t) {
            return t && t.options && (t.options = Wv(t.options)), t.items && t.items.map && (t.items = t.items.map(function (t) {
              return t.options && (t.options = Wv(t.options)), t;
            })), t;
          },
          create: function create(e) {
            return t("post", "/subscriptions", this.getCleanData(e));
          },
          update: function update(e, r) {
            return t("put", "/subscriptions/".concat(e), this.getCleanData(r));
          },
          addItem: function addItem(e, r) {
            return t("post", "/subscriptions/".concat(e, "/items"), this.getCleanData(r));
          },
          setItems: function setItems(e, r) {
            return r && r.map && (r = r.map(this.getCleanData)), t("put", "/subscriptions/".concat(e, "/items"), r);
          },
          updateItem: function updateItem(e, r, n) {
            return t("put", "/subscriptions/".concat(e, "/items/").concat(r), this.getCleanData(n));
          },
          removeItem: function removeItem(e, r) {
            return t("delete", "/subscriptions/".concat(e, "/items/").concat(r));
          }
        };
      }(am),
      content: function (t, e) {
        return {
          get: function get(r, n, o) {
            return Fv.getFetch("content_".concat(r), n, function () {
              return t("get", "/content/".concat(r), n, function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var r = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? ng(Object(r), !0).forEach(function (e) {
                    c.default(t, e, r[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ng(Object(r)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                  });
                }
                return t;
              }({
                $preview: e.previewContent
              }, o || {}));
            });
          },
          list: function list(e, r) {
            return t("get", "/content/".concat(e), void 0, r);
          }
        };
      }(am, nm),
      settings: cg(am, nm),
      payment: kb(am, nm),
      locale: function (t, e) {
        return {
          code: null,
          state: null,
          list: function list() {
            return e.api.settings.get("store.locales", []);
          },
          select: (r = s.default(f.default.mark(function r(n) {
            return f.default.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return this.set(n), Iv("swell-locale", n), e.api.settings.locale = n, r.next = 5, t("put", "/session", {
                      locale: n
                    });
                  case 5:
                    return r.abrupt("return", r.sent);
                  case 6:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          })), function (t) {
            return r.apply(this, arguments);
          }),
          selected: function selected() {
            if (this.code) return this.code;
            var t = e.api.settings.getStoreLocale(),
              r = Rv("swell-locale");
            return e.api.settings.locale = r || t, r || t;
          },
          get: function get() {
            return this.code || (this.code = this.selected()), this.state || (this.state = this.set(this.code)), this.state;
          },
          set: function set(t) {
            return this.code = t, this.state = Cf(this.list(), {
              code: t
            }) || {}, this.state;
          }
        };
        var r;
      }(am, nm),
      currency: function (t, e) {
        return {
          code: null,
          state: null,
          locale: null,
          list: function list() {
            return e.api.settings.get("store.currencies", []);
          },
          select: (r = s.default(f.default.mark(function e(r) {
            return f.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return this.set(r), e.abrupt("return", t("put", "/session", {
                      currency: r
                    }));
                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (t) {
            return r.apply(this, arguments);
          }),
          selected: function selected() {
            return this.code || this.set(Rv("swell-currency") || e.api.settings.get("store.currency")), this.code;
          },
          get: function get() {
            return this.code || (this.code = this.selected()), this.state || (this.state = this.set(this.code)), this.state;
          },
          set: function set() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "USD";
            return this.code = t, this.state = Cf(this.list(), {
              code: t
            }) || {
              code: t
            }, this.locale = String(e.api.settings.get("store.locale", "object" === ("undefined" == typeof navigator ? "undefined" : l.default(navigator)) ? navigator.language : "en-US")), Iv("swell-currency", t), this.state;
          },
          format: function format(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.get();
            if (e.code && e.code !== r.code) {
              var n = this.list();
              r = Cf(n, {
                code: e.code
              }) || {
                code: e.code
              };
            }
            var o = r,
              a = o.code,
              i = void 0 === a ? "USD" : a,
              u = o.type,
              c = o.decimals,
              s = o.rate,
              f = e.code || i,
              l = e.rate || s,
              p = e.locale || this.locale,
              d = "number" == typeof e.decimals ? e.decimals : c,
              h = e.convert,
              y = void 0 === h || h,
              v = t;
            y && ("display" === u || e.rate) && "number" == typeof v && "number" == typeof l && (v = this.applyRounding(t * l, r));
            var g = this.formatter({
              code: f,
              locale: p,
              decimals: d
            });
            try {
              if ("number" == typeof v) return g.format(v);
              var b = xi(g.formatToParts(0), "0.value", "$");
              return b !== f ? b : "";
            } catch (t) {
              console.warn(t);
            }
            return String(t);
          },
          formatter: function formatter(t) {
            var e = t.code,
              r = t.locale,
              n = t.decimals,
              o = [e, r = String(r || "").replace("_", "-"), n].join("|");
            if (Kb[o]) return Kb[o];
            var a = [];
            r && a.push(r), a.push("en-US");
            var i = "number" == typeof n ? n : void 0,
              u = {
                style: "currency",
                currency: e,
                currencyDisplay: "symbol",
                minimumFractionDigits: i,
                maximumFractionDigits: i
              };
            try {
              try {
                Kb[o] = new Intl.NumberFormat(a, u);
              } catch (t) {
                t.message.indexOf("Invalid language tag") >= 0 && (Kb[o] = new Intl.NumberFormat("en-US", u));
              }
            } catch (t) {
              console.warn(t);
            }
            return Kb[o];
          },
          applyRounding: function applyRounding(t, e) {
            if (!e || !e.round) return t;
            var r = e.decimals,
              n = "fraction" === e.round_interval && e.round_fraction || 0,
              o = ~~t,
              a = this.round(t, r);
            if (a === n) return o + a;
            var i = this.round(a - n, 1);
            if ("down" === ("nearest" === e.round ? i > 0 ? i >= .5 ? "up" : "down" : i <= -.5 ? "down" : "up" : e.round)) o = o + n - (a > n ? 0 : 1);else o = o + n + (a > n ? 1 : 0);
            return this.round(o, r);
          },
          round: Nf
        };
        var r;
      }(am, nm)
    };
  function am(t, e) {
    return im.apply(this, arguments);
  }
  function im() {
    return im = s.default(f.default.mark(function t(e, r) {
      var n,
        o,
        a,
        i,
        c,
        s,
        l,
        p,
        d,
        h,
        y,
        v,
        g,
        b,
        m,
        w,
        j,
        x,
        O,
        _,
        S,
        A,
        k = arguments;
      return f.default.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return n = k.length > 2 && void 0 !== k[2] ? k[2] : void 0, o = k.length > 3 && void 0 !== k[3] ? k[3] : void 0, a = k.length > 4 && void 0 !== k[4] ? k[4] : void 0, i = rm(rm({}, nm), a), c = i.session || Rv("swell-session"), s = i.locale || Rv("swell-locale"), l = i.currency || Rv("swell-currency"), p = "".concat(i.url).concat(i.base || "", "/api"), d = String(e).toLowerCase(), h = r, y = n, void 0 === o && "string" != typeof n || (h = [lv(r), fv(n)].join("/"), y = o), h = i.fullUrl || "".concat(p, "/").concat(sv(h)), y = i.useCamelCase ? iv(y) : y, "get" === d ? (b = h.split("?"), m = u.default(b, 2), h = m[0], g = m[1], w = [g, pv(y)].join("&").replace(/^&/, ""), h = "".concat(h).concat(w ? "?".concat(w) : "")) : v = JSON.stringify(y), j = {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Basic ".concat(Ov(String(i.key)))
              }, c && (j["X-Session"] = c), s && (j["X-Locale"] = s), l && (j["X-Currency"] = l), t.next = 21, fetch(h, {
                method: d,
                headers: j,
                body: v,
                credentials: "include",
                mode: "cors"
              });
            case 21:
              return x = t.sent, "string" == typeof (O = x.headers.get("X-Session")) && c !== O && Iv("swell-session", O), t.next = 26, x.json();
            case 26:
              if (!(_ = t.sent) || !_.error) {
                t.next = 35;
                break;
              }
              throw (S = new Error(_.error.message)).status = x.status, S.code = _.error.code, S.param = _.error.param, S;
            case 35:
              if (x.ok) {
                t.next = 39;
                break;
              }
              throw (A = new Error("A connection error occurred while making the request")).code = "connection_error", A;
            case 39:
              return t.abrupt("return", nm.useCamelCase ? ov(_) : _);
            case 40:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), im.apply(this, arguments);
  }
  return "undefined" != typeof window && (window.swell = {
    version: "@VERSION@"
  }), om;
});